import localeAntd from "ant-design-vue/lib/locale-provider/en_US";

const messages = {
  all: {
    selectionnerEleves: "Select students",
    printByLevel: "Print by grades",
    printLoginCredentials: "Print login credentials",
    understood: "I understood",
    automatique: "Automatic",
    manuel: "Manual",
    okay: "Okay",
    table: "Table",
    add: "Add",
    select: "Select",
    or: "OR",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    cloneByType: "Clone by type",
    apply: "Apply",
    source: "Source",
    targets: "Target(s)",
    selectTypes: "Select types",
    selectLevels: "Select grades",
    selectTrimesters: "Select terms",
    fillFilters: "Please fill all filters",
    sureToCancelAlert: "Are you sure to cancel?",
    sureToDelete: "Are you sure to delete?",
    startDate: "Start date",
    endDate: "End date",
    requiredStartDate: "Start date is required field",
    requiredEndDate: "End date is required field",
    requiredName: "Name is required field",
    requiredLevel: "Grade is required field",
    enterInformationBelow: "Enter the information in the fields below",
    oui: "Yes",
    non: "No",
    none: "None",
    and: "And",
    filterBy: "Filter by",
    filterByAddedDate: "Filter by added date",
    filtresEtRecherche: "Filters and Search",
    sureTo: "Are you sure?",
    unsavedchanges: "Unsaved changes!",
    unsavedchangesContent:
      "Do you really want to leave? You have unsaved changes!",
    unsavedChangesInfo:
      "You have unsaved changes. Please save so your modifications can take effect.",
    unsavedChangesLeaveConfirm:
      "You have unsaved changes. If you leave, you will lose these changes. Are you sure you want to leave?",
    savedChanges: "The modifications have been saved successfully",
    typeNeeded: "Allowed file types: png, jpg, jpeg.",
    packAcces:
      "You cannot access this feature with your current subscription plan.",
    attention: "Attention",
    nonGroupAssigned: "Unassigned",
    pagination: {
      showTotal: "Showing {start}-{end} of {total} items",
      pageSize: "Items per page",
      jumpTo: "Go to",
      page: "Page",
      total: "Total",
      items: "items",
    },
    date: "Date",
    switchMode: "Switch Dark / Light Theme",
    loadingText: "Loading...",
    selectDate: "Select date",
    noData: "No data",
    tpiAll: "All",
    pending: "Pending",
    dateRangeToday: "Today",
    dateRangeThisWeek: "This Week",
    dateRangeThisMonth: "This Month",
    dateRangeLastThreeMonths: "Last Three Months",
    enabled: "Enabled",
    disabled: "Disabled",
  },
  time: {
    minuteAgo: "1 minute ago",
    minutesAgo: "{count} minutes ago",
    hourAgo: "1 hour ago",
    hoursAgo: "{count} hours ago",
    dayAgo: "1 day ago",
    daysAgo: "{count} days ago",
    monthAgo: "1 month ago",
    monthsAgo: "{count} months ago",
    yearAgo: "1 year ago",
    yearsAgo: "{count} years ago",
  },
  pdf: {
    pageNumber: "Page {current} / {total}",
  },
  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
  },
  pdfLogin: {
    loginInfo: "Login Information",
    father: "Father",
    mother: "Mother",
    guardian: "Guardian",
    teacher: "Teacher",
    student: "Student",
    students: "Students",
    option1: "Option 1: Login with credentials",
    option2: "Option 2: Login with QR Code",
    username: "Username",
    password: "Password",
    qrCodeInstruction:
      "You can log in using this QR code in the mobile application :",
    scanQRCode: "Scan this QR code with the mobile application:",
    howToAccess: "How to access the platform",
    webPlatform: "Web platform:",
    mobileApp: "Mobile application:",
    installApp: "Install the {appName} application on your mobile phone",
    importantInfo: "Important information",
    changePassword: "• Change your password on first login.",
    keepDocumentSafe: "• Keep this document in a safe place.",
    contactAdmin: "• Contact the administration in case of problems.",
    parentLogins: "Parent Logins",
    teacherLogins: "Teacher Logins",
    studentLogins: "Student Logins",
    adminLogins: "Admin Logins",
  },
  pack: {
    new: "New",
    upgrade: "Upgrade",
    packMessage: "Upgrade for more features",
    typeNeededPNG: "Allowed file types: png.",
    infoConx: "Login Information",
    lienConx: "Login Link",
    lienConxText: "or EdTeacher Mobile App",
    upgradeModal: {
      title: "Feature Not Available",
      subtitle: "Your current subscription plan doesn't support this feature",
      description:
        "To access this feature, you need to upgrade your plan. Please contact our sales team for more details and pricing information.",
      contactInfo: "Contact Information",
      phone: "Phone",
      email: "Email",
      website: "Website",
      contactSales: "Contact Sales Team",
      close: "Close",
    },
  },
  moduleType: {
    pedagogicalModule: "Pedagogical Module",
    pilotModule: "Pilot Module",
    specificModule: "Specific Module",
  },
  teacherAvailability: {
    available: "Available",
    notAvailable: "Not available",
    saved: "The availability has been saved successfully",
    notFilledYet: "The teacher has not yet filled the availability sheet",
  },
  smartSchedule: {
    generalParams: "General parameters",
    comment: "Comment",
    commentRequired: "Comment is required field",
    startDay: "Start day",
    endDay: "End day",
    workingTime: "Working time",
    breakingTime: "Breaking time",
    startAt: "Start at",
    endAt: "End at",
    scheduleParmsAdded: "The schedule have been added successfully",
    generalParamsSaved: "The general parameters have been saved successfully",
    selectSchedule: "Select the settings",
    subjectsSchedParam: "The subjects",
    weeklyRate: "Weekly rate",
    module: "Module",
    subject: "Subject",
    moduleSpecific: "Pilote module",
    teacherClassParam: "Teacher assignment",
    teacherAffectedSuccess: "The teacher has been assigned successfully",
    teachersWeeklyRate: "Teachers weekly rate",
    name: "Name of the setting",
    smartSchedule: "Smart Schedule",
    smartSchedules: "Smart Schedules",
    ready: "Ready",
    pending: "Pending",
    finished: "Finished",
    error: "Error",
    addParam: "Add a setting",
    migrateSuccess: "The schedules has been migrated successfully",
    migrate: "Migrate the schedules",
    unmigrated: "The schedules have been successfully restored",
    noDataToUnmigrate: "The schedules already contain manual sessions!",
    unmigrate: "Restore manual sessions",
    minDuration: "Minimum duration",
    maxDuration: "Maximum duration",
    fillAllClassroomsToGenerate:
      "Please fill all classes to generate the schedules",
    weeklyRateMaxError:
      "The weekly rate should be equal to or greater than the maximum duration",
    weeklyRateMinError:
      "The weekly rate should be equal to or greater than the minimum duration",
  },
  calender: {
    calendar: "Calendar",
    noDescription: "There is no description",
    month: "Month",
    week: "Week",
    day: "Day",
    addEvent: "Add event",
    addEventTitle: "Add a new event",
    duration: "Duration",
    durationRequired: "Duration is required field",
    exam: "Exam",
    party: "Party",
    excursion: "Excursion",
    meeting: "Meeting",
    other: "Other",
    eventType: "Event type",
    color: "Color",
    typeRequired: "Event type is required field",
    editEventTitle: "Edit event",
    editEvent: "Edit event",
    editedEvent: "The event has been edited successfully",
    deletedEvent: "The event has been deleted successfully",
    addedEvent: "The event has been added successfully",
    meetingBetweenTeachersAdvisors: "Meeting between teachers and advisors",
    createdBy: "Created by the advisor",
  },
  chat: {
    ROOMS_EMPTY: "No rooms",
    ROOM_EMPTY: "No room selected",
    NEW_MESSAGES: "New Messages",
    MESSAGE_DELETED: "This message was deleted",
    MESSAGES_EMPTY: "No messages",
    CONVERSATION_STARTED: "Conversation started on:",
    TYPE_MESSAGE: "Type message",
    SEARCH: "Search",
    filter: "Filter",
    IS_ONLINE: "is online",
    searchParents: "Search parent",
    parentDetails: "Parent details",
    startNewConversationWithParent: "Create new conversation with parent",
    addParent: "Add parent",
    deleted: "Deleted",
    LAST_SEEN: "last seen ",
    noLogin: "No login account",
    inactiveParent: "Inactive parent",
    alreadyAdded: "Already added to chat",
    availableToAdd: "Available to add",
    noParentsFound: "No parents found",
    legacyMessage: "Legacy messages (before parent type separation)",
    legacyMessageInfo:
      "The messages above were sent when parents had a joint account.",
    deleteMessage: "Delete message",
    individualChats: "Individual chats",
    groupChats: "Group chats",
    groupDetails: "Group details",
    name: "Name",
    members: "Members",
    teacher: "Teacher",
    parent: "Parent",
    manager: "Manager",
    group: "Group",
    user: "User",
    description: "Description",
    noDescription: "No description",
    classLabel: "Class",
    subjectLabel: "Subject",
    noSubject: "No subject",
    classroomBased: "Classroom based",
    subjectBased: "Subject based",
    manualSelection: "Manual",
    selectionMode: "Selection mode",
  },
  paymentStatus: {
    paymentStatus: "Payment status",
    paidAmount: "The amount paid",
    monthRemainingPayments: "{month} remaining payments",
    allRemainingPayments: "All remaining payments",
    noRemainingPyaments: "There are no remaining payments",
    nothingPaid: "There are no payments paid",
    statutPaiement: "Payment status",
    nomEleve: "Student name",
    categorie: "Category",
    frais: "Fees",
    montant: "Amount",
    etat: "Status",
    totalNonPaye: "Total unpaid",
    totalPaye: "Total paid",
    totalAPayer: "Total to pay",
    resteAPayer: "Remaining",
    legende: "Legend",
    date: "Date",
    inscription: "Registration",
    pastYearsArrearsTitle: "Unpaid fees from previous school years",
    pastYearsArrearsSummary:
      "{fees} unpaid fee(s) (tuition and activities) across: {years}. Collect them before the new enrollments.",
    pastYearsArrearsDetails: "View details",
    pastYearsArrearsHide: "Hide details",
    pastYearsArrearsCollect: "Collect on {year}",
    scolarite: "Tuition",
    activite: "Activity",
  },
  language: {
    ar: "Arabic",
    fr: "French",
    en: "English",
    sw: "Swahili",
  },
  appreciation: {
    automatic: "Automatic appreciation",
    automaticDescription: "Automatic system based on averages",
    automaticDescriptionCollege:
      "Automatic appreciation by subject average (collège / lycée).",
    applyNotImplemented:
      "Apply is not yet available; it will be enabled in a future update.",
    adminAppreciation: "Admin appreciation",
    withOptions: "Specified appreciations",
    manual: "Manual Appreciations",
    appreciation: "Appreciation",
    applyAutomatic: "Apply automatic appreciation",
    duplicateAppreciations: "Duplicate appreciations",
    existingAppreciations: "Existing Appreciations",
    noExistingAppreciations: "No existing appreciations found",
    selectToReplace:
      "Select the appreciations you want to replace with automatic ones:",
    add: "Add appreciation",
    changedToManual: "The appreciation mode changed to manual",
    changedToOptions: "The appreciation mode changed to specified",
    giveAppreciation: "Give appreciation",
    bulkAppreciation: "Bulk appreciation",
    selectAppreciation: "Select appreciation",
    customAppreciation: "Add custom appreciation",
    selectPredefinedAppreciation: "Select predefined appreciation",
    insertPredefinedAppreciation: "Insert predefined appreciation",
    teacherManualDesc:
      "The teacher has access to write anything in appreciation",
    saved: "The appreciation has been saved successfully",
    deleted: "The appreciation has been deleted successfully",
    teacherAppreciation: "Teachers appreciations",
    studentsWithoutAppreciation: "Students without any appreciation",
    allStudentsHaveAppreciations: "All students have appreciations",
    missingAppreciation: "Students without appreciation",
    appreciationGiven: "Appreciation given",
    noTeacherAssigned: "No teacher assigned",
    transferAppreciation: "Transfer appreciations",
    transferSource: "Source report",
    transferTarget: "Target report",
    selectTargetType: "Select target report type",
    targetModulesSelected: "{count} target module(s) selected",
    transferSelectSource: "Please select a source module",
    transferSelectTargetModules: "Please select at least one target module",
    transferNoModules: "No modules available",
    transferPickTypeFirst: "Select a target report type to show modules",
    transferOverwritePolicy: "What to do if an appreciation already exists",
    transferSkipExisting: "Skip existing appreciations",
    transferReplaceExisting: "Replace existing appreciations",
    transferConfirmTitle: "Confirm transfer",
    transferConfirmContent:
      "Copy appreciations from \"{source}\" ({sourceType}) to {count} module(s) ({targets}) of type {targetType}? Policy: {policy}",
    transferResult:
      "Transfer done: {copied} copied, {skipped} skipped",
    applySuccess:
      "Automatic appreciations have been applied to {count} students",
    applyNone: "No automatic appreciations were applied.",
    cloneCollegeSourceHint:
      "Pick the subject and school year whose automatic appreciation rules you want to copy.",
    cloneCollegeTargetHint:
      "Choose target school year(s) first. You can pick several levels and several terms; the subject list is the union of bulletin config for those combinations. “Select all” selects every level, every term, and every subject except the source.",
    cloneSelectAllNoLevels: "No levels are available for this establishment.",
    cloneSelectAllNoSubjects:
      "No target subjects found, or only the source subject exists in the config — add other subjects or adjust filters.",
    cloneCollegeSourceIncomplete:
      "Please select source subject and source school year.",
    selectTargetSubjects: "Please select at least one target subject.",
    selectTargetTrimesters: "Please select at least one target trimester.",
    selectTargetLevels: "Please select at least one target level.",
    selectSourceModule: "Please select source module and school year",
    selectTargetSchoolYear: "Please select target school year",
    selectTargetModules: "Please select target modules or filters",
    noTargetModulesFound: "No target modules found",
    noAutoAppreciationToClone: "No automatic appreciation to clone",
  },
  connected: {
    online: "Online",
    offline: "Offline",
    all: "All",
    button_name: "Users",
    school_user: "Admin users",
    noname: "No-name",
  },
  feedback: {
    title: "Feedback",
    sendFeedback: "Send a feedback",
    category: "Category",
    comment: "Comment",
    problem: "Problem/Bug",
    idea: "Idea For Improvement",
    others: "Others",
    section: "Section",
    selectSection: "Please select the section",
    priority: "Priority",
    selectPriority: "Please choose the priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    critical: "Critical",
    message: "Message",
    uploadFiles: "Upload files",
    uploadAudio: "Upload audio",
    record: "Record",
    successSent:
      "Thank you for your contribution. We'll review it and get back to you if needed. Have a great day!",
  },
  certification: {
    Corresponding: "Corresponding decision",
    pass: "Admitted",
    fail: "Denied",
    cnd_pass: "Admitted by exemption",
    age_pass: "Admitted by age derogation",
    add: "Add certificate",
    moyPer: "Custom average",
    moySpec: "Specific average",
    default: "Use default certificates",
    confirmDefault:
      "This action will remove your certification. Are you sure to set it as default?",
    name: "Certificate name",
    min: "Minimum average",
    max: "Maximum average",
    minError: "The minimum average cannot be greater than the maximum average",
    maxError: "The maximum average cannot be less than the minimum average",
    defaultDone: "Certificates have been updated successfully",
    addCertificateDesigns: "Add your certificate designs",
    namePlaceholder: "e.g: Certificate of Appreciation",
    fileUploadedSuccessfully: "File uploaded successfully",
    moyenne: "Average",
    certificateDate: "Certificate date",
    printDate: "Print date",
    printDateEnabled: "Enable print date",
    dateFormat: "Date format",
    dateLabel: "Text before date",
    stamp: "Stamp",
    stampEnabled: "Enable stamp",
    stampPosition: "Stamp position",
    stampScale: "Stamp scale",
    stampWarning: "No stamp is configured for this school",
    stampHelp:
      "The stamp will be added automatically from the establishment settings",
    generalSettings: "General Settings",
    studentName: "Student Name",
    className: "Class Name",
    trimesterName: "Term Name",
    schoolYearHeader: "School Year",
    printDateHeader: "Print Date",
    stampHeader: "Stamp",
    orientation: "Orientation",
    positionX: "Position X",
    font: "Font",
    size: "Size",
    color: "Color",
    enable: "Enable",
    format: "Format",
    textBefore: "Text before",
    scale: "Scale",
    vertical: "Vertical",
    horizontal: "Horizontal",
    centered: "Centered",
    atStart: "At start",
    dateFormatDDMMYYYY: "DD/MM/YYYY",
    dateFormatYYYYMMDD: "YYYY-MM-DD",
    placeholderOrientation: "orientation",
    placeholderPositionX: "Position X",
    placeholderSelectFont: "Select a font",
    placeholderX: "x",
    placeholderY: "y",
    placeholderTextSize: "Text size",
    placeholderDateLabel: "ex: Print date:",
    placeholderScale: "1.0",
    scaleHelp: "Between 0.1 and 3 (1 = normal size)",
  },
  decisionConseil: {
    decision: "Decision",
    decisionM: "Decision (Male)",
    decisionF: "Decision (Female)",
    decisionConseil: "Board decisions",
    default: "Use default decisions",
    defaultDone: "Board decisions have been successfully updated",
    confirmDefault:
      "This action will remove your decisions from the board. Are you sure you set it as default?",
    editorTitle: "Council decisions per student",
    openEditor: "Council decisions",
    auto: "Auto (by average)",
    other: "Other",
    manualPlaceholder: "Enter decision",
    apply: "Apply",
    applyToSelected: "Apply to selection",
    selectDecision: "Choose a decision",
    selectStudents: "Select at least one student before applying.",
    noClassroom: "Select a class first.",
    unsavedHint: "You have unsaved changes. Click Save to confirm them.",
    bulkConfirmTitle: "Apply to selection",
    bulkConfirmContent:
      "This decision will only be assigned to selected students who have a general average (moyenne générale). Students without an average will be skipped.",
    bulkConfirmCounts:
      "{eligible} of {selected} selected student(s) will be updated.",
    noEligibleStudents:
      "None of the selected students have a general average. The decision cannot be applied.",
    noMoyenneForStudent:
      "This student has no general average. A council decision cannot be assigned.",
    filterByStudentName: "Search by student name",
    decisonOnPlaceholder: "Corresponding decision",
    decisonOnRequired:
      "Please choose the corresponding decision (A/C/R) for the class council PV.",
    pvNotDisplayed: "Not shown on PV",
    pvMissingKeyRow:
      "This student will not appear on the class council PV. Fix parametrage or assign a corresponding decision.",
    pvMissingKeyBanner:
      "{count} student(s) without a corresponding decision (A/C/R)",
    pvMissingKeyHint:
      "These students will not appear in the PV tables. Fix board decision parametrage or assign a decision per student.",
    pvMissingKeyMore: "... and {count} more",
    years:  "Study periods",
  },
  notifications: {
    desactivation:
      "Account has been suspended! Contact the administration for more information!",
    desactivateBuilding:
      "Your establishment has been suspended! Contact the administration for more information!",
    updateuser: "Account Modified! please reconnect!",
    updateAccess: "Modified Access! please reconnect!",
  },
  login: {
    incorrectInfo: "The username or password is incorrect",
    bienvenue: "Welcome to",
    title: "Management system for schools",
    connectezVous: "Log in!",
    connextion: "Login",
    requisMdp: "Please insert your password!",
    requisUsername: "Please enter your username!",
    username: "Username",
    password: "Password",
    connecte: "Connected",
    loginSuccess: "You have successfully logged in",
    readAndAccept: "I have read and accept the",
    termsAndConditions: "Terms and Conditions",
    subscribePart1:
      "If your school is not yet registered, discover our exclusive offers on our ",
    subscribePart2: "website ",
    subscribePart3: "and join our educational community today!",
    scanQR: "Bring your QR code close to the webcam to log in.",
    back: "Back",
    qrCodeInvalid: "Invalid QR code",
    oldQRCode:
      "This QR code uses an old format. Please request a new code from your administrator.",
    qrCameraError: "Unable to access the camera",
  },
  mfa: {
    twoFactorAuth: "Two-Factor Authentication",
    notEnabled: "Two-factor authentication is not enabled",
    notEnabledDescription:
      "Enable two-factor authentication to add an extra layer of security to your account.",
    enable: "Enable",
    enabled: "Two-factor authentication is enabled",
    enabledDescription:
      "Your account is protected with two-factor authentication.",
    enabledSuccess: "Two-factor authentication has been enabled successfully.",
    disabled: "Two-factor authentication is disabled",
    disabledSuccess:
      "Two-factor authentication has been disabled successfully.",
    method: "Method",
    authenticatorApp: "Authenticator App",
    sms: "SMS",
    phoneNumber: "Phone Number",
    disable: "Disable",
    disableConfirmation:
      "Are you sure you want to disable two-factor authentication? This will make your account less secure.",
    passwordRequiredToDisable:
      "For security reasons, please enter your password to disable two-factor authentication.",
    enterPasswordToDisable: "Enter your password",
    passwordRequired: "Password is required",
    invalidPassword: "Invalid password. Please try again.",
    confirmDisable: "Disable MFA",
    setup: "Setup Two-Factor Authentication",
    chooseMethod: "Choose Method",
    verify: "Verify",
    complete: "Complete",
    phoneRequired:
      "A phone number is required for SMS authentication. Please add a phone number in your profile first.",
    continue: "Continue",
    scanQRCode: "Scan QR Code",
    scanQRCodeDescription: "Use your authenticator app to scan this QR code.",
    manualEntry: "Can't scan? Enter this code manually:",
    secret: "Secret",
    next: "Next",
    smsReady: "SMS authentication is ready. Click 'Enable' to activate it.",
    verificationRequired: "Verification Required",
    enterAppCode: "Enter the 6-digit code from your authenticator app.",
    enterSMSCode:
      "Enter the 6-digit code sent to your phone. SMS may take up to 10 minutes to be received.",
    sentTo: "Code sent to",
    verificationCode: "Verification Code",
    codeRequired: "Verification code is required",
    codeLength: "Code must be 6 digits",
    codeFormat: "Code must be 6 digits",
    enterCode: "Enter 6-digit code",
    enterBackupCode: "Enter backup code",
    backupCode: "Backup Code",
    authenticatorCode: "Authenticator Code",
    backupCodeLength: "Backup code must be 8 characters",
    backupCodeFormat: "Backup code must be 8 alphanumeric characters",
    backupCodeHint:
      "Enter one of your backup codes. Each code can only be used once.",
    useBackupCode: "Can't access your authenticator? Use a backup code",
    useAuthenticatorCode: "Use authenticator code instead",
    resendCode: "Resend Code",
    codeSent: "Code Sent",
    codeSentDescription: "A new verification code has been sent to your phone.",
    rateLimitExceeded: "Resend Limit Reached",
    rateLimitMessage:
      "You must wait {minutes} minutes before requesting a new code.",
    rateLimitMessageSingular:
      "You must wait {minutes} minute before requesting a new code.",
    backupCodes: "Backup Codes",
    backupCodesDescription:
      "Save these backup codes in a safe place. You can use them to access your account if you lose access to your authenticator app.",
    copyCodes: "Copy Codes",
    codesCopied: "Backup codes copied to clipboard",
    smsEnabledDescription:
      "SMS authentication has been enabled. You will receive a code via SMS when logging in.",
    chooseMethodTitle: "Choose Your Security Method",
    chooseMethodDescription:
      "Select how you want to verify your identity when logging in. We recommend using an authenticator app for better security.",
    recommended: "Recommended",
    authenticatorAppDescription:
      "Use an authenticator app on your phone to generate secure codes. Works even without internet connection.",
    moreSecure: "More secure than SMS",
    fasterLogin: "Faster login - no waiting for SMS",
    moreReliable: "More reliable - no SMS delays",
    noNetworkNeeded: "No network needed on your phone",
    industryStandard: "Industry standard security method",
    smsDescription:
      "Receive verification codes via text message to your phone number.",
    setupAuthenticatorApp: "Setup Authenticator App",
    setupAuthenticatorAppDescription:
      "Follow these simple steps to set up two-factor authentication with an authenticator app.",
    step1Download: "Step 1: Download an Authenticator App",
    downloadInstruction:
      "If you don't have an authenticator app yet, download one of these free apps on your phone:",
    appStore: "App Store",
    googlePlay: "Google Play",
    step2Scan: "Step 2: Scan the QR Code",
    scanQRCodeInstruction:
      "Open your authenticator app and scan this QR code with your phone's camera. The app will automatically add your account under the name 'EdManager'.",
    cantScan: "Can't Scan the QR Code?",
    manualEntryDescription:
      "If you can't scan the QR code, you can enter this secret code manually in your authenticator app:",
    copySecret: "Copy Secret",
    secretCopied: "Secret code copied to clipboard",
    iHaveScanned: "I Have Scanned the Code",
    setupSMS: "Setup SMS Authentication",
    setupSMSDescription:
      "SMS authentication will send verification codes to your registered phone number.",
    smsReadyDescription:
      "SMS authentication is ready to be enabled. You will receive a 6-digit code via text message each time you log in.",
    enterAppCodeDescription:
      "Open your authenticator app and enter the 6-digit code shown on your screen.",
    enterSMSCodeDescription:
      "Check your phone for the SMS message and enter the 6-digit code you received.",
    codeHint:
      "The code refreshes every 30 seconds. Make sure to enter the current code.",
    backupCodesWarning: "Important: Save these codes now!",
    securityAlertTitle:
      "⚠️ Security Recommendation: Enable Two-Factor Authentication",
    securityAlertDescription:
      "Protect your account with an extra layer of security. Two-factor authentication significantly reduces the risk of unauthorized access to your account.",
    benefit1:
      "Prevents unauthorized access even if your password is compromised",
    benefit2: "Required by security best practices for sensitive accounts",
    benefit3: "Protects your data and prevents account takeover attacks",
    setupError: "MFA Setup Error",
    setupErrorDescription: "Unable to configure two-factor authentication",
    enableError: "MFA Activation Error",
    enableErrorDescription:
      "Invalid verification code. Please check the code and try again",
    disableError: "MFA Disable Error",
    disableErrorDescription:
      "Invalid password. Please check the password and try again.",
    invalidCode: "Invalid Verification Code",
    invalidCodeDescription: "The verification code is incorrect",
    smsError: "SMS Send Error",
    smsErrorDescription: "Unable to send SMS code",
    adminStatusOn: "MFA is enabled",
    adminStatusOff: "MFA is not enabled",
    adminDisableConfirm:
      "Disable MFA for this account? The user will be logged out on all devices and will sign in with password only.",
    adminDisableSuccess: "MFA disabled successfully",
    adminDisableError: "Could not disable MFA",
  },
  forceLogout: {
    passwordChanged: "Your password has been changed",
    accountDeactivated: "Your account has been deactivated",
    mfaEnabled: "MFA has been enabled on your account",
    securityEvent: "Security event detected",
    sessionExpired: "Session Expired",
    loggedOut: "You have been logged out. Please log in again.",
  },
  trialCommercialBlock: {
    title: "Your trial period has ended",
    badge: "Free trial ended",
    body:
      "Thank you for trying EdTrust. To keep managing your establishment from EdManager, contact our sales team to choose the plan that suits you.",
    contactTitle: "Contact our sales team",
    switchBuildingHint:
      "You can still access your other establishments by switching building below.",
    accountsKeptTitle: "EdParent and EdTeacher accounts are kept",
    parentsKept: "Parent accounts are not deleted.",
    teachersKept: "Teacher accounts are not deleted.",
    accountsKeptFootnote: "Full access will be restored as soon as your situation is settled.",
    phoneLabel: "Phone",
    emailLabel: "Email",
  },
  overduePaymentBlock: {
    title: "Access to EdManager is suspended",
    badge: "Payment pending",
    body:
      "Your establishment's subscription fees have not been paid yet. To restore access, please contact our sales team to settle your payment.",
    reasonLabel: "Reason:",
    reason: "payment deadline exceeded by more than {days} days (due date: {date}, Tunis time, UTC+1).",
    reasonNoDate: "payment deadline exceeded by more than {days} days.",
    contactTitle: "A question about your payment? Contact our sales team",
  },
  auth: {
    loginFailed: "Login Failed",
    ssoLoginFailed: "SSO Login Failed",
    genericError: "An error occurred",
  },
  niveau: {
    niveauPre: "Preschool",
    niveau0: "Preparatory",
    playGroup: "Play Group",
    pp1: "PP1",
    pp2: "PP2",
    niveau1: "1st year",
    niveau2: "2nd year",
    niveau3: "3rd year",
    niveau4: "4th year",
    niveau5: "5th year",
    niveau6: "6th year",
    niveau7: "7th year",
    niveau8: "8th year",
    niveau9: "9th year",
    niveau10: "1st year secondary",
    niveau11: "2nd year secondary",
    niveau12: "3rd year secondary",
    niveau13: "4th year secondary",
    autres: "Others",
  },
  assiduite: {
    assiduite: "Attendance",
    retard: "Late",
    present: "Present",
    absence: "Absence",
    exclus: "Exclusion",
    assiduiteMSA: "Attendance has been updated",
    assiduiteMoisChart: "Class attendance this month { className }",
    nb_absent: "Number of absences",
    nb_delay: "Number of lates",
    nb_exclusion: "Number of exclusions",
    date: "Date",
    areYouSureToEdit: "Are you sure you want to modify the attendance?",
    erreurRecuperationSeances: "Error retrieving sessions",
    erreurRecuperationDonnees: "Error retrieving attendance data",
    callSheet: "Call sheet",
    seance: "Session",
    type: "Type",
  },
  teacherAttendance: {
    title: "Teacher Attendance",
    teacher: "Teacher",
    filterTeacher: "Filter by teacher",
    allTeachers: "All teachers",
    filterStatus: "Filter by status",
    allStatuses: "All statuses",
    notMarked: "Not marked",
    status_present: "Present",
    status_absent: "Absent",
    status_late: "Late",
    status_absent_morning: "Absent (morning)",
    status_absent_afternoon: "Absent (afternoon)",
    status_absent_morning_short: "Morning",
    status_absent_afternoon_short: "Afternoon",
    lateTitle: "Enter delay",
    enterDelay: "Please enter the delay duration (in minutes)",
    delayPlaceholder: "Duration in minutes",
    updated: "Attendance updated",
    removed: "Attendance removed",
    offSite: "Off-site",
    offSiteHint: "Check-in was recorded outside the school geofence",
    tabDaily: "Daily check-in",
    tabPersonnelDaily: "Daily (no timetable)",
    tabReport: "Report",
    reportMode: "Report type",
    personnelDailyReportTitle: "Daily attendance report",
    markedDays: "Marked days",
    tabComparison: "Expected vs actual",
    searchByName: "Search by name",
    searchByNamePlaceholder: "Personnel name...",
    comparisonHint:
      "Compare expected hours (subject config × weeks, or timetable / daily config) with actual hours. Expand a teacher row for the per-subject breakdown.",
    comparisonTitle: "Expected vs actual report",
    expectedHours: "Expected hours",
    actualHours: "Actual hours",
    absentHours: "Absent hours",
    delayHours: "Delay hours",
    varianceHours: "Variance",
    timetableHours: "Timetable hours",
    noSubjectBreakdown: "No per-subject breakdown for this person.",
    validationPending: "Pending validation",
    validationValidated: "Validated",
    validate: "Validate",
    validateAll: "Validate all pending",
    validationHint:
      "Validation hierarchy is enabled: marks stay pending until a manager confirms them.",
    moduleDisabled:
      "Teachers Attendance is disabled for this establishment. Enable it in Établissement → Configurations.",
    personnelDailyHint:
      "Attendance per person per day, not linked to the timetable. Unmarked = Present by default.",
    filterPersonnel: "Filter by personnel",
    allPersonnel: "All personnel",
    defaultPresent: "Present (default)",
    reportTitle: "Teacher attendance report",
    period: "Period",
    delayMinutes: "Delay (min)",
    workedHours: "Worked hours",
    workedDays: "Worked days",
    editHistory: "Check-in history",
    noHistory: "No edit history yet",
    recordDeleted: "This check-in was deleted",
    showDeleted: "Show deleted",
    historyBy: "By",
    historyBefore: "Before",
    historyAfter: "After",
    historyAction_created: "Created",
    historyAction_updated: "Updated",
    historyAction_deleted: "Deleted",
    historyAction_restored: "Restored",
    source_teacher_checkin: "Teacher check-in",
    source_admin_manual: "Admin manual",
    minShort: "min",
  },
  avance: {
    ajoutAvance: "Add an advance",
    ajoutAvanceSubTitle: "Please complete the fields below to add an advance.",
    montantAvance: "Advance amount",
    impoAnnulerAvance: "Unable to cancel advance",
    typeRecetteRequis: "Recipe type is required!",
    saisirChequeInfo: "Enter check details",
    saisirChequeEspaceInfo: "Enter check and cash information",
    chequeNumRequis: "The check number is required!",
    historiqueAvances: "Advance history",
    avanceAjoute: "Advance successfully added",
  },
  xlsxUploader: {
    cliquer: "Click or drag and drop a file in this area to upload it",
    importEleves: "Import students",
    importElevesSubTitle:
      "Import students following the format in the template",
    downloadTemplate: "Download the Excel template",
    affectation: "Affectation",
    affectationSubTitle: "Affect parents",
    enregistrer: "Enregistrer",
    enregistrerSubTitle: "Verify and save",
    erreurValidationEleves: "Validation error - students sheet",
    erreurValidationParents: "Validation error - parents sheet",
    erreurFormatDate: "Date format error",
    formatFichierInvalide: "Invalid file format",
    formatFichierInvalideSubTitle:
      "Please download the valid template and fill in your data!",
    verifierDonnees: "Verify your data",
    affecterParents: "Affect parents",
    sectionParent: "Parents in the table",
    totalEleves: "Total students",
    totalParents: "Total parents",
    elevesNonAffectes: "Students not affected",
    verificationParents:
      "Verify, multiple parents with the same name can be affected",
    eleveNonAffecte: "Student not affected",
    affecterParent: "Affect parent",
    rechercher: "Search",
    reset: "Reset",
    laLigne: "line",
    lesLignes: "lines",
    dansLeFichierExcel: "in the Excel file",
    verifierDonneesEleves: "Please verify the required data for students",
    verifierDonneesParents: "Please verify the required data for parents",
    verifierDonnees:
      "Please verify the data, required fields and the parent assignment to each student",
    listeImporteeSucces: "List imported successfully",
    incompleteImport:
      "Incomplete import, some students or parents were not imported",
    erreurImportationParents: "Importation error - parents",
    erreurImportationEleves: "Importation error - students",
    erreurImportationSubTitle: "Please verify the following lines",
    elevesExistants: "Potentially existing students",
    elevesExistantsPotentiels: "Potentially existing students",
    existeDeja: "Potentially already exists in database",
    correspondances: "Matches",
    eleveExisteDeja: "student potentially already exists",
    elevesExistentDeja: "students potentially already exist",
    lignesExcel: "Rows",
    verifierAvantImport: "Please verify before saving",
    erreurVerificationExistence:
      "Error checking for existing students. Please proceed with caution.",
    filtrerPar: "Filter by",
    effacerFiltres: "Clear filters",
    elevesExistantsDeja: "Potentially existing students",
    elevesExistantsDejaSubTitle:
      "These students may already exist in the database",
    verificationEnCours: "Checking for existing students...",
    eleveExistePotentiellement: "This student potentially already exists",
    confirmerEnregistrement: "Confirm Registration",
    resumeImportation: "Import Summary",
    totalDansFichier: "Total in Excel file",
    elevesAInserer: "Students to insert",
    elevesAvecParentsSimilaires: "Students with similar parents",
    elevesRetiresDeListe: "Students removed from list",
    confirmezVousEnregistrement:
      "Do you confirm the registration of these students?",
    eleves: "students",
    confirmerRetraitTitle: "Confirm Removal",
    confirmerRetrait: "Confirm Removal",
    confirmer: "Confirm",
    annuler: "Cancel",
    confirmerRetraitMessage:
      "Are you sure you want to remove {count} student(s) from the list?",
    actionIrreversible: "This action is irreversible",
    selectionnerAuMoinsUn: "Please select at least one student",
    elevesRetires: "{count} student(s) removed successfully",
    modeSelection: "Selection mode active",
    modeSelectionDescription:
      "Select the students to remove from the list, then click 'Confirm Removal'",
    retirerDeLaListe: "Remove from list",
    actions: "Actions",
    nomPrenom: "Full name",
    dateNaissance: "Date of birth",
    adresse: "Address",
    sexe: "Gender",
    telephone: "Phone",
    identifiantUnique: "Unique identifier",
    parent: "Parent",
    garcon: "Boy",
    fille: "Girl",
  },
  profil: {
    noParentCredentials: "This parent has no login credentials",
    noParentInfo:
      "Please add the information for this parent to create a login account",
    photoMediaConsent: "Parent photo & media consent",
    photoMediaConsentCard: "Photo & media consent",
    photoMediaConsentHint: "Applies to all students on this parent account.",
    parentSuggestionTitle: "Parents who have the same phone number",
    changerNomUtilisateur: "Change username",
    historique: "History",
    paiement: "Payment",
    payes: "Paid",
    nonPayes: "Not paid",
    bulletin: " School report ",
    qrCode: "Qr code",
    informations: "Informations",
    Control: "Parental Control ",
    edtudiant: "Student credentials",
    paiementScol: "School payment",
    paiementAct: "Activity payment",
    paidWithAvance: "Paid with advance",
    listeReglements: "List of regulations",
    sexe: "Sex",
    nom: "Last name ",
    middleName: "Middle name",
    prenom: "First name",
    nomFr: "Last name in french",
    prenomFr: "First name in french",
    middleNameFr: "Middle name in french",
    nemisNumber: "Student NEMIS Number",
    birthCertificate: "Birth Certificate",
    saccoName: "SACCO Name",
    saccoBankName: "SACCO Bank Name",
    fullname: "Full Name",
    dateNaissance: "Date of birth",
    garcon: "Boy",
    fille: "Girl",
    adresse: "Address",
    postalAddress: "Postal Address",
    physicalAddress: "Physical Address",
    tel: "Telephone",
    classe: "Class",
    notes: "Notes",
    healthInformation: "Health Information",
    bloodType: "Blood Type",
    medicalCondition: "Medical Condition",
    medicalNotes: "Medical Notes",
    allergies: "Allergies",
    parentNoteOnAllergies: "Parent's Note on Allergies",
    unknown: "Unknown",
    nonInscrit: "Not yet registered",
    nomUser: "Username",
    mdp: "Password",
    currentPassword: "Current password",
    NewPwd: "New password",
    ConfirmNewPwd: "Confirm new password",
    resetPwd: "Reset password",
    gere: "Manage",
    consulter: "Consult",
    consulterPaiement: "Consulter Payment",
    etat: "State",
    mois: "Month",
    etablissement: "Establishment",
    administration: "Administration",
    ajouteLe: "Add in",
    lastModifi: "Last modification",
    annulerInscri: "Cancel registration",
    father: "Father",
    mother: "Mother",
    guardian: "Guardian",
    changerPrametreParent: "Change parent settings",
    changerPrametreParents: "Change parents settings",
    changerPrametreEleve: "Change student settings",
    changerPrametreTeacher: "Change teacher settings",
    teacherCredentialsSessionWarning:
      "Changing the username or password will sign the teacher out of all devices and sessions.",
    noTeacherCredentials: "This teacher has no login credentials",
    noTeacherInfo:
      "Please add the information (email) for this teacher to create a login account",
    ajouterCompteEnseignant: "Add teacher account",
    inscriActivitePour: "Activity registration for {name}",
    poid: "Weight",
    taille: "Height",
    maladies: "Illness",
    remarques: "Remarks",
    selectOption: "At least select one option",
    aucuneMaladieEnregistree: "No illness was recorded",
    aucuneDossierMedical: "No medical records found!",
    annulationEleve: "Cancel registration",
    deleteEleve: "Remove Student",
    nameChangeRequest: "Name changes were requested on",
    firstNameChangeRequest: "First name change from",
    lastNameChangeRequest: "Last name change from",
    requestedBy: "requested by",
    student: "Student",
    to: "To",
    approuver: "Approve",
    rejeter: "Reject",
    birthPlace: "Birthplace",
    confirmDelete:
      "Are you sure you want to delete this student's photo? This action cannot be undone.",
    viewStudentPhoto: "View Student Photo",
    uploadStudentPhoto: "Upload Student Photo",
    removeStudentPhoto: "Delete Student Photo",
    years: "years",
    profile: "Profile",
    userProfilePhoto: "Profile Photo",
    uploadUserPhoto: "Upload Profile Photo",
    removeUserPhoto: "Delete Profile Photo",
    unavailableUserName: "Username is not available!",
    passwordMustIncludeDigit: "The password must include at least one digit",
    passwordMustIncludeUppercase:
      "The password must include at least one uppercase letter",
    passwordMustIncludeLowercase:
      "The password must include at least one lowercase letter",
    passwordMinLength: "The password must be at least 8 characters long",
    passwordMustNotMatchUsername:
      "The password must be different from the username",
    ajouterCompteParent: "Add parent account",
  },
  topBar: {
    issuesHistory: "Issues History",
    projectManagement: "Project Management",
    typeToSearch: "Search...",
    findPages: "Find pages...",
    actions: "Acts",
    status: "Status",
    profileMenu: {
      hello: "Hello",
      billingPlan: "Billing Plan",
      role: "Role",
      email: "Email",
      phone: "Phone",
      editProfile: "Edit Profile",
      logout: "Log - Out",
    },
    notification: {
      notifications: "Notifications",
      searchPlaceholder: "Search notifications...",
      noNotifications: "No notifications found",
      errorFetch: "Failed to load notifications",
      readMore: "Read more",
    },
    bookmarks: "Bookmarks",
    pack: "Pack",
    storage: {
      menuLabel: "Storage",
      menuHintNoBar: "Open for details and history",
      tooltip: "Storage usage",
      modalTitle: "Storage usage history",
      seriesStorage: "Storage",
      noData: "No storage scans yet",
      objectsLabel: "objects",
      currentSummary: "Latest: {storage} · {count} objects",
      scopeDescription:
        "This total is the storage consumed by your entire school on our platform, including courses, homework, and other files uploaded by teachers (and similar content).",
      quotaTitle: "Your pack storage",
      quotaUsedOf: "{used} of {allowed} used",
      quotaUnlimitedLine: "{used} used · no storage cap on your pack",
      quotaOver:
        "You have exceeded your pack storage limit. Uploads may be blocked until usage drops. Contact the sales team to obtain more storage quota.",
      quotaNear:
        "You are close to your pack storage limit. Free some space or contact the sales team to increase your quota.",
      objectsInLastScan: "{count} objects in last scan",
      chartLimitLabel: "Pack limit",
    },
  },
  command: {
    idCommand: "Command ID",
    clientName: "Client Name",
    date: "Date",
    montant: "Amount",
    productName: "Product Name",
    quantity: "Quantity",
    etat: "State",
    status: "Status",
    detailsTitle: "Details",
    available: "Available",
    unavailable: "Unavailable",
    productsInCommand: "Products in the command",
    associatedCommands: "Associated commands",
    state: "State",
    Commands: "Commands",
    createdAt: "Created At",
    pending: "Pending",
    inProgress: "In Progress",
    cancelled: "Cancelled",
    validated: "Validated",
    active: "Active",
    inactive: "Inactive",
    note: "Note",
    showArchived: "Show Archived",
    search: "Search by reference or client name",
    showActive: "Show Active",
    ennote: "Enter note for the command",
  },
  product: {
    image: "Image",
    name: "Name",
    price: "Price",
    availability: "Availability",
    quantity: "Quantity",
    lastUpdate: "Last Update",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    tags: "Tags",
    description: "Description",
    coverPicture: "Cover Picture",
    additionalPictures: "Additional Pictures",
    submit: "Submit",
    private: "Private",
    public: "Public",
    visibility: "Visibility",
    uploadAdditionalPictures: "Upload Additional Pictures",
    uploadCoverPicture: "Upload Cover Picture",
    modifyCoverPicture: "Modify Cover Picture",
    reference: "Reference",
    pictures: "Pictures",
    Products: "Products",
    available: "Available",
    comingSoon: "Coming Soon",
    outOfStock: "Out of Stock",
    unavailable: "Unavailable",
    reqprice: "Price is required",
    reqavailability: "Availability is required",
    reqquantity: "Quantity is required",
    productAdded: "Product added successfully",
    impoPubAjout: "Unable to add product",
    reqname: "	Name is required",
    tag: "Enter tags or select from existing",
    ref: "Enter reference (optional)",
    currency: "TND",
    search: "Enter product name",
    minprice: "Min Price",
    maxprice: "Max Price",
    noChanges: "No changes detected",
    productDetails: "Product Details",
    visiblity: "Visibility",
  },
  menu: {
    statstiqueGeneral: "General Stats",
    financialStats: "Financial Stats",
    accessTeacher: "Teacher access",
    marketproducts_list: "Market Products",
    marketPlace: "MarketPlace",
    connection: "Users",
    powerbi: "powerBI",
    parametrageEtablissement: "Establishment settings",
    parametrageComptabilite: "Accounting settings",
    parametrageScolarite: "Schooling settings",
    printExport: "Print & Export",
    dataManagement: "Data Management",
    accessManagement: "Access Management",
    parentLogins: "Parent Logins",
    studentLogins: "Student Logins",
    adminLogins: "Admin Logins",
    smartSchedule: "Smart Schedule",
    teacherAvailability: "Teacher Availability",
    calender: "Calender",
    supervision: "Supervision",
    ptchat: "Chat parents with teachers",
    chat: "Chat",
    cheques: "The checks",
    logout: "Logout",
    activites: "Activities",
    etablissement: "Establishment",
    generale: "Genral",
    accueil: "Home",
    parametrage: "Settings",
    actualite: "Actuality",
    administration: "Administration",
    autorisation: "Permission",
    utilisateur: "User",
    liste: "Students list",
    activites: "Activities",
    cantine: "Canteen",
    etatPaiement: "State of payments",
    inscriActiv: "Registration: Activities",
    emploiActivites: "Schedule: Activities",
    assiduiteActivites: "Attendance: Activities",
    scolarite: "Schooling",
    inscriScol: "Registration : Education",
    etatPaiements: "State of payments",
    listePunition: "List of punishments",
    degital_library: "digital library",
    degital_library_list: "list of documents",
    emploi: "Timetable",
    eleves: "Students",
    enseignants: "Teachers",
    bulletin: "School report",
    bulletinCollege: "College / High School Report",
    bulletinStatistique: "Result statistics",
    notes: "Grades",
    notesModule: "Grades by subject",
    notesParEleve: "Student grades",
    notesModuleComplet: "Grades by module",
    personnel: "Personnel",
    listePersonnels: "List of staff",
    listeEnseignants: "List of teachers ",
    teacherAttendance: "Teacher Attendance",
    listeActivites: "List of activities",
    virementBancaire: "Bank Transfer",
    listeEleves: "Students list",
    comptabilite: "Accounting",
    etatRecettes: "Revenue state",
    journaleCaisse: "Cash journal",
    depenses: "Expenses",
    nouvelleDepense: "New expense",
    fournisseurs: "Suppliers",
    fournisseurProfile: "Supplier profile",
    factures: "Invoices",
    saisiePaiement: "Payment entry",
    historiquePaiements: "Payment history",
    encaissementValidation: "Receipt validation",
    reconciliation: "Reconciliation",
    avoirFournisseur: "Supplier credit notes",
    dettes: "Engagements",
    depensesPersonnel: "Wage expense",
    etatImpayes: "State of unpaid",
    listeReglement: "Regulation List",
    reglementsAnnules: "Canceled Payments",
    etatImpayesActivites: "Unpaid status: Activities",
    etatImpayesScolarite: "paid status: Education",
    declaration: "Declaration",
    decaissement: "Decaissement",
    declarationTva: " TVA Declaration",
    chiffreAffaires: "Turnovers",
    chiffreAffairesScolarite: "Turnover : Education",
    statistique: "Statistics",
    actulite: "News",
    bulletinNews: "Bulletin",
    sms: "SMS",
    smsAndNotifications: "SMS and Notifications",
    envoyerSms: "Send SMS",
    envoyerSmsLogin: "Parent Logins",
    envoyerParClasseSms: "Send by class",
    historiqueSms: "History",
    caisseAvance: "Cash advance",
    assiduite: "Attendance",
    preinscription: "Pre-registration",
    profile: "My Profile",
    certificate: "Certificate",
    finance: "Finance",
    tresorerie: "Treasury",
    manageCaisses: "Manage wallets",
    myCaisse: "My wallet",
    encaissement: "Cash collection",
    chequeEtTraite: "Checks and drafts",
  },
  finance: {
    invoiceBuilder: "Add a payment",
    legend: "Legend :",
  },
  accueil: {
    title: "Dashboard",
    subtitle: "Overview of school activities and statistics",
    refresh: "Refresh",
    activite: "Activity",
    activiteSubtitle: "Total number of available activities",
    eleves: "Students",
    elevesSubtitle: "Total number of enrolled students",
    employees: "Employees",
    employeesSubtitle: "Total number of employees",
    classes: "Classes",
    classesSubtitle: "Total number of available classes",
    serviceActiv: "Services / Activities",
    benefice: "Total profit",
    montant: "Amount",
    pourcentage: "Percentage",
    depense: " Total Expense",
    RevenuDep: "Expenses / Income ",
    depenses: "Expenses",
    revenu: "Income",
    tnd: "TND",
    totalClasses: "Total Number of Classes",
    nombreDeClasses: "Number of Classes",
    boys: "Boys",
    girls: "Girls",
    totalBoys: "Total Boys",
    totalGirls: "Total Girls",
    noDataClasses: "No class data available",
    noDataNiveaux: "No grade data available",
    moreDetails: "Click here for more details",
    stat: "Detailed Statistics",
    deletedClasse: "Class has been deleted",
    dashboard: {
      hello: "Hello",
      guest: "Guest",
      subtitleOverview: "Here is an overview of your school today.",

      quickCantine: "Canteen",
      quickConsolidation: "Consolidation",
      quickClasses: "Classes",
      quickEmploi: "Timetable",
      quickEleves: "Students",
      quickDiscipline: "Discipline",
      quickSupport: "Support",

      financialSummary: "Financial summary",
      seeDetails: "See details",
      encaissementDuJour: "Today's collections",
      decaissementDuJour: "Today's disbursements",
      vsHier: "vs yesterday",
      soldeNetJour: "Net balance for today",

      criticalTasks: "Critical tasks",
      criticalTasksSubtitle: "Action required · Your attention is needed",
      enAttente: "pending",
      allClear: "You're all caught up!",
      punitionsPending: "Punishments pending validation",
      actualitesPending: "News pending validation",
      notificationsUnread: "Unread notifications",
      messagesUnanswered: "Unanswered parent messages",
      addNews: "Add a news item",
      newsCtaFirstTitle: "Add your first news item and notify parents",
      newsCtaFirstSubtitle:
        "Share important school information in a few clicks.",
      newsCtaTodayTitle: "Add today's news to keep parents informed",
      newsCtaTodaySubtitle:
        "No news was published today. Stay connected with parents.",

      pendingRequests: "Pending requests",
      enAttenteReponse: "Awaiting response",
      requestsParents: "Parents",
      requestsEleves: "Students",
      requestsPersonnel: "Staff",

      birthdays: "Upcoming birthdays this month",
      searchByName: "Search by name...",
      staff: "Staff",
      student: "Student",
      birthdayToday: "Today",
      birthdayTomorrow: "Tomorrow",
      birthdayInDays: "In {days} days",
      birthdayOnDate: "{date}",
      noBirthdaysToday: "No birthdays this month",

      topStudents: "Top 10 averages",
      moyenne: "Average",
      bulletinPedagogique: "Pedagogical",
      bulletinPilote: "Pilot",
      bulletinSpecifique: "Specific",
      noTopStudents: "No averages available for this bulletin",
      accessDenied: "Access denied",

      upcomingEvents: "Upcoming events",
      seeAllEvents: "See all events",
      noUpcomingEvents: "No events scheduled in the next 7 days",

      latestNews: "Latest news",
      seeAllNews: "See all news",
      noNews: "No news for now",

      roomsAvailability: "Real-time room availability",
      free: "Free",
      occupied: "Occupied",
      noRooms: "No rooms configured",

      disciplineBreakdown: "Disciplinary breakdown",
      total: "Total",
      cases: "cases",
      noSanctions: "No sanctions recorded",
    },
  },
  sms: {
    smsSentSuccess: "SMS sent successfully",
    selectionner: "Select",
    corriger: "Correct it",
    noValidParentsInformation: "No valid parent information for the student:",
    noValidParentInformation: "No valid {parent} information for the student:",
    noAccount: "No account for {parent} for the student:",
    paymentRappel: "Payment reminder",
    deatilsAutoSmsTitle: "Details of Automated SMS Messages",
    seeProfile: "See profile",
    newPayment: "New payment",
    newInscription: "New registration",
    newAbsence: "Absence/Late",
    newCourse: "Course/Homework",
    bulletinDispo: "Report card available",
    actualite: "News",
    autoSms: "Automatic SMS settings",
    autoPn: "Automatic mobile notifications settings",
    votreSolde: "YOUR BALANCE",
    nbrSmsRestant: "Number of SMS remaining",
    paymentTemplate1:
      'You have paid {amount paid} TND for "{Activity Name}" fees for {Student Name}. This payment is for the period {list of months}.',
    paymentTemplate2:
      "You have paid {amount paid} TND for school fees for {Student Name}. This payment is for the period {list of months}.",
    inscriptionTemplate1:
      "Your child {student name} has been successfully enrolled in {activity name}.",
    inscriptionTemplate2:
      "Your child {student name} has been successfully enrolled in class {class name}.",
    absenceTemplate1:
      'Your child {student name} was absent on {date} at {time} during the "{session name}" session',
    absenceTemplate2:
      'Your child {student name} arrived late on {date} at {time} during the "{session name}" session',
    courseTemplate1:
      "A new course has been added for your child with the title: {title}.",
    courseTemplate2:
      "A new homework has been added for your child with the title: {title}.",
    bulletinTemplate:
      "The {pedagogic/pilot/specific} report card of {student name} for term {trimester} is available on EdParent.",
    actualiteTemplate:
      "A new news item has been added on Edparent with the title: {title}.",
    nomlExpediteur: "SENDER'S NAME",
    desclExpediteur: "The SMS are sent as",
    gererListeDistinateurs: "MANAGE THE LIST OF DESTINATIONS",
    envoyerDesSms: "SEND SMSs",
    listeVosEleves: "List of your students",
    listeClasses: "Class list",
    selectionnerEleves: "Select students",
    selectionnerClases: "Select Classes",
    pressEnterToSelect: "Press enter to select",
    pressEnterToRemove: "Press enter to remove",
    selected: "Selected",
    maxClassesReached: "You can select a maximum of 4 classes",
    entrerNumerosSpecifiques: "Enter specific numbers",
    entrerNumerosSpecifiquesDesc: "Phone numbers must be separated by commas",
    categorieTag: "Category/tag",
    categorieTagDesc: "Tags help you organize your posts well",
    saisirCategorieTag: "Enter categories/tags",
    contenueVotreMessage: "Enter the content of your message",
    contenueMessage: "Enter the content of the SMS",
    listeFinale: "FINAL LIST",
    nombreSms: "Number of SMS",
    nombreMessage: "Number of messages",
    nomberTotal: "Total number",
    nombreMessageParCategorie: "Number of SMS per category",
    nombreCaracteres: "NUMBER OF CHARACTERS",
    pere: "Father",
    mere: "Mother",
    guardian: "Guardian",
    specifique: "Specific",
    destinataire: "Receiver",
    telephone: "Telephone",
    parents: "parents",
    personnel: "Personnel",
    sanction: "sanction",
    bulletin: "Report",
    envoyer: "Send",
    nonInscrit: "Not enrolled",
    noOptions: "The list is empty",
    jours: "Days",
    boiteEnvoieSms: "SMS send box",
    message: "Message",
    numsSpecifiques: "Specific numbers",
    listeParents: "List of parents",
    envoyeParUser: "Sent by user",
    groupe: "Group",
    tags: "Tags",
    envoiDate: "Sent date",
    selectAll: "Select all",
    selectAllTeachers: "Select all teachers",
    selectAllStudents: "Select all students",
    envoyerDesSmsLogins: "SEND SMS OF LOGINS",
    alertNumberSMS:
      "If the username and password are long (exceeds 66 arabic characters or 156 english characters) the number of SMS for a parent can consume 2 SMS of the balance",
    envoyerDesLoginsParents: "Send parent logins",
    calculerNombreSms: "Calculating SMS count...",
    totalSms: "Total SMS: ",
    boiteEnvoie: "Outbox",
    nomUtilisateur: "Username",
    nombreSmsEnvoye: "Number of SMS sent",
    date: "Date",
    noRecipients: "Please select at least one recipient to send the SMS.",
    confirmSendTitle: "SMS Sending Confirmation",
    invalidPhones: "invalid",
    duplicatePhones: "duplicate(s)",
    duplicateTag: "Duplicate",
    noValidNumbers: "No valid numbers",
    confirmTotalLabel: "Number of SMS to be sent",
  },
  mobileNotifications: {
    title: "Mobile Notifications",
    detailsTitle: "Details of Automated mobile notifications",
    enablePaymentReminder: "Enable payment reminders",
    recurringFrequency: "Recurring frequency",
    weekly: "Weekly",
    monthly: "Monthly",
    dayOfWeek: "Day of week",
    dayOfMonth: "Day of month",
    time: "Time",
    selectDays: "Select days",
    paymentReminderTitle: "Payment Reminder",
    paymentReminderClassroom: "Payment Reminder - Tuition",
    paymentReminderActivity: "Payment Reminder - Activities",
    notificationTitle: "Title",
    // Monthly payment messages (matching Lambda function)
    messageClassroomMonthly:
      "Reminder: Please pay the tuition fees for {month} currently due. Please check the app for details.",
    messageActivityMonthly:
      "Reminder: Please pay the activity fees for {month} currently due. Please check the app for details.",
    // Tranche payment messages (matching Lambda function)
    messageClassroomTranche:
      "Reminder: Please pay the tuition fees for the installment currently due. Please check the app for details.",
    messageActivityTranche:
      "Reminder: Please pay the activity fees for the installment currently due. Please check the app for details.",
    sendNow: "Send Now",
    sendNotificationSuccess: "Payment reminder notification sent successfully",
    sendNowConfirmTitle: "Send Notification Now?",
    sendNowConfirmMessage:
      "Are you sure you want to send payment reminder notifications to all parents with unpaid payments right now?",
    timeRequired: "Time is required when notifications are enabled",
    dayOfWeekRequired:
      "At least one day of week is required for weekly frequency",
    dayOfMonthRequired:
      "At least one day of month is required for monthly frequency",
  },
  notificationConfig: {
    title: "Notification Configuration",
    sendPaymentValidationNotification:
      "Send a notification to parents when a payment is validated",
  },
  action: {
    cloneSuccess: "All data has been cloned successfully",
    refreshPage: "Please refresh the page to see the complete effect",
    impressionReussie: "Printing successful",
    erreurImpression: "An error occurred while printing",
    reinitialiser: "Reset",
    clone: "Clone",
    simpleBadge: "Simple badge",
    badgeAvecPhoto: "Badge with photo",
    reset: "Reset",
    imprimerTab: "Print table",
    imprimerFreresSoeurs: "Print brothers & sisters list",
    imprimerBadges: "Print the badges",
    imprimerNewBadges: "Imprimer les badges with",
    actions: "Actions",
    operation: "Operation",
    supprimer: "Delete",
    ajouter: "Add",
    modifier: "Edit",
    consulter: "Consult",
    annuler: "Cancel",
    enregistrer: "Save",
    afficher: "Show",
    voir: "See",
    desactiver: "Disable",
    activer: "Enable",
    imprimer: "Print",
    confirmer: "Confirm",
    changer: "Change",
    importer: "Import",
    preview: "Preview",
    revoke: "Revoke",
    retour: "Back",
    refresh: "Refresh",
    retry: "Retry",
    selectAll: "Select All",
    bulkEdit: "Bulk Edit",
    saveAll: "Save All",
    applySameReduction: "Apply Same Reduction to All Selected Rows",
    selected: "selected",
    editing: "Editing",
    fullyPaid: "Fully Paid",
    imprimerHistorique: "Print history",
    genererPdfHistorique: "Generate PDF",
    pdfGenereAvecSucces: "PDF generated successfully",
    succes: "Success",
    upload: "Upload",
    search: "Search",
    fermer: "Close",
    status: "Status",
    suivant: "Next",
  },
  common: {
    loading: "Loading statistics...",
    selected: "selected",
    editing: "Editing",
  },
  message: {
    noSelection: "No selection found",
    noValidUpdates: "No valid updates found",
    bulkUpdateSuccess: "{count} reductions updated successfully",
    bulkUpdateError: "Error during bulk update",
    enterReductionValue: "Please enter a reduction value",
    paymentDataNotFound: "Payment data not found",
    loadingBulletin: "Please wait...",
  },
  confirmation: {
    revokeAccess: "Do you confirm revoking the access?",
    revokeAccessSaved: "Access has been successfully revoked",
    solveTheConflictError: "Please solve the conflict before continuing",
  },
  library: {
    yes: "Yes",
    no: "No",
    createdBy: "Created by",
    ajouterDocument: "Add a document",
    editDocument: "Edit a document",
    titre: "Title",
    subject: "Subject",
    grade: " Grade",
    search: "Search",
    submit: "Submit",
    createdAt: "Created At",
    lastUpdate: "Last Update",
    contentType: "Content type",
    text: "Text",
    video: "Video",
    attachment: "Attachement",
    uploadAttachment: "Upload attachment",
    uploadVideo: "Upload video",
    visibility: "Visibility",
    public: "Public",
    private: "Private",
    shared: "Shared",
    levelRequired: "Grade is required",
    select: "Select a",
    docRequired: "You need to upload documents",
    maxDocs: "No more than 15 files can be downloaded",
    ressources: "Resources",
    search: "Enter title to search",
    fileName: "File name",
    fileUploadError: "You can only upload JPG, JPEG, or PNG file!",
    added: "Added",
    deleted: "Deleted",
    updated: "Updated",
    document: "Document",
    documents: "Documents",
    uploadText: "Upload a text",
    add: "Add",
  },
  subject: {
    subject1: "Math",
    subject2: "French",
    subject3: "Mathematics",
    subject4: "Natural Sciences",
    subject5: "History",
    subject6: "Geography",
    subject7: "Civic Education",
    subject8: "Arts Education",
    subject9: "Physical Education",
    subject10: "Computer Science",
    subject11: "English",
    subject12: "Modern Language",
    subject13: "Physics-Chemistry",
    subject14: "Life and Earth Sciences",
    subject15: "Technology",
    subject16: "Philosophy",
  },
  actualite: {
    ajouterAlbum: "Add an album",
    ajouterActualite: "Add news",
    modifierAlbum: "Edit album",
    modifierActualite: "Edit news",
    album: "Album",
    date: "Date release",
    seenAtLabel: "Seen at",
    tousClasses: "Classes",
    titre: "Title",
    categorie: "Category",
    customCategory: "Custom category",
    customCategoryPlaceholder: "Enter a custom category",
    categoryInfo: "Information",
    categoryImportantInfo: "Important information",
    categoryUrgent: "Urgent",
    categoryAvisImportant: "Important notice",
    categoryAvis: "Notice",
    categoryImportant: "Important",
    categoryOther: "Other",
    cibles: "Targets",
    jaimes: "Like",
    photos: "Photos",
    dateCreation: "Creation Date",
    tous: "All",
    enseignants: "Teachers",
    eleves: "Students",
    teachers: "Teachers",
    students: "Students",
    administration: "Administration",
    parents: "Parents",
    cliquer: "Click or drag the file to the area to upload it",
    support:
      "Support single or batch download. Strictly prohibit downloading company data or other group files",
    description: "Description",
    ajouterPub: "Add a publication",
    trimestre1: "Term 1",
    trimestre2: "Term 2",
    trimestre3: "Term 3",
    trimester_one: "Original Term",
    trimester_two: "Cloned Term",
    retour: "Return",
    pasImages: "No images",
    mentionJaimes: "Likes",
    seenByParentsNewsTitle: "Parents who viewed this news",
    notSeenByParentsNewsTitle: "Parents who did not view this news",
    seenNotSeenParentsTitle: "Seen / Not seen by parents",
    seenNotSeenParentsLabel: "Seen and not seen by parents",
    seenTrackedOnlyForParents:
      "Views are only tracked for news targeting parents.",
    noParentSeenNews: "No parent has viewed this news yet.",
    allParentsSeenNews: "All targeted parents have viewed this news.",
    seenCountLabel: "Seen ({count})",
    notSeenLabel: "Not seen",
    notSeenCountLabel: "Not seen ({count})",
    modifierImages: "Edit images",
    specificFor: "Specific for",
    levels: "Grades",
    classrooms: "Classes",
    activities: "Activities",
    selectActivities: "Select activities",
    activitiesRequired: "Activities are required",
    specified: "Specified",
    specifiedInfo: "Specified filters will apply only for parents",
    studentSpecifiedInfo: "Specified filters will apply only for students",
    teacherSpecifiedInfo: "Specified filters will apply only for teachers",
    selectionnerEnseignants: "Select teachers",
    files: "Files",
    noFiles: "No files found",
    details: "News Details",
    aucuneActualite: "No news published",
    enableComments: "Enable Comments",
    commentsEnabled:
      "Comments can be enabled or disabled for each news item separately",
    commentsDisabled: "Comments are disabled for all news items",
    videoProcessing: "Processing video...",
    videoError: "Video processing error",
    videoNotReady: "Video is not ready yet",
    videoLoading: "Loading video...",
    videoNotSupported: "Your browser does not support playing this video",
    videoTagNotSupported: "Your browser does not support the video tag.",
    videoPlaybackError: "Error playing video",
    videoQualityAuto: "Auto",
    videoQuality: "Quality",
    enableCommentsForThisNews: "Enable Comments for this News",
    enableCommentsForThisNewsDesc: "Allow users to comment on this news item",
    searchAndFilters: "Search & Filters",
    total: "Total",
    actualitesPlural: "News",
    clearFilters: "Clear Filters",
    searchByTitle: "Search by title",
    filterByCategory: "Filter by category",
    actualiteLabel: "News",
    filterByCreationDate: "Filter by creation date",
    filterByTarget: "Filter by target",
    search: "Search",
    parentLabel: "Parent:",
    videos: "Videos",
    uploadVideo: "Click or drag video files here to upload",
    videoSupport: "Support for MP4, MOV, AVI, MKV video formats",
    pendingValidation: "Pending Validation",
    validated: "Validated",
    approve: "Approve",
    reject: "Reject",
    rejected: "Rejected",
    confirmReject: "Are you sure you want to reject this news?",
    newsValidated: "News approved successfully",
    newsRejected: "News rejected successfully",
    createdByTeacher: "Created by teacher",
    createdByLabel: "Created by",
    statusLabel: "Status",
    validation: "Validation",
    validatedLabel: "Validated",
    teacher: "Teacher",
    admin: "Administrator",
    filterByValidation: "Filter by status",
    allNews: "All",
    pendingOnly: "Pending",
    validatedOnly: "Validated",
    rejectedOnly: "Rejected",
    seeMore: "See more",
    seeLess: "See less",
    like: "Like",
    liked: "Liked",
    commentBtn: "Comment",
    writeCommentPlaceholder: "Write a comment...",
    commentsCountLabel: "{count} comments",
    noLikesYet: "Be the first to like this post",
    noCommentsYet: "No comments yet",
    postOptions: "Options",
    composerPrompt1: "What's new at school today?",
    composerPrompt2: "Share today's news with your whole community…",
    composerPrompt3: "Announce an event, celebrate a win, or keep everyone in the loop.",
    composerPrompt4: "Got an update, an important notice, or good news to share?",
    composerPrompt5: "Inspire parents, students, and staff — start your post here.",
    emojiPickerLabel: "Add emoji",
    sendCommentLabel: "Send comment",
  },
  activityClub: {
    confirmDeletePost: "Are you sure you want to delete this activity / club?",
    tabNews: "News & Albums",
    tabClub: "Activity / Club",
    addPost: "Add activity / club post",
    editPost: "Edit activity / club post",
    noPosts: "No activity / club posts",
    searchByTitle: "Search by title",
    activity: "Activity / Club",
    other: "Other",
    customActivityName: "Club name",
    price: "Price",
    registrationStartDate: "Registration start date",
    clubStartDate: "Club start date",
    clubEndDate: "Club end date",
    maxPlaces: "Max places",
    maxPlacesOptional: "Leave empty for unlimited",
    unlimited: "Unlimited",
    coverImage: "Cover image",
    attachments: "Attachments",
    pending: "Pending",
    accepted: "Accepted",
    rejected: "Rejected",
    subscribers: "Subscribers",
    views: "Views",
    searchByName: "Search by name",
    allStatuses: "All statuses",
    parentName: "Parent",
    studentName: "Student",
    status: "Status",
    subscribedAt: "Subscribed at",
    accept: "Accept",
    reject: "Reject",
    register: "Register",
    joinSuccess: "Your request has been sent",
    registrationStartsOn: "Registration starts on {date}",
    status_pending: "Pending",
    status_accepted: "Accepted",
    status_rejected: "Rejected",
    enableComments: "Enable comments",
    commentsEnabled:
      "Comments can be enabled or disabled for each activity / club post individually",
    commentsDisabled: "Comments are disabled for all activity / club posts",
    enableCommentsForThisPost: "Enable comments for this post",
    enableCommentsForThisPostDesc:
      "Allow users to comment on this activity / club post",
    composerPrompt1: "Share a new activity or club…",
    composerPrompt2: "Announce open registration…",
    composerPrompt3: "Post info about the next club…",
  },
  etablissement: {
    reductionType: "Type of discount",
    pourcentage: "Percentage",
    dinar: "Dinar",
    shilling: "Shilling",
    currency: "Currency",
    TND: "Tunisian Dinar (TND)",
    KES: "Kenyan Shilling (KES)",
    currencyRequired: "Currency is required",
    access: "Access",
    editAccess: "Edit access",
    accessUpdated: "Access updated successfully",
    editingAccess: "Editing access",
    config: "Configurations",
    editConfig: "Edit Configuration",
    editBuilding: "Edit Building",
    accessConfig: "Configuration has been successfully modified",
    editingConfig: "Editing Configuration",
    alertDisableChat:
      "Enable or disable chat between parents and teachers (if disabled, teachers and parents will instantly lose access to chat in the mobile and web apps)",
    alertDisableTeacherParentGroupChat:
      "Enable or disable teacher-parent group chat (if disabled, existing groups stay visible but become read-only for teachers and parents).",
    teacherParentGroupChat: "Teacher-parent group chat",
    alertRequirePunishmentValidation:
      "If enabled, punishments added by the administration stay pending until validated by an admin. If disabled (default), they are auto-validated as soon as they are added.",
    requirePunishmentValidation:
      "Require validation for punishments added by the administration",
    alertTeacherAttendanceEnabled:
      "Enable or disable the Teachers Attendance module (session check-in, daily attendance, reports and expected vs actual). If disabled, the feature is hidden and APIs are blocked.",
    teacherAttendanceEnabled: "Enable Teachers Attendance",
    alertRequireTeacherAttendanceValidation:
      "If enabled, attendance marks stay pending until a manager validates them. If disabled (default), marks are final immediately and existing session/daily flows are unchanged.",
    requireTeacherAttendanceValidation:
      "Require validation for teacher/personnel attendance (hierarchy)",
    etablissements: "Establishments",
    classe: "Class",
    classes: "Classes",
    niveaux: "Levels",
    ajouterNiveau: "Add a level",
    createAllLevels: "Create all levels",
    niveauxHint:
      "Define fees per level. Normal classrooms automatically inherit their level's fees.",
    levelRequiredFirst:
      "This level must be created in the Levels tab before adding a classroom.",
    niveauAffectation: "Level (affectation)",
    elevesAffectes: "Affected students",
    salles: "Rooms",
    services: "Services",
    activites: "Activities",
    typeQualification: " Qualifications Type",
    anneeScolaire: "School year",
    logo: "Logo",
    name: "Name",
    nom: "Name",
    designation: "designation",
    legalName: "Legal name",
    headMaster: "Head Master",
    dateEnregistrement: "Registration Date",
    createdAt: "Registration Date",
    phone: "Telephone",
    mainPhone: "Main Phone",
    email: "Email",
    mainEmail: "Main Email",
    additionalEmails: "Additional Emails",
    addEmail: "Add Email",
    additionalPhones: "Additional Phones",
    addPhone: "Add Phone",
    kenyaPhoneRequirement: "At least 2 additional phone numbers required",
    MF: "Tax Registration Number",
    schoolNEMISNumber: "School NEMIS Number",
    RIB: "RIB",
    adress: "Address",
    geoLat: "Latitude (GPS)",
    geoLng: "Longitude (GPS)",
    geoRadius: "Radius (meters)",
    geoHint:
      "School coordinates for teacher check-in (off-site if outside the radius).",
    postalAddress: "Postal Address",
    type: "Type",
    niveau: "Grade",
    fraisInscri: "Admission Fees",
    fraisMensuel: "Monthly fees",
    fraisParJour: "Daily fees",
    typeActivite: "Activity Type",
    nameActivite: "Activity name",
    parJour: "Daily",
    mensuelleParTranche: "Monthly/by term",
    emploi: "Timetable",
    dateCreation: "Creation Date",
    capacite: "Capacity",
    fournisseurs: "Providers",
    fournisseur: "Provider",
    fournisseurNonRequis: "Provider (not required) :",
    service: "Service",
    responsable: "Responsible",
    responsableActivite: "Activity responsible",
    ordrePriorite: "Order/priority",
    order: "Order",
    dateDebut: "Start date",
    dateFin: "End date",
    seuleFois: "A single time",
    entrerInfo: "Enter the information in the fields below",
    modifierEmploi: "Edit Timetable for {name}",
    other: "Other",
    editAlert:
      "Modifying the school year will not change the enrollment months for students already registered. Are you sure you want to proceed?",
    clickOrDragToUpload: "Click or drag a file to this area to upload it",
    clickForUploadLogo: "Click to edit logo",
    ecole: "Primary school",
    college: "Middle school",
    lycee: "High school",
    collegeEtLycee: "Middle & High school",
    primaireEtCollege: "Primary & Middle school",
    jardinEnfant: "Kindergarten",
    preSchool: "Pre-School",
    prePrimary: "Lower Primary",
    middle: "Upper Primary",
    junior: "Junior Secondary",
    senior: "Senior School",
    cache: "Stamp",
    choisir: "Choose",
    matriculeFiscale: "Tax registration number",
    ArabicName: "Name in Arabic",
    delegeRegional: "Regional Delegate",
    countyLocation: "Country Location",
    slogan: "Slogan",
    nameRequired: "Name is required",
    arabicNameRequired: "Arabic name is required",
    legalNameRequired: "Legal name is required",
    delegeRegionalRequired: "Regional delegate is required",
    countyLocationRequired: "Country location is required",
    headMasterRequired: "Head Master is required",
    headMasterFrench: "Head Master in French",
    headMasterGender: "Head Master gender",
    additionalDirectors: "Additional Directors",
    directorName: "Director Name",
    addDirector: "Add Director",
    male: "Male",
    female: "Female",
    phoneRequired: "Phone is required",
    showFeesParentPayment: "Show payment fees to parents",
    showInvoicesParentPayment: "Show payment invoices to parents",
    alertShowFeesParentPayment:
      "If enabled, parents will be able to see payment fees in the mobile application",
    alertShowInvoicesParentPayment:
      "If enabled, parents will be able to see payment invoices in the mobile application",
    rib20Digits: "The RIB must contain exactly 20 digits",
    tranches: "Terms",
    fraisMensuelle: "Monthly fees",
    addTranche: "Add a term",
    tranche: "Term",
    verifierTranches: "Check the terms fees",
    establishmentCode: "Establishment Code",
  },
  comptabilite: {
    comptabilite: "Accounting",
    fournisseur: "Provider",
    typeDepense: "Expense Type",
    tabDepenseTypes: "Expense types",
    tabDepenseCategories: "Categories",
    tabDepenseSubcategories: "Subcategories",
    tabAssociates: "Associates",
    tabUnites: "Units",
    tabCompanies: "Companies",
    companyLegalName: "Company name",
    companyCode: "Code",
    companyArchiveConfirm: "Archive this company?",
    companyArchived: "Company archived successfully",
    tabDebiteurs: "Debtors",
    tabDocumentDisplay: "Receipt / invoice display",
    documentDisplayIntro:
      "Configure how receipts and invoices are displayed for this school. Unconfigured options keep the default behaviour.",
    documentDisplayHeader: "Header",
    documentDisplayFooter: "Footer",
    documentDisplayPayment: "Payment and discounts",
    documentDisplayPrint: "Print",
    documentDisplayPreview: "Preview",
    previewDocument: "Preview",
    previewHint: "Click Preview to see the result with the current (unsaved) options.",
    showLogo: "Show logo",
    titleMode: "School title",
    titleModeDefault: "Default title",
    titleModeCustom: "Custom title",
    customTitle: "Custom title",
    includeSchoolTypeInTitle: "Include school type in the title",
    showClass: "Show class",
    showFooterText: "Show custom footer text",
    footerText: "Custom footer text",
    showCachetSignatureLabel:
      "Show “Stamp and signature” label (hidden when stamp image is shown)",
    showStamp: "Show stamp image",
    stampScale: "Stamp size",
    stampScaleHint: "Adjust the stamp image size on the PDF (0.5x to 2.5x).",
    showSignature: "Show signature area",
    showTuitionSummary: "Show tuition payment summary",
    showActivitySummary: "Show activity payment summary",
    paymentSummaryHint:
      "Total to pay, paid (debit) and unpaid (credit) months / installments for the school year.",
    showTableNote: "Display custom text below tables",
    tableNoteHint:
      "Printed exactly as entered in the white space right below the payment / summary tables (not in the footer).",
    tableNoteText: "Custom text",
    tableNoteColor: "Text color",
    tableNoteFontSize: "Text size",
    tableNoteAlign: "Text position",
    tableNoteAlignAuto: "Automatic (by language)",
    tableNoteAlignLeft: "Left",
    tableNoteAlignCenter: "Center",
    tableNoteAlignRight: "Right",
    showPaymentMethodDetails: "Show payment method details",
    showOnTransReduction: "Show discount on total",
    baseReductionDisplay: "Base discount display",
    baseReductionHidden: "Do not show",
    baseReductionTotal: "Show total discounts",
    baseReductionPercentPerLine: "Show % per line",
    copiesPerPage: "Print format",
    copiesPerPage1: "1 receipt / invoice per page (portrait)",
    copiesPerPage2:
      "2 copies on one landscape page (same document left and right)",
    autoPrint: "Auto-print receipt after payment",
    documentDisplayFiscal: "Fiscal (invoice)",
    tvaApplicable: "VAT applicable",
    showTva: "Show VAT on invoice",
    tvaRate: "VAT rate (fraction)",
    tvaRateHint:
      "Example: 0.07 for 7%. Leave empty to use the environment default.",
    timbreApplicable: "Fiscal stamp applicable",
    showTimbre: "Show stamp on invoice",
    timbreAmount: "Fiscal stamp amount",
    timbreAmountHint: "Leave empty to use the environment default.",
    retenueApplicable: "Withholding tax applicable",
    showRetenue: "Show withholding on invoice",
    retenuePercent: "Withholding tax (%)",
    retenuePercentHint:
      "Percent of TTC (same logic as supplier withholding).",
    documentNumbering: "Document numbering",
    numberFormatCustom: "Custom format",
    numberFormatCustomHint:
      "Off = current format (YYYYMM + 3 digits, e.g. 202609001). On = configurable prefix / date / sequence, independent for receipts and invoices.",
    numberFormatPrefix: "Prefix",
    numberFormatDatePattern: "Date format",
    numberFormatDateNone: "No date",
    numberFormatSeparator: "Separator",
    numberFormatPadding: "Sequence digits",
    numberFormatPattern: "Free pattern (optional)",
    numberFormatPatternHint:
      "Tokens: {PREFIX} {YYYY} {YY} {MM} {DD} {YYYYMM} {SEQ}. If EMPTY, the number is built from prefix + date + separator + sequence. Grey text in the field is only a placeholder, not a saved value — use the buttons below to apply a pattern.",
    numberFormatExample: "Next numbers: {example}",
    numberFormatStartNumber: "Starting number",
    numberFormatStartNumberHint:
      "Continue an existing numbering (e.g. last invoice FACT-2026-000598 → enter 599). Format and zero-padding are kept. If documents already exist beyond this number, the sequence continues after the last one, with no duplicates.",
    numberFormatTabReceipt:
      "Numbering for RECEIPTS only. Switch to the Invoice tab to configure invoices.",
    numberFormatTabInvoice:
      "Numbering for INVOICES only. Switch to the Receipt tab to configure receipts.",
    numberFormatSeparatorHint:
      "Used only when the free pattern is empty. Leave empty to concatenate prefix+date+sequence (e.g. ZOUI26001).",
    numberFormatPatternPlaceholder:
      "Empty = use prefix / date / separator above",
    numberFormatPresetParts: "Use prefix + date",
    numberFormatPresetYyyy: "Apply {PREFIX}-{YYYY}-{SEQ}",
    numberFormatPresetYyyymm: "Apply {PREFIX}-{YYYYMM}-{SEQ}",
    numberFormatSeqRequired:
      "The pattern must include {SEQ} so each document gets a unique number. It will be added automatically on save (e.g. …-{SEQ}).",
    numberFormatUnsafeChars:
      "Characters / \\ : * ? \" < > | cannot appear in a PDF file name: they will be replaced with \"-\" (e.g. ZOUI/x → ZOUI-x).",
    reference: "Reference",
    expenseKind: "Kind",
    expenseKindOpex: "OPEX",
    expenseKindCapex: "CAPEX (depreciation)",
    expenseKindOther: "Other",
    capexFormula: "Depreciation formula",
    description: "Description",
    category: "Category",
    categoryDeactivatedCascade:
      "Category archived. {subcategories} related sub-categories were also set to inactive.",
    categoryDeactivateConfirm:
      "Archive this category? All active sub-categories under it will also be set to inactive.",
    subcategory: "Subcategory",
    parentSubcategory: "Additional subcategory",
    direction: "Direction",
    directionNormal: "Normal",
    directionInverse: "Inverse",
    visibility: "Visibility",
    visibilityHint: "People or roles concerned (free text)",
    associateType: "Associate type",
    associateInternal: "Internal",
    associateExternal: "External",
    fullName: "Full name",
    unitKind: "Unit kind",
    unitPrincipal: "Primary",
    unitSecondary: "Secondary",
    companyName: "Company name",
    debtorName: "Debtor name",
    depenseTypeDeactivatedCascade:
      "Expense type archived. {categories} categories and {subcategories} sub-categories were also set to inactive.",
    depenseTypeDeactivateConfirm:
      "Archive this expense type? All active categories and their sub-categories under it will also be set to inactive.",
    deleteAllowed: "Delete",
    optional: "(optional)",
    typeRecette: "Revenue",
    nom: "Name",
    adresse: "Address",
    telephone: "Telephone",
    email: "E-mail",
    codeTVA: "TVA Code ",
    depenseParametrageNotice:
      "Use Delete to archive an item (status inactive). It disappears from these lists; data is kept for traceability.",
    noDeleteHint:
      "Delete archives the row (inactive); it no longer appears in this list.",
    planComptable: "Chart of accounts",
    accountingClass: "Class",
    accountingParentClass: "Parent class",
    accountingClassReference: "Class (Reference)",
    accountingClassPlaceholder: "Pick a class…",
    accountingClassHint:
      "Optional. Pick a class from the chart of accounts (e.g. 60 – Purchases).",
    accountingClassChildHint:
      "The final class is auto-generated from the selected parent class.",
    accountingClassParentMissing:
      "Parent category has no class yet. Set it first to auto-generate a child class.",
    accountingClassParentMissingShort: "Pick a parent class first.",
    accountingClassChangeBlocked:
      "Cannot change the class: child sub-categories already have a generated class. Reset them first.",
    accountingClassAutoGenerated: "Auto-generated",
    accountingClassAutoGeneratedHint:
      "The child code is allocated on creation from the category's class.",
    accountingClassNotAssigned: "No class",
    serviceClassMissing:
      "The parent service does not have a class yet. Set it first to auto-generate a class.",
    accountingClassAssign: "Assign a class",
    subCategory: "Sub-category",
  },
  decaissement: {
    expenseMode: "Expense mode",
    normal: "Normal",
    declaree: "Declared",
    beneficiaryType: "Beneficiary type",
    beneficiaryName: "Beneficiary name",
    companyEntity: "Group company",
    amortizationEmpty:
      "No provider invoices with CAPEX amortization for this school year.",
    amortizationFilterCategories: "CAPEX categories",
    amortizationFilterCategoriesPlaceholder: "All CAPEX categories",
    amortizationFullyAmortizedCount: "Fully amortized assets",
    amortizationKpiRemaining: "How much value do we still have?",
    amortizationKpiThisMonth: "How much depreciation this month?",
    amortizationStatusActive: "In progress",
    amortizationStatusComplete: "Fully amortized",
    amortizationTab: "Amortization",
    amortizationTableCost: "Cost basis",
    amortizationTableRemaining: "Remaining value",
    amortizationTableThisMonth: "This month",
    amortizationTableStatus: "Status",
    capexAmountColumn: "Amount",
    capexDepreciationPeriodMonths: "Depreciation period (months)",
    capexInvoiceDate: "Invoice date (for amortization)",
    capexJulyJuneHint:
      "Amortization is calculated by school-year windows (July to June).",
    capexMonthsColumn: "Months",
    capexSchedulePreview: "Amortization schedule (preview)",
    capexSchoolYearColumn: "School year",
    capexSectionTitle: "CAPEX amortization",
    capexCompleteAmountsFirst:
      "Enter the invoice amounts (HT, VAT, TTC) first; amortization appears below once the payable total is calculated.",
    invoiceNumber: "Invoice number",
    invoiceDate: "Invoice date",
    invoiceDateNotInFuture: "Invoice date cannot be in the future.",
    depenseCreatedAt: "Creation date",
    entryDateNotInFuture: "Entry date cannot be in the future.",
    description: "Description",
    amountTTC: "TTC amount",
    amountTVA: "TVA amount",
    amountAfterRetention: "Amount after retention",
    applyRetention: "Apply retention",
    attachment: "Attachment",
    paymentManagement: "Payment management",
    planPayment: "Schedule payment",
    payNow: "Immediate payment",
    totalToPay: "Total to pay",
    addSchedule: "Add schedule",
    fundSource: "Fund source",
    myCaisse: "My caisse",
    otherCaisse: "Other caisse",
    caisseBank: "Bank caisse",
    cashName: "Cash name",
    availableForThisPayment: "Available for this payment method",
    caisseBalanceExceedsAvailWarning:
      "This amount exceeds the available balance for the selected account (for this payment method).",
    receiptNumber: "Receipt number",
    methodReference: "Method reference",
    paymentSaved: "Payment saved successfully",
    missingRequiredFields: "Please fill in all required fields",
    activityOrServiceRequired: "Select an activity or a service",
    formSectionGeneral: "General information",
    formSectionDetails: "Expense details",
    formSectionAttachments: "Supporting documents and notes",
    formSectionPayment: "Payment or installments",
    formSectionPaymentHint:
      "Choose immediate payment or add at least one installment. Associate/employee declared expenses require installment totals to match the expense amount.",
    paymentTotalInvalid:
      "Enter a valid expense amount above before choosing how to pay.",
    validation: {
      expenseModeRequired: "Expense mode is required",
      invoiceDateRequired: "Invoice date is required",
      entryDateRequired: "Entry date is required",
      subCategoryRequired: "Subcategory is required",
      amountRequired: "Amount is required",
      amountMustBePositive: "Amount must be greater than zero",
      beneficiaryTypeRequired: "Beneficiary type is required",
      beneficiaryRequired: "Beneficiary is required",
      invoiceNumberRequired: "Invoice number is required",
      amountHTRequired: "Amount excluding tax is required",
      amountHTMustBePositive: "Amount excluding tax must be greater than zero",
      amountTTCRequired: "Amount including tax is required",
      amountTTCMustBePositive: "Amount including tax must be greater than zero",
      amountTVARequired: "VAT amount is required",
      capexPeriodRequired: "Depreciation period (months) is required",
      capexInvoiceDateRequired: "Capex invoice date is required",
      paymentCaisseRequired: "Select a cash register for payment line {n}",
      paymentBankRequired: "Select a bank/cash account for payment line {n}",
      scheduleDateRequired: "Installment {n} date is required",
      scheduleAmountRequired:
        "Installment {n} amount must be greater than zero",
      selectCaisse: "Select a cash register",
      selectCaisseBank: "Select a bank/cash account",
      checkHighlightedFields: "Check the highlighted fields in the form.",
    },
    duplicateInvoiceTitle: "Duplicate invoice",
    viewExistingInvoice: "View existing invoice",
    invoiceNotFoundForRedirect: "The existing invoice could not be found.",
    schedulesMustMatchInvoice:
      "Installment amounts must add up to the expense total exactly (same as the invoice amount).",
    formSubsectionBeneficiary: "Beneficiary",
    formSubsectionProvider: "Supplier details",
    formSubsectionAmount: "Amount details",
    activityPercent: "Share (%)",
    activityPercentTotal: "Total allocated",
    activityPercentSumMustBe100: "Activity percentages must add up to 100%.",
    activityDuplicate: "Each activity can only appear once.",
    addActivityAllocation: "Add another activity",
    activitySingleFullAmount:
      "100% of the expense is assigned to this activity.",
    activityAllocations: "Activities (split)",
    classRoom: "Tuition (classroom)",
    classRoomAllocations: "Tuition (split)",
    levels: "Levels",
    activityPlaceholder: "Select an activity (optional)",
    classRoomPlaceholder: "Select a classroom (optional)",
    addClassRoomAllocation: "Add a classroom",
    classRoomPercentTotal: "Classroom total allocated",
    classRoomPercentSumMustBe100: "Classroom percentages must total 100%.",
    classRoomDuplicate: "Each classroom can only appear once.",
    classRoomSingleFullAmount: "100% of the expense is assigned to this classroom.",
    combinedAllocationPercentTotal: "Tuition + Activity total",
    combinedAllocationPercentSumMustBe100:
      "Tuition and activity percentages must add up to 100%.",
    combinedAllocationSingleHint: "100% assigned to this item.",
    paymentMethod: {
      cash: "Cash",
      cheque: "Cheque",
      virement: "Transfer",
      prelevement: "Direct debit",
      traite: "Draft",
      tpe: "POS terminal",
      mixed: "Split payment",
    },
    directionInverse: "Inverse",
    directionInverseHint:
      "This subcategory is inverse: the school advances money and the beneficiary will repay later. Only immediate payment is available. The advance is deducted from the cash register only after manager validation (reconciliation).",
    repaymentSchedule: "Repayment schedule",
    repaymentScheduleHint:
      "Define when the beneficiary will repay the amount advanced by the school.",
    methodDetailsSumError:
      "The sum of detailed amounts must match the total payment amount",
    chequeNum: "Cheque No.",
    traiteNum: "Draft No.",
    chequeBank: "Bank",
    chequeTitulaire: "Holder",
    traiteRib: "RIB",
    virementNum: "Transfer No.",
    addCheque: "Add a cheque",
    addTraite: "Add a draft",
    addVirement: "Add a transfer",
    placeholderChequeNum: "Number",
    placeholderTraiteNum: "Number",
    placeholderDueDate: "DD/MM/YYYY",
    placeholderBank: "Bank",
    placeholderTitulaire: "Holder",
    placeholderRib: "20 digits",
    placeholderAmount: "0.000",
    placeholderVirementRef: "Reference",
    legendDebtRow: "Debt",
    legendDebtRowHint:
      "Rows with this background are linked to a debt (dette).",
  },
  fournisseur: {
    title: "Suppliers",
    companyName: "Company name",
    codeTVA: "TVA code",
    retenue: "Retention applied",
    website: "Website",
    category: "Category",
    subCategory: "Sub-category",
    archiver: "Archive",
    archived: "Archived",
    active: "Active",
    archivedNotice:
      "This supplier is archived and can no longer be selected for new expenses.",
    confirmArchive: "Are you sure you want to archive this supplier?",
    invoiceHistory: "Invoice history",
    creditNotesTitle: "Supplier credit notes (Avoir)",
    creditNotesEmpty: "No credit notes for this supplier",
    schedulingStatus: "Scheduling",
    invoiceStatus: "Invoice status",
    paid: "Paid",
    partial: "Partially paid",
    unpaid: "Unpaid",
    scheduled: "Scheduled",
    notScheduled: "Not scheduled",
    addSchedule: "Add schedule",
    editSchedule: "Edit schedule",
    deleteSchedule: "Delete schedule",
    confirmDeleteSchedule: "Are you sure you want to delete this schedule?",
    scheduleExceedsRemaining:
      "Total scheduled amount exceeds the remaining amount",
    cannotEditPaidSchedule: "Paid or cancelled schedules cannot be modified",
    dueDate: "Due date",
    scheduledAmount: "Scheduled amount",
    totalAmount: "Total amount",
    totalPaid: "Total paid",
    remaining: "Remaining",
    invoiceSummary: "Invoice summary",
    noSchedules: "No schedules for this invoice",
    scheduleCreated: "Schedule created successfully",
    scheduleUpdated: "Schedule updated successfully",
    scheduleDeleted: "Schedule deleted successfully",
    schedulesDisabledInvoicePaid:
      "You cannot add payment schedules when the invoice status is paid.",
    supplierArchived: "Supplier archived successfully",
    allSuppliers: "All suppliers",
    showArchived: "Show archived",
    searchPlaceholder: "Search by name, TVA code...",
    totalInvoices: "Total invoices",
    totalRemaining: "Total remaining",
    contactInfo: "Contact information",
    businessInfo: "Business information",
    financialOverview: "Financial overview",
    paymentBreakdown: "Payment breakdown",
    paymentProgress: "Payment progress",
    scheduleProgress: "Planning progress",
    scheduleDueToday: "next due today",
    scheduleDueInDays: "next due in {n} days",
    scheduleDueInMonths: "next due in {n} months",
    scheduleOverdueByDays: "overdue by {n} days",
    noData: "No data available",
  },
  factures: {
    title: "Invoices",
    filtersTitle: "Filters",
    searchPlaceholder: "Search label, reference, invoice no., description…",
    filterInvoiceStatus: "Payment status",
    filterSchedulingStatus: "Scheduling",
    filterBeneficiaryType: "Beneficiary type",
    filterExpenseMode: "Expense type",
    filterProvider: "Supplier",
    filterDateRange: "Invoice date",
    resetFilters: "Reset filters",
    detailTitle: "Invoice details",
    reference: "Reference",
    manageSchedules: "Payment schedules",
    goToPaymentEntry: "Payment entry",
    viewSupplier: "Supplier profile",
    attachments: "Attachments",
    attachmentCount: "{n} file(s)",
    noAttachments: "No attachments",
    beneficiaryProvider: "Supplier",
    beneficiaryAssociate: "Associate",
    beneficiaryEmployee: "Employee",
    beneficiaryCompany: "Group company",
    beneficiaryDebiteur: "Debtor",
    tableLabel: "Label",
    paginationTotal: "{total} invoice(s)",
    createNewDepense: "New expense",
    backToInvoiceList: "Back to invoices",
  },
  saisiePaiement: {
    title: "Payment entry",
    pending: "Pending",
    pendingSchedules: "Pending schedules",
    unplannedExpenses: "Unplanned expenses",
    paySelected: "Pay selected",
    groupPayment: "Group payment",
    duplicateSchedule: "Duplicate schedule",
    paymentExecuted: "Payment executed successfully",
    selectAtLeastOne: "Select at least one schedule",
    beneficiary: "Beneficiary",
    invoiceRef: "Invoice reference",
    dueDate: "Due date",
    amount: "Amount",
    selectFundSource: "Select fund source",
    selectMethod: "Select payment method",
    confirmPayment: "Confirm payment",
    totalSelected: "Total selected",
    addScheduleFromHere: "Add schedule",
    noUnplannedExpenses: "No unplanned expenses",
    noPendingSchedules: "No pending schedules",
    filterBeneficiaryType: "Beneficiary type",
    filterExpenseMode: "Expense mode",
    filterDueDateRange: "Due date range",
    expenseLabel: "Expense",
    expenseMode: "Mode",
    splitPaymentsHint:
      "Add one line per mode. Cash uses your main cash register only; cheque, transfer, draft and POS use a bank account. Amounts must add up to the total.",
    tableSearch: "Search",
    tableSearchPlaceholder:
      "Expense, beneficiary, invoice ref., beneficiary type, mode or amount…",
    paymentLine: "Payment line {n}",
    addPaymentLine: "Add a payment line",
    removePaymentLine: "Remove this line",
    splitsTotal: "Allocated total",
    splitsSumMismatch: "Allocated total must equal the selected total",
    lineAmountRequired: "Each line must have a positive amount",
    manageSchedules: "Manage installments",
    cannotLoadDepenseForSchedules:
      "Could not open schedule editor (missing expense data).",
    drawerDepenseSchedulesTitle: "Expense & payment schedules",
    depenseDetailsSection: "Invoice / expense details",
    schedulesEditHint:
      "Edit pending installments, add new lines, or delete them. The total scheduled amount must not exceed the expense total.",
    clickedScheduleBadge: "From list",
    batchPendingTotal: "Pending installments total",
    batchRequiredRemaining: "Required (invoice total minus paid)",
    batchSchedulesEmptyHint:
      "Add one or more lines. The total must match the required amount before saving.",
    unsavedSchedulesHint: "Save or cancel to select installments for payment.",
    batchSchedulesSaved: "Installment plan saved.",
    selectToPaySection: "Pay now (select installments)",
  },
  paiementHistory: {
    title: "Payment history",
    paymentDetail: "Payment detail",
    date: "Date",
    paymentMode: "Payment mode",
    immediate: "Immediate",
    scheduled: "Scheduled",
    status: "Status",
    validationStatus: "Validation status",
    method: "Method",
    fundSource: "Source",
    createdBy: "Created by",
    rejectedBy: "Rejected by",
    rejectedAt: "Rejected on",
    validatedBy: "Validated by",
    validatedAt: "Validated on",
    rejectionReasonMissing: "No rejection reason recorded",
    searchReceipt: "Search by receipt No.",
    dateRange: "Date range",
    noPayments: "No payments found",
    relatedInvoices: "Related invoices",
    schedules: "Related schedules",
    schedulesThisPayment: "Installments covered by this payment",
    otherSchedules: "Other scheduled installments",
    otherSchedulesHint:
      "Other installments on the same expenses (pending or paid separately).",
    debtLabel: "Debt label",
    debtRepaymentStatus: "Debt repayment",
    debtRemainingInstallments: "Remaining installments on this debt",
    debtNoRemainingInstallments:
      "No pending installments left on this debt (all paid or none scheduled).",
    expenseOrInvoice: "Expense / ref.",
    statuses: {
      completed: "Completed",
      pending: "Pending",
      cancelled: "Cancelled",
      awaiting_validation: "Awaiting validation",
    },
    validationStatuses: {
      pending_validation: "Pending",
      validated: "Validated",
      rejected: "Rejected",
    },
  },
  encaissementValidation: {
    title: "Receipt validation (inverse)",
    detailTitle: "Inverse schedule detail",
    searchPayeur: "Search by payer / label",
    filterBenType: "Beneficiary type",
    filterDateRange: "Due date range",
    colPayeur: "Payer",
    colLibelle: "Label",
    colMontant: "Amount",
    colDueDate: "Due date",
    colCreatedBy: "Created by",
    colDepensePaymentStatus: "Disbursement status",
    colStatut: "Status",
    statusPending: "Pending",
    statusReceived: "Received",
    statusCancelled: "Cancelled",
    confirm: "Confirm",
    confirmDisabledHint:
      "The disbursement must be validated in reconciliation before confirming receipt.",
    outboundPaymentNone: "No disbursement",
    confirmTitle: "Confirm payment receipt",
    paymentMethod: "Payment method",
    fundDestination: "Fund destination",
    receivedBy: "Received by",
    receivedAt: "Received on",
    noSchedules: "No inverse schedules found",
    depenseInfo: "Expense information",
    paymentInfo: "Received payment details",
    otherSchedules: "Other schedules on this expense",
    repaymentSchedules: "Repayment schedules (inverse)",
    repaymentComplete: "Repayment is complete",
    scheduleTotal: "Schedule amount to receive",
    splitPaymentsHint:
      "Add one line per payment mode. Amounts on all lines must add up to the schedule total. Each line can use a different cash register or bank account.",
    paymentLine: "Payment line {n}",
    addPaymentLine: "Add a payment line",
    removePaymentLine: "Remove this line",
    splitsTotal: "Allocated total",
    splitsSumMismatch: "Allocated total must equal the schedule amount",
    lineAmountRequired: "Each line must have a positive amount",
    pendingInverseSchedules: "Pending installments",
    editRepaymentSchedulesSection: "Repayment installments",
  },
  reconciliation: {
    title: "Reconciliation",
    pendingValidation: "Pending validation",
    validated: "Validated",
    rejected: "Rejected",
    rejectionReason: "Rejection reason",
    rejectionReasonRequired: "Rejection reason is required",
    paymentValidated: "Payment validated successfully",
    paymentRejected: "Payment rejected successfully",
    validatePayment: "Validate",
    rejectPayment: "Reject",
    confirmValidation: "Are you sure you want to validate this payment?",
    createdBy: "Created by",
    noPaymentsPending: "No payments pending validation",
    noPaymentsRejected: "No rejected payments",
    noPaymentsValidated: "No validated payments",
    noPaymentsFound: "No payments found",
    filterValidationStatus: "Validation status",
    filterPendingValidation: "Pending validation",
    filterValidatedOnly: "Validated only",
    filterRejectedOnly: "Rejected only",
    filterAllPayments: "All (pending, validated, rejected)",
    colPaymentType: "Type",
    colCaisseDebit: "Caisse debit",
    paymentTypeNormal: "Outbound",
    paymentTypeInverse: "Inverse",
    caisseDebitPending: "On validation",
    caisseDebitAlreadyApplied: "Already debited",
    validateModalTitle: "Validate payment",
    validateModalPaymentType: "Payment type",
    validateModalAmount: "Amount",
    validateModalInverseIntro:
      "Inverse expense: amounts will be deducted from cash registers when you validate.",
    validateModalInverseDebitList: "Deductions that will be applied:",
    validateModalInverseAlreadyDebited:
      "The amount has already been debited from the cash register. This validation confirms the operation.",
    validateModalNormalIntro:
      "This payment was already debited from the cash register when it was entered. Validation confirms the accounting operation.",
    splitLineSummary: "{method} — {amount} from {caisse}",
  },
  avoir: {
    title: "Credit notes",
    newCreditNote: "New credit note",
    pendingReception: "Pending reception",
    received: "Received",
    cancelled: "Cancelled",
    confirmReception: "Confirm reception",
    amountExceedsInvoice: "Amount exceeds invoice total",
    creditNoteCreated: "Credit note created successfully",
    receptionConfirmed: "Reception confirmed successfully",
    selectInvoice: "Select invoice",
    selectProvider: "Select supplier",
    receptionMethod: "Reception method",
    noCreditNotes: "No credit notes",
    depenseMissingForDetail: "Linked invoice could not be loaded for details.",
    invoiceAlreadyHasAvoir:
      "This invoice already has a credit note. Only one credit note per invoice is allowed.",
    invoiceNotFullyPaid:
      "You can only create a credit note for an invoice that is fully paid.",
    detailDrawerTitle: "Credit note details",
    detailSectionCreditNote: "Credit note",
    detailSectionReception: "Reception",
    detailSectionOriginalInvoice: "Original supplier invoice",
    detailSupplierLabel: "Supplier",
    detailSchoolYear: "School year",
    receptionValidatedAt: "Reception date",
    receptionValidatedBy: "Reception recorded by",
    totalReceived: "Total received",
    transferDestinationCaisse: "Destination cash register (after transfer)",
    receptionSplitLines: "Reception by payment method",
    splitDestination: "Destination",
    detailPendingReception:
      "This credit note is awaiting reception; payment methods will appear after confirmation.",
  },
  dette: {
    title: "Engagement Management",
    newDebt: "New debt",
    credit: "Credit",
    engagement: "Commitment",
    loan: "Loan",
    debtType: "Debt type",
    beneficiary: "Beneficiary",
    beneficiaryType: "Beneficiary type",
    associate: "Associate",
    debiteur: "Debtor",
    installmentAmount: "Installment amount",
    numberOfInstallments: "Number of installments",
    firstInstallmentDate: "First installment date",
    generateInstallments: "Generate installments",
    sumMismatch: "The sum of installments must equal the total amount",
    debtCreated: "Debt created successfully",
    depenseTemplate: "Expense template",
    installments: "Installments",
    debtInfo: "Debt information",
    totalAmount: "Total amount",
    noDebts: "No debts",
    debtDetail: "Debt detail",
    schedulePending: "Pending",
    schedulePaid: "Paid",
    scheduleCancelled: "Cancelled",
    paidOn: "Paid on",
    noSchedulesDetail: "No installments found for this debt.",
    nextPaymentEta: "Next installment",
    initialReceiptStep: "Fund receipt",
    initialReceiptHint:
      "Record how the borrowed amount enters your caisses (cash, cheque, bank). Totals must match the debt amount; lines appear in each caisse’s encaissement history.",
    initialReceiptDetail: "Initial fund receipt",
    receivedAt: "Received at",
    receivedBy: "Received by",
    encaissementLines: "Payment lines (splits)",
  },
  scolarite: {
    affichageParametrage: "Display settings",
    matieres: "Subjects",
    modules: "Modules",
    modulesSpec: "Specific modules",
    moduleType: "Module type",
    moduleName: "Module",
    nomModule: "Module name",
    affectationDansClasses: "Assignment in classes",
    affectationEnseignants: "Teacher assignment",
    enseignants: "Teachers",
    typePunitions: "Type of punishments",
    typeStudentDiscipline: "Type of Student Discipline",
    nom: "Name",
    customName: "Customized Name",
    coefficient: "Coefficient",
    listeMatieres: "Subjects List",
    listeModules: "Modules List ",
    infoModule:
      "Assigned subjects to modules in order to organize the management of grades !",
    listeModulesSpec: "List of specific modules",
    infoModuleSpec:
      "Assigned subjects to specific modules in order to organize the management of notes!",
    ajouterModule: "Add a module ",
    ajouterMatiere: "Add a subject",
    affectes: "Affected",
    nonAffectes: " Not Affected",
    recherche: "Search",
    element: "Element",
    aucunDonnee: " No data",
    modifierListeMatieres: "Edit the list of subjects of the module : {name}",
    modifierListeEnseignants: "Edit the list of class teachers : {name}",
    supprime: "Deleted",
    aucuneClasseTrouvee: "No class found",
    charcherParClasse: "Search by class name",
    afficherClassesSupprimees: "Show deleted classes",
    deletedClasses: "Deleted classes",
    activeClasses: "Active classes",
    other: "Other",
    confirmDeleteModule:
      "All sessions relating to this module will be deleted. This module is used in the classes below",
    certification: "Certification",
    appreciation: "Appreciation",
    modulesVerySpec: "Very specific Module",
    subsubjects: "Sub-subjects",
    subsubject: "Sub-subject",
    ajouterSubsubject: "Add a sub-subject",
    addNewSubsubject: "Manage sub-subjects",
    choisirSubsubject: "Choose a sub-subject",
    mark: "Maximum mark",
    listeModulesVerySpec: "List of very specific modules",
    infoModuleVerySpec:
      "Assigned subjects to very specific modules in order to organize the management of notes!",
    totalMarksMustBe20: "{subject}: The total of sub-subject marks must be 20",
    adminAppreciation: "Admin appreciation",
    subjectDejaExiste: "The subject already exists",
    SubSubjectDejaExiste: "This sub-subject already exists",
    cloneParam: "Clone a setting",
    schoolYear: "School year",
    selectSchoolYear: "Select school year",
    fromSchoolYear: "Source school year",
    toSchoolYear: "Target school year",
    selectParamToClone: "Select a setting to clone",
    duppModules: "Clone modules ",
    nombreElevesManquants: "Number of students missing grades",
    SubModuleDejaExiste: "This sub-module already exists",
    incompleteDataWarning:
      "Some subjects have incomplete configuration. Default values have been applied. Please review and save to fix.",
  },
  autorisation: {
    accueil: "Home",
    admin: "Admin",
    designation: "Designation",
    compteAdmin: " Admin Account",
    dossierMedical: "Medical report",
    listeEleves: "Students List",
    parametrage: "Settings",
    activite: "Activity",
    administration: "Administration",
    scolarite: "Schooling",
    personnel: "Personnel",
    personnels: "Personnels",
    comptabilite: "Accounting",
    declarations: "Declarations",
    paiements: "Payments",
    medicalNote: "Medical Note",
    medicalNoteContext:
      "Parents can view and edit their children's medical notes.",
    noteForTeachers: "Medical notes for Teachers",
    noteForTeachersContext:
      "Parents can view and edit their children's notes for teachers.",
    modifierFraisClasse: "Edit classroom fees",
    modifierFraisClasseHint:
      "Allows overriding fees on a normal classroom (otherwise inherited from the level).",
    decaissementLegacyAccess: "Decaissement — full access (legacy)",
  },
  utilisateur: {
    listeUtilisateur: "Users list",
    nom: "Name",
    role: "Role",
    acces: "Access to establishments",
    actif: "Active",
    nonActif: "Not active",
    mdp: "Password",
    activerDesactiver: "Enable/Disable",
    confirmerMdp: "Confirm Password",
    changerMdp: "You can change the password",
    active: "Active",
    nonActive: "inactive",
    desactiverAlert: "Do you want to deactivate this user?",
    activerAlert: "Do you want to activate this user?",
    userDesactive: "User disabled!",
    userActive: "User activated!",
    passwordAgain: "Please enter the password again",
    passwordMatch: "The inputs do not match!",
    sessions: "Sessions",
    sessionOnline: "Online",
    sessionOffline: "Offline",
    viewSessions: "View ({count})",
    activeSessionsFor: "Active sessions — {user}",
    device: "Device",
    unknownDevice: "Unknown device",
    ipAddress: "IP address",
    sessionSource: "Source",
    lastActive: "Last active",
    expiresAt: "Expires",
    actions: "Actions",
    withActiveSessions: "With sessions",
    allUsersFilter: "All users",
    restricted: "Restricted",
    sessionScopeDenied:
      "You need access to every building assigned to this user.",
    revokeSession: "Revoke",
    revokeSessionConfirm: "Revoke this session?",
    revokeSessionSuccess: "Session revoked.",
    revokeAllSessions: "Revoke all sessions",
    revokeAllSessionsConfirm:
      "Revoke every session and immediately log this user out?",
    revokeSessionsSuccess: "All user sessions were revoked.",
    revokeSessionsError: "Could not revoke user sessions.",
    loadSessionsError: "Could not load user sessions.",
  },
  parentalControl: {
    changeUserName: "Change username",
    disableAccount: "Disable Parent's account",
    enableAccount: "Enable Parent's account",
    parentQrCode: "Parent's QR code",
    accountActive: "Account activated, the user can access the application.",
    accountInactive:
      "Account deactivated, the user cannot access the application.",
  },
  liste: {
    searchStudent: "Search for a student",
    searchBy: "You can search by",
    listeElevesArchive: "Archived students list",
    reactive: "Reactivate",
    showSchoolLogo: "Show the school logo",
    showGovLogo: "Show the ministry logo",
    reasonArchive: "Reason for archiving",
    addFiles: "Add files",
    studentPhoto: "Student's avatar",
    studentFiles: "Student's files",
    consulterProfil: "Consult the profile for more details",
    nomPrenom: "Last and first name",
    fullName: "Full name",
    photoMediaConsent: "Photo & media consent (parent)",
    photoMediaConsentFilterLabel: "Student photo & media consent",
    photoMediaConsentAll: "All",
    photoMediaConsentAccepted: "Accepted",
    photoMediaConsentRefused: "Refused",
    photoMediaConsentPending: "Not answered",
    scolarite: "Schooling",
    ficheParent: "Parent Sheet",
    attestation: "Presence certificate",
    inscription: "Registration",
    supprimerAnnuler: " Delete / Cancel",
    inscriSupprimer: "Registration / Delete",
    filles: "Girls",
    garcons: " Boys",
    total: "Total",
    nonInscrits: "Non-registered",
    inscrits: " Registered",
    parents: "Parents",
    pere: "Father",
    mere: "Mother",
    guardian: "Guardian",
    enfants: "Children",
    email: "Email",
    ajouterEleve: " Add a student",
    nouveauPaiement: "New payment",
    ajouterDossier: "Add a document",
    ajouterPersonnel: "Add a personnel",
    ajouterEnseignant: "Add a teacher",
    listeEleves: "Students List",
    administration: "Administration",
    tranches: "by terms",
    toutesTranches: "All terms",
    nom: "Name",
    prenom: "First name",
    notes: "Grades",
    dateNaissance: "Date of Birth",
    sexe: "Sex",
    adresse: "Address",
    telephone: "Telephone",
    classes: "Classes",
    ajouterParent: "Add a parent",
    ajouterParentSansEleveHint:
      "Create a parent account without adding a student. You can link this parent to a student from the student profile afterward.",
    parentsExis: "Existing parents",
    ficheParents: "Parents sheet",
    nomMere: "Mother's first name",
    prenomMere: "Mother's last name",
    emailMere: "Mother's email",
    adresseMere: "Mother's address",
    adressePere: "Father's address",
    emailPere: "Father's email",
    telMere: "Mother's phone",
    nomPere: "Father's first name",
    prenomPere: "Father's last name",
    telPere: "Father's phone",
    metierPere: "Father's job",
    metierMere: "Mother's job",
    cinPere: "Father's National ID (CIN)",
    cinMere: "Mother's National ID (CIN)",
    cinGardian: "Guardian's National ID (CIN)",
    gardianName: "Guardian's name",
    gardianAdress: "Guardian's address",
    gardianFirstName: "Guardian's first name",
    gardianPhone: "Guardian's phone",
    gardianJob: "Guardian's job",
    adresseParents: "Address",
    emailParents: "E-mail ",
    reduction: "Reduction on the registration fees",
    reductionMensuel: "Discount on the monthly fees",
    identifiantUnique: "Unique identifier",
    regionalEducation: "Regional Education Commission",
    recuEn: "Received in",
    nonInscrit: "NOT ENROLLED",
    freresSoeurs: "Brothers & sisters list",
    studentFullName: "Student name",
    brotherSister: "Brother / Sister",
    brother: "Brother",
    sister: "Sister",
    parentFullName: "Parent name",
    classe: "Class",
    siblingGroups: "family groups",
    noSiblingGroups: "No brothers and sisters groups found",
    changementNonEffectue: "No change",
    champsVides: "Input fields cannot be empty",
    imprimerLoginsEnsg: "Teacher logins",
    fichePersonnel: "Personnel Record",
    nombreEnfants: "Number of children",
    situationFamiliale: "Financial status",
    dateEntree: "Entry date",
    etablissementPrecedent: "Previous institution",
    dateSortie: "Exit date",
    motifSortie: "Exit reason",
    documents: "Documents",
    motivation: "Motivation",
    nombreInscriptions: "Number of registrations",
    accompanyingDocuments: "Accompanying documents",
    secondarySchool: "Secondary school",
    previousInstitution: "Previous institution",
    behavior: "Behavior",
    attendance: "Attendance",
    includePhoto: "Student Photo",
    generatePdfAnyway: "Generate PDF anyway",
    studentsWontAppearInPdf:
      "The following students will not appear in the PDF because their parents do not have login credentials:",
    studentsWithoutLogin: "Students without login credentials",
    studentsWithoutLoginInfo:
      "The following students do not have login credentials but will appear in the PDF:",
    qrCodeErrorWarning: "QR Code Generation Problem",
    qrCodeErrorDescription:
      "These users had problems generating their QR codes. You can print them individually from their profile.",
    parentLogins: "Parents logins",
    printSelectionMode: "Print by",
    fraisTranches: "Fees by terms",
    paymentMode: "The selected payment mode is",
    tranches: "by terms",
    mensuelle: "monthly",
    generated: "Generated on:",
    listBadges: "List of badges",
    concInfo: "Connection information",
    elevesAssocies: "Associated students",
    linkConnection: "Connection link",
    linkConnectiontext: "or Mobile EdParent application",
    attestationInscription: "Enrollment certificate",
  },
  cantine: {
    cantine: "Canteen",
    dateChoisie: "Chosen Date",
    choisirDate: "Choose a date to insert the menu",
    ajouterRepas: "Add a meal",
    ajouterMenu: " Add a new menu for ",
    choisirJour: "Choose days",
    mealName: "Meal Name",
    type: " Type",
    repeter: " Repeat ",
    saisirNom: " Enter the name of the meal",
    saisirType: "Choose the type of meal",
    saisirEndDate: "Enter the end date",
    plat: " Dish",
    entree: "Starter",
    goute: "Snack",
    boissons: " Drinks",
    autre: "Others",
    dessert: "Dessert",
    menuIntrouvable: "Menu not found, please add meals!",
    ajouterNewMenu: "Add new menu for {date}",
    modifierMenu: "Edit menu {name}",
    saisirDateFin: "Enter the end date",
    addSuccessMessage: "A meal is added.",
    editSuccessMessage: "A meal is edited.",
    errorMessage: "An error occurred in the modification!",
    errorMessageAdd: "An error occurred in the addition!",
    ajouterMenuHebdo: "Add weekly menu",
    nomMenu: "Menu name",
    saisirNomMenu: "Enter the menu name",
    descriptionMenu: "Description",
    saisirDescriptionMenu: "Enter a description of the menu",
    dateDebut: "Start date",
    saisirDateDebut: "Enter the start date",
    endDateAvantDebut: "The end date must be on or after the start date",
    joursWeekend: "Weekend days",
    inclureSamedi: "Include Saturday",
    inclureDimanche: "Include Sunday",
    imageMenu: "Menu image",
    menusHebdo: "Weekly menus",
    repasDuJour: "Meals of the day",
    aucunMenuHebdo: "No weekly menu for this date",
    samediEtDimancheInclus: "Saturday & Sunday included",
    modifierMenuHebdo: "Edit weekly menu {name}",
    menuHebdoAjoute: "Weekly menu added.",
    menuHebdoModifie: "Weekly menu updated.",
    menuHebdoSupprime: "Weekly menu deleted.",
    erreurSuppressionMenuHebdo: "An error occurred while deleting the weekly menu!",
    apercu: "Preview",
    samediInclus: "Saturday included",
    dimancheInclus: "Sunday included",
    joursSemaineSeulement: "Weekdays only",
  },
  paiement: {
    reducation: "Discount",
    reducationRep: "Repetitive Discount",
    reducationDefault: "Default Discount",
    reductionBase: "Base discount",
    selectMonths: "Select months",
    avoir: "Refund",
    note: "Note",
    paiementClasse: "Payment/Class",
    nom: "Student's first name",
    prenom: "Student's last name",
    classe: "Class",
    parents: "Parents",
    tels: "Telephones",
    etat: "Payment Status",
    fraisInscri: "Registration Fees",
    fraisMensuel: "Monthly Fees",
    dateDebut: " Start date",
    dateFin: "End date",
    tousMois: "All months",
    mois: "Month",
    tousClasses: "All classes",
    order: "Order",
    service: "Service",
    nbEleves: "Number of students",
    listeClasses: " Classes List",
    listeEleves: "Students List",
    imprimerTab: "Print table",
    selectionnerMois: "Select month",
    paye: "Paid",
    inscriPaye: "Paid Registratiion",
    inscriNonPaye: "Unpaid Registration",
    impaye: "Unpaid",
    partiel: "Partially paid",
    selectionnerDate: "Select a date",
    reduction: "Discount on registration",
    reductionMensuel: "Monthly discount",
    activite: "Activity",
    annulation: "Cancellation",
    annulationSuccess: "Cancellation completed successfully",
    listeActivites: "Activities List",
    filtrerParStatut: "Filter by status:",
    activiteSupprimee: "Deleted activities",
    activiteActive: "Active activities",
    actives: "Active",
    toutes: "All",
    dt: " TND",
    non: "No",
    chercher: "Search",
    annulerInscri: "Do you want to cancel the registration?",
    eleveRequis: "At least one student is required",
    classRequis: "At least one class is required",
    activiteRequis: "The activity is required",
    activitesTypeDifferent:
      "You can only select activities of the same type (Daily or Monthly/Term)",
    tagActiviteJournaliere: "Daily",
    tagActiviteMensuelleTranche: "Monthly/Term",
    inscriptionEchecPourActivite: "Registration failed for activity",
    inscriptionReussitePourActivites:
      "Registration successful for {count} activity(ies)",
    dateDebutRequis: "The start date is required",
    dateFinRequis: "The end date is required",
    msgReduction: "Set reduction to zero if you don't want to add reduction",
    typeDepense: "The type of expense is required",
    eleve: "Student is required",
    totalPaiements: "Total payments",
    totalMontant: "Total amount",
    lignes: "lines",
    paymentMode: "The selected payment mode is",
    etatPaiementsPourMois: "Payment status for the month",
    etatPaiementsTousMois: "Payment status for all months",
    num: "No.",
    paymentStatusActivity: "Activity_payment_status",
    paymentStatusScolarite: "Payment_status_scolarite",
    totalInscriptions: "Total admissions",
    trancheLabel: "Term",
    inscriptionLabel: "Admission",
    title: "Payment entry",
    pendingSchedules: "Pending schedules",
    unplannedExpenses: "Unplanned expenses",
    invoiceRef: "Invoice reference",
    beneficiary: "Beneficiary",
    dueDate: "Due date",
    amount: "Amount",
  },
  inscription: {
    nom: "Fullname",
    dateNaissance: "Date of birth",
    sexe: "Sex",
    tels: "Telephone",
    parent: "Parent",
    nouvInscri: "New registration",
    nbEleves: "Number of students : {number}",
    ficheParentClasse: "Class sheet / parent",
    ficheClasse: "Class sheet",
    confirmEnrollmentTooltip:
      "Enrollment for class {name} will be available to parents",
    cancelEnrollmentConfirmationTooltip:
      "Enrollment for class {name} will no longer be available to parents",
    enrollmentVisibleTag: "Available to parents",
    enrollmentHiddenTag: "Unavailable to parents",
    enrollmentVisibleTooltip:
      "Enrollment for class {name} is available to parents",
    enrollmentHiddenTooltip:
      "Enrollment for class {name} is unavailable to parents",
    enrollmentAllVisibleTooltip:
      "Enrollment for all classes is available to parents",
    enrollmentAllHiddenTooltip:
      "Enrollment for all classes is unavailable to parents",
    confirmAllClassesBtn: "Make all classes available to parents",
    cancelAllConfirmationBtn: "Make all classes unavailable to parents",
    confirmAllClassesContent:
      "Enrollment for all classes will be available to parents.",
    cancelAllConfirmationContent:
      "Enrollment for all classes will no longer be available to parents.",
    enrollmentConfirmedMsg:
      "Enrollment for class {name} is now available to parents",
    enrollmentUnconfirmedMsg:
      "Enrollment for class {name} is no longer available to parents",
    allClassesConfirmedMsg:
      "Enrollment is now available to parents for all classes",
    allClassesUnconfirmedMsg:
      "Enrollment is no longer available to parents for all classes",
    inscription: "Registration",
    enfant: "Child",
    fraisInscri: "Registration fees",
    fraisMensuel: "Monthly Fees",
    remise: "Discount ",
    remiseInscri: "Discount on registration",
    remiseMensuel: "Monthly Discount",
    rechercher: "Search",
    mensuel: "Monthly",
    chercherParActivite: "Search by activity name",
    sureToInscri: "Are you sure you want to register this student?",
    downloadTitle: "Download student list by activity",
    activityListSelectColumnsHint:
      "Choose the student information to include in the activity list.",
    noStudentInActivity: "No students registered in the following activities",
    unableToGeneratePdf:
      "Unable to generate the PDF - No students registered in the selected activities",
    selectionnerModePaiement: "Select payment mode",
    fraisDesTranches: "Term fees",
    tranche: "Term",
    lesFraisAPayer: "Fees to pay",
    modePaiementSelectionne: "The selected payment mode is",
    parTranches: "by terms",
    mensuelle: "monthly",
    frais: "Fees",
    inclus: "Included",
    selectionnerJours: "Select days",
    selectionnerAuMoinsUnJour:
      "Please select at least one day for this daily activity",
    ajouterDate: "Add a date",
    ajouter: "Add",
    aucuneDateSelectionnee: "No dates selected",
    datesSelectionnees: "Selected dates",
    toutEffacer: "Clear all",
    selectionnerTranches: "Select terms",
    tranchesSelectionnees: "Selected terms",
    selectionnerMois: "Select months",
    moisSelectionnes: "Selected months",
    elementsSelectionnes: "Selected elements",
    changeClassroom: "Change class",
    studentsList: "Students list registered in the activity",
    activityList: "Activity_list",
    num: "N°",
    ecolePrimairePrivee: "Private primary school",
    formulaireParent: "Parent form",
    anneeScolaireLabel: "School year",
    numero: "Number",
    nomPrenom: "Full name",
    nomParent: "Parent's name",
    telephone: "Phone",
    delegeRegionalEducation: "Regional Education Authority",
    ficheParentPDF: "Parent_Form",
    nonDisponible: "Not available",
    classe: "Class",
    pere: "Father",
    mere: "Mother",
    identifiantUnique: "Unique identifier",
    nomComplet: "Full name",
    garcon: "Boy",
    fille: "Girl",
    nombreTotal: "Total number",
    nombreGarcons: "Number of boys",
    nombreFilles: "Number of girls",
    listeElevesPDF: "Student_list",
    installmentFees: "Installment fees",
    installment: "Installment",
    selectedPaymentMode: "The selected payment mode is",
    byInstallments: "by installments",
    fees: "Fees",
    included: "Included",
    discount: "Discount",
    changeGroup: "Change Group",
    monthlyPayment: "Monthly payment",
    installmentPayment: "Payment by installment",
    paymentMode: "Payment mode",
    monthly: "Monthly",
    byInstallment: "By installment",
    globalStatus: "Global status",
    notSpecified: "Not specified",
    sureToCancel: "Sure to cancel?",
    sureToDelete: "Sure to delete?",
  },
  buildingType: {
    jardinEnfantsPrive: "Private kindergarten",
    ecolePrimairePrivee: "Private primary school",
    collegePrive: "Private middle school",
    lyceePrive: "Private high school",
    collegeLyceePrives: "Private middle and high school",
    collegeEcolePrives: "Private primary and middle school",
    jardinEnfantEcolePrives: "Private kindergarten and primary school",
    jardinEnfantCollegePrives: "Private kindergarten and middle school",
    jardinEnfantLyceePrives: "Private kindergarten and high school",
    ecoleLyceePrives: "Private primary and high school",
    jardinEnfantEcoleCollegePrives:
      "Private kindergarten, primary and middle school",
    jardinEnfantCollegeLyceePrives:
      "Private kindergarten, middle and high school",
    jardinEnfantEcoleLyceePrives:
      "Private kindergarten, primary and high school",
    jardinEnfantEcoleCollegeLyceePrives:
      "Private kindergarten, primary, middle and high school",
    collegeEcoleLyceePrives: "Private primary, middle and high school",
    ecolePrivee: "Private school",
    // Kenya school types
    preSchoolPrive: "Private pre-school",
    prePrimaryPrive: "Private lower primary",
    middlePrive: "Private upper primary",
    juniorPrive: "Private junior secondary",
    seniorPrive: "Private senior school",
    prePrimaryMiddlePrives: "Private lower primary and upper primary",
    prePrimaryJuniorPrives: "Private lower primary and junior secondary",
    prePrimarySeniorPrives: "Private lower primary and senior school",
    middleJuniorPrives: "Private middle and junior secondary",
    middleSeniorPrives: "Private upper primary and senior school",
    juniorSeniorPrives: "Private junior and senior secondary",
    prePrimaryMiddleJuniorPrives:
      "Private lower primary, middle and junior secondary",
    prePrimaryMiddleSeniorPrives:
      "Private lower primary, upper primary and senior school",
    prePrimaryJuniorSeniorPrives:
      "Private lower primary, junior and senior secondary",
    middleJuniorSeniorPrives: "Private middle, junior and senior secondary",
    prePrimaryMiddleJuniorSeniorPrives:
      "Private lower primary, upper primary, junior and senior school",
    preSchoolPrePrimaryPrives: "Private pre-school and lower primary",
    preSchoolMiddlePrives: "Private pre-school and upper primary",
    preSchoolJuniorPrives: "Private pre-school and junior secondary",
    preSchoolSeniorPrives: "Private pre-school and senior school",
    preSchoolPrePrimaryMiddlePrives:
      "Private pre-school, lower primary and upper primary",
    preSchoolPrePrimaryJuniorPrives:
      "Private pre-school, lower primary and junior secondary",
    preSchoolPrePrimarySeniorPrives:
      "Private pre-school, lower primary and senior school",
    preSchoolMiddleJuniorPrives:
      "Private pre-school, upper primary and junior secondary",
    preSchoolMiddleSeniorPrives:
      "Private pre-school, upper primary and senior school",
    preSchoolJuniorSeniorPrives:
      "Private pre-school, junior and senior secondary",
    preSchoolPrePrimaryMiddleJuniorPrives:
      "Private pre-school, lower primary, upper primary and junior secondary",
    preSchoolPrePrimaryMiddleSeniorPrives:
      "Private pre-school, lower primary, upper primary and senior school",
    preSchoolPrePrimaryJuniorSeniorPrives:
      "Private pre-school, lower primary, junior and senior secondary",
    preSchoolMiddleJuniorSeniorPrives:
      "Private pre-school, upper primary, junior and senior secondary",
    preSchoolPrePrimaryMiddleJuniorSeniorPrives:
      "Private pre-school, lower primary, upper primary, junior and senior school",
  },
  punition: {
    eventTime: "Event Time",
    createdBy: "Created by",
    eleve: "Student",
    nom: "Last Name",
    prenom: "First Name",
    details: "Details",
    seenByParents: "Seen by parents",
    noParentSeen: "No parent has viewed this punishment yet.",
    notVisibleToParents: "Hidden from parents",
    notVisibleToParentsHint:
      "Only validated punishments are visible to parents.",
    punition: "Punishment",
    studentDiscipline: "Student Discipline",
    studentDisciplineList: "Student Discipline List",
    temps: "Time",
    raison: "Reason",
    description: "Description",
    validation: "Validation",
    valides: "Validated",
    rejetes: "Rejected",
    nonEvalues: "Not reviewed",
    dateAjout: "Added date",
    dateEvalution: "Review date",
    valider: "Validate",
    rejeter: "Reject",
    rejectReason: "The reason for the punishment rejection",
    rejectReasonDiscipline: "The reason for the student discipline rejection",
    reasonRequired: "Reason for the rejection is required",
    typeRequired: "Punishment type is required",
    typeRequiredDiscipline: "Student discipline type is required",
    autoValidationMessage:
      "This punishment will be automatically validated. Do you want to continue?",
    autoValidationMessageDiscipline:
      "This student discipline will be automatically validated. Do you want to continue?",
    pendingValidationMessage:
      "This punishment will remain pending until it is validated by an administrator. Do you want to continue?",
    pendingValidationMessageDiscipline:
      "This student discipline will remain pending until it is validated by an administrator. Do you want to continue?",
    errorLoadingPunishments: "Error loading punishments",
    errorLoadingDisciplines: "Error loading student disciplines",
    noPunishmentTypeFound: "No punishment type found",
    noDisciplineTypeFound: "No student discipline type found",
    timeRequired: "Event time is required",
  },
  days: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
  },
  emploi: {
    hideTeacherUpdated: "Teacher hidden successfully",
    hideEmploi: "Schedule will not be available to parents",
    validateEmploi: "Schedule will be available to parents",
    validatedClassroom: "Schedule will be available to parents",
    hideTeacher: "Hide teacher",
    validated: "Schedules are now available for the class: {name}",
    unvalidated: "Schedules are now unavailable for the class: {name}",
    hideEmploin:
      "The schedule of this class will no longer be available to parents",
    validateEmploin: "The schedule of this class will be available to parents",
    emplois: "Timetables",
    temps: "Times",
    choisirTemps: "Choose time",
    trimestre: "Term",
    listeClasses: "Classes List",
    listeEnseignants: "Teachers List",
    emploiEnseignants: " Teachers timetables ",
    imprimerEmploi: "  Print the timetable ",
    imprimerEmploiAdministrative: "Print the administrative timetable",
    pdfRepublique: "Tunisian Republic - Ministry of Education",
    pdfDelegation: "Regional Delegation of {delegation}",
    pdfDelegationKE: "Country Location: {delegation}",
    pdfAnnee: "School Year: {year}",
    pdfImprime: "Printed on: {date}",
    pdfEcole: "Private Primary School: {name}",
    pdfEmploi: "Timetable for {className}",
    pdfEmploiTeacher: "Timetable for {teacher}",
    pdfEmploiAdmin: "Administrative Timetable",
    enseignant: "Teacher",
    matiere: "Subject",
    salle: "Class",
    duree: "Duration",
    classe: "Class",
    choisirEnseignant: "Choose a teacher ",
    choisirMatiere: "Choose a subject",
    choisirSalle: "Choose a classroom ",
    choisirDuree: "Choose a duration",
    choisirClasse: "Choose a class",
    ajouterSeance: "Add a session",
    addSession: "Add Session",
    modifierSeance: "Edit a session ",
    disponible: "Available",
    indisponible: "Unavailable",
    modeModif: "Modification mode is activated!",
    desc: "You can modify the location and the duration of the sessions!",
    totaleHeures: "Total Hours",
    moyenneHeuresJour: "Average Hours/day",
    maximunHeuresJour: "Maximum Hours/day",
    totaleClasses: "Total classes",
    totaleTeachers: "Total teachers",
    seance: "Session",
    seanceListe: "Session list",
    choisirName: "Write a session name",
    name: "Session name",
    includedSubjects: "Teacher can access",
    selectedTime: "Selected Time",
    selectedDay: "Selected Day",
    selectedClass: "Selected Class",
    group: "Group",
    groupOption: "Select a group",
    fullClass: "Full Class",
    week: "Week",
    weekLabel: "Week",
    weekOption: "Select a week",
    weekBoth: "Both weeks",
    weekA: "Week A",
    weekB: "Week B",
    modulesPedagogiques: "Pedagogical Modules",
    modulesPilotes: "Pilot Modules",
    additionalSubject: "Additional Subject",
    pedagogicalModule: "Pedagogical Module",
    pilotModule: "Pilot Module",
    today: "Today",
    month: "Month",
    day: "Day",
    startTime: "Start Time",
    duration: "Duration",
    subject: "Subject",
    room: "Room",
    notes: "Notes",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    durationFormat: "{hours} H {minutes} m",
    pleaseSelectDay: "Please select a day",
    pleaseSelectStartTime: "Please select start time",
    pleaseSelectDuration: "Please select duration",
    pleaseSelectSubject: "Please select a subject",
    pleaseSelectTeacher: "Please select a teacher",
    pleaseSelectRoom: "Please select a room",
    selectDay: "Select a day",
    selectStartTime: "Select start time",
    selectDuration: "Select duration",
    selectSubject: "Select a subject",
    selectTeacher: "Select a teacher",
    selectRoom: "Select a room",
    selectGroup: "Select a group",
    addNotes: "Add notes",
    updateSessionOptions: "Update Options",
    updateSessionQuestion: "How would you like to update this session?",
    updateSessionDescription:
      "Choose whether you want to update only this session or all similar sessions.",
    updateOnlyThis: "Update only this session",
    updateOnlyThisDescription: "Only this session will be modified.",
    updateAllSimilar: "Update all similar sessions",
    updateAllSimilarDescription:
      "All sessions with the same characteristics will be updated.",
    updateDuration: "Update Duration",
    untilEndOfYear: "This session and all following sessions",
    untilEndOfYearDescription:
      "Update this session and every following session until the end of the school year.",
    wholeSchoolYear: "All sessions of the school year",
    wholeSchoolYearDescription:
      "Update every session of the school year, including past sessions.",
    customDuration: "Custom duration",
    customDurationDescription: "Choose a specific duration in months.",
    enterDurationMonths: "Enter duration in months",
    durationInMonths: "Duration in months (1-12)",
    enterValidDuration: "Please enter a valid duration",
    sessionPreview: "Session Preview",
    sessionName: "Session Name",
    sessionTime: "Session Time",
    teacher: "Teacher",
    selectEndDate: "Select end date",
    selectEndDateDescription: "Choose the end date for bulk updates",
    selectedDate: "Selected date",
    restoreSession: "Restore Session",
    restoreSessionConfirm: "Are you sure you want to restore this session?",
    cancelSessionWarning: "Cancel Session",
    cancelSessionDescription:
      "This will cancel the session and all its occurrences",
    cancellationReason: "Cancellation Reason",
    cancelUntil: "Cancel Until",
    cancelUntilDescription: "Choose the date until which to cancel the session",
    sessionDetails: "Session Details",
    confrimCancel: "Confirm Cancellation",
    cancellationReasonRequired: "Cancellation reason is required",
    deleteSession: "Delete Session",
    deleteSessionQuestion: "Do you want to delete this session?",
    deleteSessionOptions: "Choose an option:",
    deleteRecuring: "Delete Recurring Sessions",
    deleteOnlyThis: "Delete only this session",
    cancelSession: "Cancel Session",
    confirmCancel: "Confirm Cancellation",
    enterCancellationReason: "Enter cancellation reason",
    selectCancelUntilDate: "Select cancel until date",
    cancelUntilRequired: "Cancel until date is required",
    cancelUntilCannotBePast: "Cancel until date cannot be in the past",
    deleteRecurring:
      "Delete this session and all similar recurring sessions (past and future)",
    sessionCanceled: "Session canceled",
    unvalidatedClassroom:
      "The timetable will no longer be available to parents",
    chooseSubmodule: "Choose a sub-module",
  },
  bulletin: {
    bulletins: "Bulletins",
    annualReport: "Annual report",
    displayOptions: "Display options",
    teachersByClassroom: "Teachers (per class)",
    showDate: "Show date",
    configSaved: "Configuration saved",
    pvAnnuel: "Annual PV",
    ficheNotes: "Notes sheet",
    exporterExcel: "Export Excel",
    imprimerPV: "Print PV",
    imprimerConseilClasse: "Print class council PV",
    imprimerPVParNiveau: "Print PV by grade",
    notesWillBeDeleted: "These grades will be deleted",
    loading: "Loading...",
    deletingNotes: "Deleting grades...",
    classroom: "Class",
    numberOfAffectedNotes: "Number of affected grades",
    student: "Student",
    subjects: "Subjects",
    duplicateSettings: "Duplicate Settings",
    source: "Source",
    targets: "Target(s)",
    parameters: "Parameters",
    templates: "Templates",
    schoolYear: "School Year",
    selectSchoolYear: "Select school year",
    selectTemplate: "Select a template",
    selectTypes: "Select types",
    selectLevels: "Select grades",
    selectTrimesters: "Select terms",
    allDataDuplicatedSuccess: "All data has been duplicated successfully",
    pleaseRefreshPage: "please refresh the page to see the complete effect",
    duplicationHappened:
      "A parameter duplication action has occurred, please refresh the page to see the complete effect",
    configureDisplay: "Configure Display",
    generalConfiguration: "General Configuration",
    studentName: "Student Name",
    className: "Class Name",
    trimesterName: "Term Name",
    orientation: "Orientation",
    positionX: "Position X",
    font: "Font",
    size: "Size:",
    color: "Color:",
    vertical: "Vertical",
    horizontal: "Horizontal",
    centered: "Centered",
    atBeginning: "At Beginning",
    selectFont: "Select a font",
    textSize: "Text Size",
    arabicAndFrench: "Arabic and French",
    arabicOnly: "Arabic Only",
    amiriNormal: "Amiri (Normal)",
    amiriBold: "Amiri (Bold)",
    notoNaskhArabicNormal: "Noto Naskh Arabic (Normal)",
    notoSansArabicBold: "Noto Sans Arabic (Bold)",
    alJazeeraArabicBold: "Al Jazeera Arabic (Bold)",
    imprimerPVNiveaux: "Print PV grades",
    ConsielClass: "Class Council",
    changePositions: "Change positions",
    fuseSubSubject: "Merge sub-subjects",
    showSubModule: "Sub-module name",
    hideDate: "Hide date",
    hideSubject: "Hide subjects",
    useSubModule: "Use sub-modules",
    subModule: "Sub-modules",
    managerSubModule: "Manage sub-modules",
    manageCertType: "Manage certificates for :",
    pvSortBy: "Sort by",
    pvSortOrder: "Sort order",
    pvSortAverage: "Average",
    pvSortName: "Name",
    pvSortAsc: "Ascending",
    pvSortDesc: "Descending",
    alert:
      "Modification is not possible: please edit in the specific report card.",
    avg: "Module Average",
    defaultModule: "Set default modules",
    defaultModuleConfirm:
      "This action will delete the existing module. Proceed with setting the default modules?",
    defaultDone: "The modules have been updated successfully",
    coefTrimester1: "Coefficient of term 1 ",
    coefTrimester2: "Coefficient of term 2 ",
    coefTrimester3: "Coefficient of term 3 ",
    moyenneGeneral: "General average",
    moyenneTrimestreGeneral: "General term average",
    moyenneTrimestreGeneralMatieresBase:
      "General term average in basic subjects",
    bulletinCoefs: "Coefficients of Bulletins",
    coefBulletinsSaved:
      "The coefficients of Bulletins has been saved successfully",
    decisionConseil: "Council decision",
    finalBulletin: "Annual school report",
    syncClass: "Synchronize the class",
    syncSubject: "Synchronize the subject",
    syncMarks: "Synchronize the marks",
    sureToSync: "Do you want to overwrite the marks?",
    syncDone: "Marks Synchronized successfully",
    date: "Print date",
    parametrageSaved: "The bulletin settings saved successfully",
    label: "Label",
    moyennePersonalized: "Personalized average per school",
    moyenneSpecifique: "Specific average",
    moyenneVerySpecifique: "Very specific average",
    moyennePedagogique: "Pedagogical Average",
    formulePersonalized: "Personalized formula",
    imprimerFichModuleVide: "Empty sheet",
    imprimerFichModule: "Completed sheet",
    imprimerFichModuleVideAll: "All empty sheets",
    imprimerFichModuleAll: "All filled sheets",
    certByMoyenne: "Certificates according to students averages",
    imprimerBulletin: "Print the School report",
    note: "Grade",
    nom: "Student name",
    bulletin: "School report",
    bulletinV1: "School report (Old version)",
    notes: "Grades",
    matieres: "Subjects",
    bulletinPedagogique: "Pedagogic Report",
    bulletinSpecifique: "Pilote Report",
    bulletinVerySpecifique: "Specific Report",
    performancesMatiere: "Subject performance",
    plus15: "More than 15",
    plus12: "More than 12 ",
    plus9: "More than 9",
    mois9: "Under 9",

    listeClasses: "Class list",
    classesActives: "Active classes",
    nombreClassesNonNote: "Number of classes not graded",
    tousClassesSontNotes: "All classes are graded!",
    nombreMatieresNonNote: "Number of subjects not graded",
    tousMatieresSontNotes: "All subjects are graded!",
    nombreElevesNonNotes: "Number of students not graded",
    tousElevesSontNotes: "All students are graded!",
    classes: "classes",
    toutMatieres: "All the subjects",
    toutEleves: "All students",
    activeStudents: "Active students",
    archivedStudents: "Archived students",
    enregistrerTout: "Save all",
    parEleve: "By student",
    parMatiere: "By subject",
    typeIntrouvable: "Type not found",
    saisirSchoolType:
      "Please enter the type of your establishment in settings - establishment!",
    aucuneDonnee: "No data available for this term",
    confirmPrintMatieres:
      "The subject marks below ({count}) must be completed to generate the report card!",
    confirmPrintEleves:
      "The student marks below ({count}) must be filled in to generate the report card!",
    generateAnyway: "Generate anyway",
    listeClassesNonNote: "List of ungraded classes",
    listeMatiereNonNote: "List of ungraded subjects",
    listeEleveNonNote: "List of ungraded students",
    performancesNotes: "Grades performance",
    notePlusHaute: "Highest average",
    noteEleve: "Student grade",
    notePlusBasse: "Lowest average",
    moyennesModules: "Module averages",
    maximaleMoyenne: "Maximum Average",
    moyenne: "Average",
    minimaleMoyenne: "Minimum Average",
    imprimerTout: "Print all",
    imprimerFichModuleVideexcel: "All empty sheets Excel",
    imprimerFichModuleexcel: "ALL filled sheets Excel",
    moyenneTrimestre: "term average : {moyenne}",
    moyenneMax: "Highest average : {moyenne}",
    moyenneMin: "Lowest average : {moyenne}",
    validated: "School report are now available for class {name}",
    unvalidated: "School report are no longer available for class {name}",
    hideBulletin: "School reports will not be available to parents",
    validateBulletin: "School reports will be available to parents",
    cancelValidation: "Make unavailable to parents",
    validatedClassroom: "Make available to parents",
    deleteMark: "Do you want to delete this mark?",
    markDeletedSucc: "Mark was successfully deleted",
    markDeletedFail: "The mark could not be deleted, please try again!",
    showStamp: "Show stamp",
    PersonalizedAverage: "Use Personalized Average",
    notesManquantes: "Missing marks",
    Module: "Module",
    SubModule: "Sub-Module",
    noTemplateFound:
      "The bulletin is not configured please add a configuration first",
    exempt: "Exempt",
    alreadyExempt: "Already exempt",
    confirmExemptStudent: "Are you sure you want to exempt this student?",
    confirmUnexemptStudent:
      "Are you sure you want to undo the exemption for this student?",
    showNbrStudents: "Show Number of Enrolled Students",
    bulletinNotDispo: "Bulletin not available",
    bulletinDispo: "Bulletin available",
    parentVisibility: "Parent Visibility",
    directorNotesOnBehaviorAndAttendance:
      "Director's notes about behavior and attendance",
    destination: "Destination",
    pleaseSelectOrTypeAppreciation: "Please select or type an appreciation",
    pv: "PV",
    pvExcel: "PV (Excel)",
    format: "Format",
    formatAnnuel: "Annual Format",
    cannotModifyEditIn:
      "Cannot modify: please edit in the {type}, module: {name}",
    module: "module",
    noLevelsAvailable: "No grades available for this school type",
  },
  markHistory: {
    action: "Action",
    action_create: "Created",
    action_delete: "Deleted",
    action_update: "Updated",
    after: "After",
    before: "Before",
    date: "Date",
    empty: "No grade changes recorded yet",
    role: "Role",
    title: "Grade change history",
    user: "User",
    viewHistory: "History",
  },
  bulletinStatistics: {
    totalWithoutAverage: "Total without average",
    totalWithAverage: "Total with average",
    schoolStatistics: "School Statistics",
    level: "Grade",
    equalsOrExceeds16: "Equals or exceeds 16",
    between15And1599: "Between 15 and 15.99",
    between10And1499: "Between 10 and 14.99",
    lessThan10: "Less than 10 out of 20",
    exceeds15: "Exceeds 15",
    exceeds10To15: "Exceeds 10 to 15",
    equals10: "Equals 10 out of 20",
    from5ToLessThan10: "From 5 to less than 10 out of 20",
    lessThan5: "Less than 5 out of 20",
    student: "Student",
    levelSuffix: "",
  },
  personnel: {
    nom: "Last name",
    prenom: "First Name",
    adresse: "Address",
    telephone: "Telephone",
    qualification: "Qualification",
    dateNaissance: "Date of birth",
    typeContrat: "Type of contrat",
    salaire: "Salary",
    cin: "CIN",
    idCard: "ID Card Number",
    etatCivil: "Civil status",
    niveau: "Grade",
    experiences: "Experiences",
    dateEntretien: "Date of interview",
    qualifications: "Qualifications",
    tauxHoraire: "Hourly rate",
    detailPaiement: "Payment Details",
    jourSemaine: "Days",
    expectedHoursPerDay: "Expected hours / day",
    daysOff: "Days off",
    daysOffPlaceholder: "Select days off",
    weekday_0: "Sunday",
    weekday_1: "Monday",
    weekday_2: "Tuesday",
    weekday_3: "Wednesday",
    weekday_4: "Thursday",
    weekday_5: "Friday",
    weekday_6: "Saturday",
    expectedTeachingHours: "Teaching hours / subject / week",
    expectedTeachingHoursHint: "Select a subject and enter hours per week",
    hoursPerWeek: "Hours / week",
    addSubjectHours: "Add subject",
    attendanceConfig: "Attendance configuration",
    cnss: "CNSS",
    rib: "RIB",
    pin: "PIN (Tax)",
    sha: "SHA (Health)",
    nssf: "NSSF (National Social Security Fund)",
    bankAccountNo: "Bank Account No.",
    bankName: "Bank Name",
    bankBranch: "Bank Branch",
    autre: "Other ",
    notes: "Grades",
    infoBase: " Basic Informations",
    infoContrat: "Contract Informations",
    chercher: "Search",
    listeQualifications: "Qualifications List",
    staff: "Staff",
    gestionPaiements: "Employee payment management",
    chercherParNom: "Search by name",
    nbPersonnel: "Number of staff",
    infoPersonnel: "Employee information",
    type: "Type",
    personnel: "Staff",
    enseignant: "Teacher",
    personalList: "Personnel List",
    totalSalary: "Total Salary",
    listPersonnelPDF: "Personnel_List",
    etatPaiePersonnels: "Personnel Payment Status",
  },
  enseignant: {
    advisorAddExercice: "Possibility to add homeworks",
    advisorAddNews: "Possibility to add news",
    advisorValidateNews: "Possibility to validate news",
    newsPermissions: "News permissions",
    selectClassMessage:
      "Please select a class from those assigned to the teacher",
    addAccess: "Add access to teacher",
    nom: "Last Name",
    prenom: "First Name",
    adresse: "Address",
    telephone: "Telephone",
    qualification: "Qualifications",
    dateNaissance: "Birth date",
    typeContrat: "Contrat Type",
    salaire: "Salary",
    cin: "CIN",
    etatCivil: "Civil Status",
    niveau: "Grade",
    experiences: "Experiences",
    dateEntretien: "Date of interview",
    qualifications: "Qualifications",
    tauxHoraire: "Hourly rate",
    detailPaiement: "Payment Details",
    jourSemaine: "Days",
    cnss: "CNSS",
    rib: "RIB",
    autre: "Other",
    notes: "Grades",
    infoBase: " Basic Informations",
    infoContrat: "Contract Information",
    chercher: "Search",
    listeQualifications: "Qualifications List",
    matiere: "Subject ",
    specialite: "Speciality",
    grade: "Grade",
    email: "Email",
    mdp: "Access",
    compte: "Account",
    detailPedagogiques: "Pedagogical details",
    usernameEmail: "Username/email",
    photo: "Photo",
    conseillersPedagogiques: "Pedagogical advisers",
    ajouterConseillerPedagogique: "Add an advisor",
    enterInfoConseillerPedagogique:
      "Enter the advisor's information in the fields below",
    niveauxSuperviser: "Supervised grades",
    niveauxRequis: "Grades are required",
    listeNiveaux: "List of grades",
    aucunConseillerPedagogique: "No Pedagogical Advisor is found",
    needValidation: "Automatic validation of courses and homeworks",
    needValidation2: " and homeworks",
    needNewsValidation: "Automatic validation of news",
    teacherAddNews: "Possibility to add news",
    permissionsValidation: "Validation permissions",
    listeEnseignantsPDF: "Teachers_List",
    listeConseillersPedagogiquesPDF: "Pedagogical_Advisors_List",
    listeConseiller: "List of pedagogical advisors",
    deactivateOrActivateTeacherAccount:
      "Deactivate or activate teacher account",
    teacherQrCode: "Teacher QR code",
    modifyTeacherAccessSubtitle:
      "Modify teacher access to facilitate grade management and educational content in EdTeacher.",
    educationalAdvisor: "Educational advisor",
    duplicate: "Duplicate",
    duplicateAccessForTeacher: "Duplicate access for teacher",
    duplicateAllTeachers: "Duplicate all teachers",
    duplicateAccessForAllTeachers: "Duplicate access for all teachers",
    accessLevelAddedSuccessfully: "Access grade added successfully",
    accessLevelNotAdded: "Access grade not added",
    revokedAccessFrom: "Revoked access from",
    onModules: "on modules",
    unknownModule: "Unknown Module",
  },
  etatPaiement: {
    personnel: "Personnel",
    salaire: "Salary",
    avance: "Advance",
    nbJours: "Number of days",
    mois: "Month",
    etatPaiement: "Payment Status",
    virementBancaire: "Bank transfer?",
    paiementAction: "Payment",
    selectionnerMois: "Select a month",
    selectionnerFrais: "Select fees to pay",
    totalAvances: "Total advances",
    frais: "Fees",
    montant: "Amount",
    fraisAPayer: "Fees to pay",
    inscription: "Registration",
    tranche: "Term",
    toutAfficher: "Show all",
    toutMasquer: "Hide all",
    payerAvecAvance: "Pay with advance",
    sansAvance: "Without advance",
    activerPaiementAvance: "Enable advance payment",
    montantAvance: "Advance amount (TND)",
    saisirMontant: "Enter amount",
    fraisNonPayes: "unpaid fees",
    reste: "Remaining",
    avanceAppliquee: "Advance applied",
    restePayer: "Remaining to pay",
    paiementPartiel: "Partial payment - remaining amount to pay",
    montantInvalide:
      "The advance amount entered does not allow to cover this fee. Please enter a higher advance amount.",
    selectionnerTout: "Select all",
    deselecTout: "Deselect all",
    montantSupTotal:
      "The advance amount entered is higher than the total amount of fees to pay. advance amount must be less than or equal to",
    montantInsuffisant:
      "The advance amount entered does not allow to cover all fees. Please enter a higher advance amount.",
    paiementsPersonnels: "Personnel Payments",
    attendanceReference: "Attendance reference (teacher)",
    attendanceReferenceHint:
      "Indicative information for the selected month. Days/hours fields are not filled automatically.",
    noAttendanceData: "No attendance data for this month.",
    attendanceDetails: "Details",
    attendanceDetailsTitle: "Session details",
    attendanceSource: "Source",
    attendanceSourceCheckin: "Check-in",
    attendanceSourceManual: "Manual",
    reste: "Rest",
    scolarite: "Schooling",
    activite: "Activity",
  },
  hr: {
    nbHeures: "Nb hours/week",
    nbJours: "Nb days/week",
    espece: "Cash",
    cheque: "Cheque",
    modePaiement: "Payment method",
    modifierPaiement: "Modify payment",
    paiementModifie: "Payment has been successfully modified",
    paiementSupprime: "Payment has been successfully deleted",
  },
  virement: {
    rib: "RIB",
    nom: "Last Name",
    prenom: "First Name",
    etatPaiement: "Payment Status",
    salaire: "Salary",
    mois: "Month",
    nbJours: "Number of days",
    chercher: "Search",
  },
  recette: {
    fournisseurProfil: "Provider profile",
    checksDueThisWeek: "Checks due this week",
    anneeScolaire: "School year",
    dateAjout: "Added at",
    doneBy: "Added By",
    cancelledBy: "Canceled by",
    actions: "Actions",
    detailsReglement: "Payment details",
    infosGenerales: "General information",
    repartitionMontants: "Amount breakdown",
    lignesReglement: "Payment lines",
    periodeHint:
      "The date range only applies to the selected school years. Invoices and receipts from other years are excluded, even if they fall within the dates.",
    montantRequis: "Amount is required and must be a number",
    montantCheque: "Check amount",
    montantEspece: "Cash amount",
    montantTraite: "Traite amount",
    montantTPE: "TPE amount",
    montantVirement: "Virement amount",
    montantTotal: "Total amount",
    typePaiement: "Payment type",
    montant: "Amount",
    nom: "Client Name ",
    typeRecete: "Revenue type",
    typeReglement: "Payment Type",
    modePaiement: "Payment Mode",
    receiptType: "Receipt Type",
    montantHT: " HT Amount",
    montantTTC: " TTC Amount",
    type: "Type",
    datePaiement: "Date of payment",
    numCheque: "Check number",
    imprimer: "Print ",
    csv: "CSV",
    tous: "All",
    cheque: "Check",
    espece: "Cash",
    traite: "Draft",
    virement: "Bank Transfer",
    TPE: "TPE",
    chequeEtEspece: "Check and cash",
    detailsPaymentDist: "Check Details",
    numero: "Number",
    titulaire: "Incumbent",
    banque: "Bank",
    dateEcheance: "Due date",
    chequeMontantTotal: "Total check amounts",
    relatedPayments: "Related payments",
    fermer: "Close",
    ok: "Ok",
    typeJournal: "Log type",
    selectionnerDate: "Select a date",
    motCles: "Key Words",
    chercher: "Search",
    bouillard: "Bouillard box",
    annule: "Canceled",
    personnel: "Personnel",
    salaire: "Salary",
    avance: "Advance",
    avanceAPayer: "Advance to pay",
    invoicesCanOnlyBeCredited: "Invoices can only be credited (credit note)",
    listeReglements: "List of payments",
    nbJours: "Number of days",
    mois: "Month",
    etatPaiement: "Payment Status",
    virementBancaire: "Bank Transfer ?",
    typeDepense: "Expense Type",
    date: "Date",
    dateDebutPlaceholder: "Select start date",
    dateFinPlaceholder: "Select end date",
    fournisseur: "Provider",
    numSerie: "Serial number",
    nomParent: "Parent Name",
    dateAnnulation: "Cancellation date",
    facture: "Invoice ?",
    impression: "Impression",
    annulation: "Cancellation",
    paiementQuoi: "Fees",
    selectionnerParent: "Select a parent",
    selectionnerEnfant: "Select a child",
    titre: "Title",
    valider: "Confirm",
    recuPaiement: "Payment receipt",
    facturePaiement: "payment invoice",
    paiementTotal: "Total Payment ?",
    paiementPour: "Payment for  ",
    restePayer: "Left to pay",
    payer: "Pay",
    payerMain: "Pay now ?",
    reducRepet: "Repetitive reduction",
    reducFact: "Discount On this invoice",
    reducRecu: "Reduction On this receipt",
    reducInscri: "Discount on Registration",
    reductionMensuel: "Monthly Reduction",
    fraisInscri: "Registration fees",
    fraisMensuel: "Monthly fees ",
    ajouterPaiement: "Add a payment",
    montantRestant: "Remaining amount",
    inscription: "Registration",
    telephone: "Telephone",
    frais: "Fees",
    enfant: "Child",
    activite: "Activity",
    tousMois: "All months",
    montantHTVA: "HTVA Amount",
    nonSeule: "No (one time only)",
    payeQues: "Paid ?",
    recus: "Receipts",
    factureTag: "Invoice",
    traite: "Draft",
    virement: "Bank Transfer",
    TPE: "TPE",
    avantReduction: "Before reduction",
    apresReduction: "After reduction",
    reduction: "Reduction",
    saisirInfoCheque: "Enter check information",
    saisirInfoChequeEtEspace: "Enter check and cash information",
    timbreFiscal: "Tax stamp",
    associatedCheques: "Associated cheques",
    associatedTraites: "Associated traites",
    associatedTPE: "Associated TPE",
    associatedVirements: "Associated virements",
    saisirInfoTraite: "Enter traite information",
    saisirInfoTPE: "Enter TPE information",
    versable: "Payable?",
    transactionId: "Transaction ID",
    nonTransfere: "Non-collected",
    transfere: "Collected",
    paiementEffectue: "Payment made",
    saisirInfoVirement: "Enter virement information",
    replacedCheques: "Cheques replaced by cash",
    chequeTraite: "Checks and Drafts",
    borderaux: "Documents",
    stat: "Statistics",
    file: "File",
    replacedBy: "Replaced by",
    viewFile: "View file",
    uploadFile: "Upload file",
    erreurChargementDonnees: "Error loading data",
    selectionnerModePaiement: "Select payment method",
    montantsNonEgaux: "The entered amounts are not equal to the total amount",
    paiementAjoute: "Payment added",
    paiementNonEffectuer: "Payment not made",
    typeFactureFeesRestants:
      "You cannot choose type 'Invoice' when selected fees have remaining amounts to pay. Please first settle the remaining amounts or choose type 'Receipt'.",
    sommeMontantsEgal: "The sum of amounts must be equal to {amount}",
    montantEgal: "The amount must be equal to {amount}",
    parentAnd: "And",
    nonValid: "you cannot validate a payment of an amount equal to zero",
    payWithAvance: "Pay with advance",
    payWithoutAvance: "Pay without advance",
    selectAdvances: "Select advances to use",
    parentBalance: "Parent balance",
    advanceAmountLabel: "Advance amount",
    advanceAmountPlaceholder: "Advance amount",
    remainingToPay: "Remaining to pay",
    index: "Index",
    payable: "Payable",
    nonPayable: "Non-payable",
    addCheque: "Add a cheque",
    chequeAmount: "Cheque amount",
    cashAmount: "Cash amount",
    incorrectAmountsInfo:
      "The information about cheque amounts and cash amount is incorrect, please correct them before distributing amounts",
    totalAmountMustBe: "The total amount must be",
    selectFeesToPay: "Select fees to pay",
    education: "Education",
    addDate: "Add date",
    chequeAmountColumn: "Cheque amount",
    advanceAmountColumn: "Advance amount",
    invoiceNumber: "Invoice N.",
    receiptNumber: "Receipt N.",
    fullName: "Name and Surname",
    child: "Child",
    baseReduction: "base reduction",
    totalAmountIs: "The total amount is",
    page: "Page",
    advanceDebited: "Advance debited from parent balance successfully",
    sumChequeCashEqual:
      "The sum of cheque and cash amounts must be equal to {amount}",
    paymentMethod: {
      ESPESE: "Cash",
      CHEQUE: "Check",
      TPE: "TPE",
      TRAITE: "Traite",
      VIREMENT: "Virement",
      VERSEMENT: "Deposit",
    },
    fluxType: {
      ALIMENTATION_P: "Main caisse funding",
      ALIMENTATION_SOUS_CAISSES: "Sub-caisse funding",
      VERSEMENT: "Deposit",
      COLLECTE_SOUS_CAISSES: "Sub-caisse collection",
      CHEQUE_TRAITE_BANQUE: "Cheque/traite transfer to bank",
      CHEQUE_TRAITE_CASH_REPLACEMENT: "Cheque/traite replacement by cash",
    },
    stats: {
      financialDashboard: "Checks, Drafts and Transfers Statistics",
      paymentsOverview: "Payments and transactions overview",
      bankStatus: "Bank Status",
      generalStatus: "General Status",
      rejectedChequesAlert: "Attention : Rejected payments not resolved",
      rejectedPayments: "rejected payments",
      rejectedPayment: "rejected payment",
      forTotalAmount: "for a total amount of",
      elements: "elements",
      transactions: "transactions",
      loadingStatsError: "Error loading statistics",
    },
    pdfGenerationError: "An error occurred during printing",
    pdfDailyFeesCount: "{count} sessions",
    effectuePar: "Done by",
    parent: "Parent",
    nSerie: "N° Serie",
    toutesDates: "All dates",
    depensesAnnule: "Cancelled expenses",
    montantTotalText: "The total amount is",
    tags: "Tags",
    totalSansReduction: "Total without reduction",
    totalHTVA: "Total HTVA",
    tva: "VAT",
    totalTTC: "Total TTC",
    dateRangeFrom: "From",
    dateRangeTo: "to",
    csvLabelTypeDepense: "Expense Type",
    csvLabelDate: "Date",
    csvLabelMontantTTC: "Amount TTC",
    csvLabelFournisseur: "Provider",
  },
  encaissement: {
    paymentMethod: "Payment method",
    cash: "Cash",
    cheque: "Check",
    tpe: "TPE",
    draft: "Draft",
    transfer: "Transfer",
    cashRegister: "Cash register",
    selectCashRegister: "Select a cash register",
    period: "Period",
    monthlyPayment: "Monthly payment",
    singlePayment: "Single payment",
    installmentPayment: "Term payment",
    activity: "Activity",
    schooling: "Schooling",
    fees: "Fees",
    monthly: "Monthly",
    installments: "Installments",
    stateOfReceipts: "State of receipts",
    creditNote: "Credit note",
    summaryByPaymentMethod: "Summary by payment method",
    totalGeneral: "TOTAL GENERAL",
    stateOfUnpaid: "State of unpaid",
    schoolingStateOfUnpaid: "Schooling: State of unpaid",
    activitiesStateOfUnpaid: "Activities: State of unpaid",
    invoicesCanOnlyBeCredited: "Invoices can only be credited (credit note)",
    quantite: "Quantity",
    eleve: "Student",
    pdfTableHeaders: {
      clientName: "Client name",
      telephone: "Phone",
      child: "Children",
      fees: "Fees",
      amount: "Amount",
      total: "Total",
    },
    pdfTotal: "Total",
    pdfCurrencySuffix: "TND",
    pdfFileName: "State_of_unpaid",
  },
  scolaritePdf: {
    total: "Total",
    registration: "Registration",
    schooling: "Schooling",
    activities: "Activities",
    levels: "Grades",
    allLevels: "All grades",
    installment: "Term {number}",
    legendPaid: "Paid",
    legendUnpaid: "Unpaid",
    legendPaidPartially: "Paid partially",
    legendPaidWithDiscount: "Paid with discount",
    totalDiscountAmount: "Total discount amount",
    totalAdvancePayments: "Total advance payments",
  },
  caisse: {
    caisse: "Cash register",
    SUBCAISSE: "Sub-cash register",
    BANK: "Bank",
    PRINCIPAL: "Principal",
    fermerCaisse: "Close cash register",
    ouvrirCaisse: "Open cash register",
    caisseOuverte: "Cash register opened successfully",
    caisseFermee: "Cash register closed successfully",
    caisseFermeeMessage: "Cash register closed",
    caisseOuvertureAutomatique:
      "The cash register will be opened automatically after payment",
    erreurOuverture: "Error opening cash register",
    erreurFermeture: "Error closing cash register",
    confirmationOuverture: "Opening Confirmation",
    confirmationFermeture: "Closing Confirmation",
    messageOuverture: "Do you really want to open the cash register?",
    messageFermeture: "Do you really want to close the cash register?",
    erreurAlimentation: "Error during cash register funding",
    aucuneCaisseAssigne: "No assigned caisse",
    aucuneCaisseAssigneDesc:
      "You don't have any assigned caisse at the moment.",
    ajouterCaisse: "Add cash register",
    modifierCaisse: "Edit cash register",
    gererCaisses: "Manage cash registers",
    detailsCaisse: "Cash register details",
    proprietaire: "Owner",
    proprietaires: "Owners",
    selectionnerCaisse: "Select a cash register",
    toutesLesAnnees: "All school years",
    anneeScolaireColonne: "School year",
    balance: "Balance",
    statut: "Status",
    type: "Type",
    nom: "Name",
    reference: "Reference",
    banque: "Bank",
    disponibilite: "Availability",
    actif: "Active",
    inactif: "Inactive",
    ouverte: "Open",
    fermee: "Closed",
    enregistrer: "Save",
    desactiver: "Deactivate",
    activer: "Activate",
    general: "General",
    modifier: "Edit",
    acces: "Access",
    transfers: "Transfers",
    historique: "History",
    totalDebits: "Total debits",
    totalCredits: "Total credits",
    debit: "Debit",
    credit: "Credit",
    nombreCheques: "Number of checks",
    montantCheques: "Check amount",
    montantTotalCheques: "Total check amount",
    nombreTraites: "Number of drafts",
    montantTraites: "Draft amount",
    montantTotalTraites: "Total draft amount",
    nombreTPE: "Number of TPE",
    montantTPE: "TPE amount",
    montantTotalTPE: "Total TPE amount",
    nombreVirements: "Number of transfers",
    montantVirements: "Transfer amount",
    montantTotalVirements: "Total transfer amount",
    montantEspeces: "Cash amount",
    alerteGestionTransactions:
      "Transaction management between cash registers is only available in the main cash register profile.",
    nomRequis: "Name required",
    referenceRequise: "Reference required",
    typeRequis: "Type required",
    nomBanque: "Bank name",
    caisseAjouteeSucces: "Cash register added successfully",
    erreurAjoutCaisse: "Error adding cash register",
    erreurChargementCaisses: "Error loading cash registers",
    erreurChargementCaisse: "Error loading cash register",
    settings: "Settings",
    label: "Label",
    lePorteur: "The holder",
    disponibiliteUpper: "AVAILABILITY",
    typeUpper: "TYPE",
    statutUpper: "STATUS",
    actions: "ACTIONS",
    caisseModifieeSucces: "Cash register modified successfully",
    erreurModificationCaisse: "Error modifying cash register",
    caisseDesactiveeSucces: "Cash register deactivated successfully",
    erreurDesactivationCaisse: "Error deactivating cash register",
    caisseActiveeSucces: "Cash register activated successfully",
    erreurActivationCaisse: "Error activating cash register",
    utilisateursAutorises: "Authorized users",
    accesALaCaisse: "Cash register access",
    selectionnerUtilisateur: "Select a user",
    roles: "Roles",
    lire: "VIEW",
    ecrire: "WRITE",
    proprietaireRole: "OWNER",
    roleDepense: "EXPENSE",
    roleDepenseEncaissement: "Expense — incoming (receipts, credit notes)",
    ajouterUtilisateur: "Add user",
    enregistrerAcces: "Save access",
    veuillezRemplirChamps: "Please fill in all required fields",
    exactementUnProprietaire: "There must be exactly one owner (OWNER)",
    auMoinsUnProprietaire:
      "The cash register must have at least one owner (OWNER)",
    utilisateurEnDouble: "A user can only be listed once in the access list",
    accesMisAJour: "Access updated",
    erreurMiseAJourAcces: "Error updating access",
    erreurChargementUtilisateurs: "Error loading users",
    nouveauTransfert: "New transfer",
    reglesCollectePartielle: "Collection rules",
    montantDemande: "Requested amount",
    especesDisponibles: "Available cash",
    collectePartielleEspecesUniquement:
      "The requested amount exceeds the available cash.",
    collecteTotaleTousModes:
      "A full collection can include all payment types without restriction.",
    modesNonEspecesCollecteTotale:
      "TPE and other payment types cannot be partially collected. They must be collected in full.",
    pourMontantPrecis: "To obtain a specific amount",
    etapeCollecterTout: "Perform a full collection using “Collect all”.",
    etapeTransfererMontant:
      "Then transfer the desired amount to a sub-cash register.",
    typeDeFlux: "Flow type",
    libelle: "Label",
    montant: "Amount",
    toutCollecterBtn: "Collect all",
    veillezSelectionnerTypeFlux:
      "Please first select the flow type to continue entering the transfer.",
    veillezSelectionnerTypeFluxMessage: "Please select the flow type",
    veillezSaisirLibelle: "Please enter a label",
    veillezSaisirMontant: "Please enter an amount",
    selectionnerTypeAlimentation: "Select funding type",
    veillezSelectionnerType: "Please select a type",
    caisseSource: "Source cash register",
    caisseDestination: "Destination cash register",
    selectionnerCaisseSource: "Select source cash register",
    selectionnerCaisseDestination: "Select destination cash register",
    veillezSelectionnerCaisseSource: "Please select a source cash register",
    veillezSelectionnerCaisseDestination:
      "Please select a destination cash register",
    commentaire: "Comment",
    ajouterCommentaire: "Add a comment (optional)",
    commentaireMaxCaracteres: "Comment must not exceed 500 characters",
    paymentsEffectues: "Payments made",
    valider: "Validate",
    transactionsDeLaCaisse: "Cash register transactions",
    alimentationEffectueeSucces: "Funding completed successfully",
    alimentationCaissePrincipale: "Main cash register funding",
    alimentationSousCaisses: "Sub-cash register funding",
    versement: "Deposit",
    collecteSousCaisses: "Sub-cash register collection",
    caisseBanque: "Bank Cash Register",
    augmentationCapital: "Capital increase",
    fonds: "Funds",
    historiqueTransactions: "Transaction history",
    dateColonne: "Date",
    typeDeFluxColonne: "Flow type",
    montantColonne: "Amount",
    sourceColonne: "Source",
    destinationColonne: "Destination",
    utilisateurColonne: "User",
    actionsColonne: "Actions",
    details: "Details",
    detailsTransaction: "Transaction details",
    utilisateurTransaction: "User",
    typeDeCollecte: "Collection type",
    totale: "Total",
    partielle: "Partial",
    etatCaisses: "Cash register status at transaction time",
    etatCaisseSource: "Source Cash Register Status",
    etatCaisseDestination: "Destination Cash Register Status",
    erreurChargementTransactions: "Error loading transactions",
    erreurRecuperationSolde: "Error retrieving cash register balance",
    transactions: "Transactions",
    erreurChargementStatistiques: "Error loading statistics",
    nombrePaiementEspeces: "Number of cash payments",
    montantTotalPaiementEspeces: "Total amount of cash payments",
    nombrePaiementTPE: "Number of TPE payments",
    montantTotalPaiementTPE: "Total amount of TPE payments",
    typeEncaissement: "Income",
    typeInverseEncaissement: "Inverse income",
    typeAvoirCredit: "Supplier credit note (Avoir)",
    inverseDetailMissing:
      "No reception schedule is linked to this payment for details.",
    typeDecaissement: "Expense",
    typeColonne: "Type",
    descriptionColonne: "Description",
    journalCaisseTitle: "Cash journal",
    dateImpression: "Print date",
    dateHeure: "Date and time",
    touteLaPeriode: "Entire period",
    statutCollecte: "Collection status",
    totalRecettes: "Total receipts",
    totalDepenses: "Total expenses",
    balanceTable: "Balance",
    totalEncaissements: "Total incoming",
    totalDecaissements: "Total outgoing",
    facturesAnnulees: "Cancelled invoices / receipts",
    depenseLabel: "Expense payment",
    beneficiary: "Beneficiary",
  },
  tresorerie: {
    chequeTraitePdf: "checks-drafts",
    bordereauPdf: "Deposit slip",
    avoirs: "Credits",
    chequesTraites: "Checks and drafts",
    bordereaux: "Deposit slips",
    statistiques: "Statistics",
    listeReglementAnnule: "Cancelled payments list",
    recherche: "Global search",
    type: "Type",
    statut: "Status",
    statutDepot: "Deposit Status",
    numero: "Number",
    description: "Description",
    montant: "Amount",
    date: "Date",
    dateCreation: "Creation date",
    dateDepotPrevue: "Expected deposit date",
    dateDepotEffective: "Actual deposit date",
    caisse: "Cash register",
    banque: "Bank",
    titulaire: "Holder",
    note: "Note",
    borderaux: "Deposit slips",
    selectionnerType: "Select type",
    filtrerParNom: "Filter by name",
    recherchreParNumeroDescription: "Search by number or description",
    statutBanque: "Bank Status",
    statutGeneral: "General Status",
    statutDuDepot: "Deposit status",
    statutDuBordereau: "Deposit slip status",
    selectionnerTypeBordereau: "Select deposit slip type",
    dateDepotPrevuePlaceholder: "Expected deposit date",
    dateDepotEffectivePlaceholder: "Actual deposit date",
    nomTitulaire: "Holder name",
    noteOptionnelle: "Optional note",
    descriptionBordereau: "Deposit slip description",
    selectionnerCaisse: "Select cash register",
    nouveauBordereau: "New Deposit Slip",
    toutSelectionner: "Select all",
    toutDeselectionner: "Deselect all",
    modifier: "Edit",
    supprimer: "Delete",
    voir: "View",
    details: "Details",
    gererCheques: "Manage checks",
    enAttente: "Pending",
    valide: "Validated",
    rejete: "Rejected",
    nonDepose: "Not deposited",
    depose: "Deposited",
    traite: "Processed",
    annulation: "Cancellation",
    avoir: "Credit note",
    cheque: "Check",
    traiteType: "Draft",
    numSerie: "Serial number",
    nomParent: "Parent name",
    nomClient: "Client name",
    typeReglement: "Payment type",
    facture: "Invoiced",
    dateAnnulation: "Cancellation date",
    annulePar: "Cancelled by",
    typesReglement: "Payment types",
    anneeScolaire: "School year",
    detailsBordereau: "Deposit slip details",
    modifierBordereau: "Edit deposit slip",
    creerBordereau: "Create deposit slip",
    modifierCheque: "Edit check",
    gestionCheques: "Check management",
    oui: "Yes",
    non: "No",
    erreurChargementDonnees: "Error loading data",
    erreurSauvegarde: "Error saving",
    erreurSuppression: "Error deleting",
    erreurCreation: "Error creating",
    bordereau: {
      creeSucces: "Deposit slip created successfully",
      modifieSucces: "Deposit slip modified successfully",
      supprimeSucces: "Deposit slip deleted successfully",
    },
    verificationPermissions: "Checking permissions...",
    aucunAcces: "You don't have access to any tab in this section.",
    pasAccesOnglet: "You don't have access to this tab",
    reglementsAnnules: "Cancelled payments",
    exportCSV: "CSV Export",
    rechercherCheques: "Search checks",
    rechercherTraites: "Search drafts",
    periode: "Period",
    factureLabel: "Invoice",
    espece: "Cash",
    remplacerParEspece: "Replace with cash",
    confirmationRemplacement:
      "Are you sure you want to replace check {numero} with a cash payment of {montant}?",
    chequeRemplaceSucces: "Check replaced with cash successfully",
    erreurRemplacementCheque: "Error replacing check",
    chequeNonEligible: "Check not eligible for replacement",
    chequeNonTrouve: "Check not found",
    remplacementChequeNote: "Replacement of check {numero} with cash payment",
    elements: "items",
    sur: "of",
    modifierLe: "Edit",
    numeroChequeTraite: "Check/draft number",
    dateEcheance: "Due date",
    informationsNonModifiables: "Non-editable information",
    modification: "Editing...",
    numeroRequis: "Number is required",
    banqueRequis: "Bank is required",
    dateEcheanceRequis: "Due date is required",
    titulaireRequis: "Holder is required",
    virement: "Transfer",
    actif: "Active",
    inactif: "Inactive",
    chequeModifieSucces: "Check modified successfully",
    erreurModification: "Error during modification",
    cheques: "Checks",
    traites: "Drafts",
    chequesPluriel: "check(s)",
    traitesPluriel: "draft(s)",
    valides: "validated",
    gererLesCheques: "Manage checks",
    aucunCheque: "No check",
    confirmationSuppressionBordereau:
      "Are you sure you want to delete this deposit slip?",
    impossibleSupprimerBordereau:
      "Cannot delete a deposit slip containing validated checks",
    selectionnes: "selected",
    aucunSelectionne: "None",
    modificationEnCours: "Editing...",
    creationEnCours: "Creating...",
    creer: "Create",
    typeBordereauRequis: "Deposit slip type is required",
    statutRequis: "Status is required",
    caisseRequise: "Cash register is required",
    auMoinsUnElementRequis: "At least one element is required",
    num: "No.",
    rib: "RIB",
    erreurChargementCaisses: "Error loading cash registers",
    erreurChargementElements: "Error loading elements",
    erreurCreationBordereau: "Error creating deposit slip",
    rechercheParNumeroTitulaireBanque: "Search by number, holder, bank...",
    rechercheParNumeroBanque: "Search by number, bank...",
    informationsDuBordereau: "Deposit Slip Information",
    total: "Total",
    montantTotal: "Total Amount",
    listeDes: "List of",
    aucuneDescription: "No description",
    fermer: "Close",
    erreurGenerationBordereau: "Error generating deposit slip.",
    echeance: "Due date",
    nombreTotalElements: "Total number of items",
    repartitionParType: "Distribution by type",
    repartitionParStatut: "Distribution by status",
    virements: "Wire Transfers",
    pdfGeneratedSuccessfully: "PDF generated successfully",
    pdfGenerationError: "Error generating PDF",
    summary: "Summary",
    nombreBordereaux: "Number of bordereaux",
    nombreTotalCheques: "Total number of checks",
    nombreCheques: "No. Checks",
    montantTTC: "Amount TTC",
    creationDate: "Creation Date",
    numberOfElements: "Number of Elements",
    actions: "Actions",
    errorLoadingBordereaux: "Error loading bordereaux",
    errorDuringDeletion: "Error during deletion",
    errorRetrievingBordereau: "Error retrieving bordereau",
    errorGeneratingPdf: "Error generating PDF",
    erreurTelechargementCSV: "Error downloading CSV",
  },
  choisir: {
    enseignant: "Choose a teacher",
    matiere: "Choose a subject",
    salle: "Choose a classroom",
    duree: "Choose a duration",
    classe: "Choose a class",
    repas: "Choose the type of meal",
    jour: "Choose the days of this meal",
    dateDebut: "Choose start date",
    dateFin: "Choose end date",
    niveauClass: "Choose class grade",
    template: "Template",
  },
  requis: {
    nameActivite: "Activity name is required",
    template: "Template is Required",
    smsContenue: "The content of your message is required.",
    message: "The message is required",
    required: "is required",
    coefficient: "Coefficient is required",
    red: "Set reduction to zero if you don't want to add reduction",
    activite: "L'activité est requise",
    cnss: "CNSS is required",
    rib: "RIB is required",
    specialite: "Specialty is required",
    niveau: "Grade is required",
    etatCivil: "Marital status is required",
    jourSemaine: "Days per week are required ",
    tauxHoraire: "Hourly rate is required",
    dateEntretien: "Interview date is required",
    matiere: "The subject is required",
    typeContrat: "Contract type is required",
    qualification: "Qualification is required",
    telephone: "Phone number must be 8 digits",
    telephoneKE: "Phone number must be 10 digits",
    phoneRequired: "Phone is required",
    birthCertificate: "Birth certificate is required for Grade 3 and above",
    cin01: "National ID card number must be 8 digits and start with 0 or 1",
    cin8: "National ID card number must be 8 digits",
    cin: "National ID card number is required",
    pourcentage: "Discount percentage is required",
    dinar: "Discount dinar is required",
    order: "Order is required",
    mail: "Enter your email!",
    mois: "Month is required",
    mdp: "Password is required",
    noWhitespace: "Field cannot contain whitespace",
    alphabeticOnly: "Must contain only alphabetic characters and spaces",
    confirmation: "Password confirmation is required",
    username: " Username is required",
    usernameEmail: " Username or email is required",
    titre: "Title is required",
    categorie: "Category is required",
    designation: "Designation is required",
    cible: " Target is required",
    salaire: "Salary is required",
    role: "The role is required ",
    repas: "Enter the name of the meal",
    depense: "Expense type is required",
    fournisseur: "Provider is required",
    nom: " Name is required ",
    min: " Minimum mark is required ",
    max: " Maximum mark is required ",
    nomPersonnel: " Personnel name is required ",
    date: "Date  is required",
    selection: "Parent selection is required",
    nomPere: "Father's name is required",
    nomMere: "Mother's name is required",
    prenom: "Last name is required",
    prenomPere: "Father's first name is required",
    prenomMere: "Mother's first name is required",
    telPere: "Father's phone is required",
    telMere: "Mother's phone is required",
    email: "Invalid email ! ",
    activite: "Activity is required",
    carac: "4 characters minimum for the password ",
    genre: "Gender is required",
    adresse: "Address is required",
    service: "A service must be selected",
    fraisInscri: "Registration fees is required",
    fraisMensuel: "Monthly fees is required ",
    fraisParJour: "Daily fees is required",
    ajoutLogo: "Add new logo ",
    dateNaissance: "Date of birth is required",
    nbJours: "The number of days is required",
    montant: "The amount is required and must be a number",
    modePaiement: "Payment method is required",
    avance: "Advance is required",
    selectionEnfant: "Child selection is required",
    etatPaiement: "Payment status is required",
    specification: "Specification is required",
    observation: "Observation is required",
    reductionInscro:
      "Reduction on the registration fee is required (put zero if there is no reduction)",
    reductionMensuel:
      "Reduction on the monthly fee is required (enter zero if there is no reduction)",
    supp: "Are you sure to delete ?",
    supp2:
      "If you delete a student, their payment status will be updated, all unpaid months will be deleted. Safe to delete?",
    annu: "If you cancel the enrollment, Eve's enrollment status for the current school year will be updated. Sure to unsubscribe?",
    appreciation: "Appreciation is required",
    subject: "Subject is required",
    grade: "Grade is required",
    reqcoverpicture: "Cover picture is required",
    reqdescription: "Description is required",
    reqtags: "At least one tag is required",
  },
  phoneInput: {
    countryCodeLabel: "Country code",
    countrySelectorError: "Choose country",
    phoneNumberLabel: "Phone number",
    example: "Example:",
    descriptionTN: "Enter 8 digits (Tunisia)",
    descriptionKE: "Enter 10 digits (Kenya)",
    required: "Phone number is required",
  },
  success: {
    niveauAjout: "The level has been added",
    niveauxCrees: "Levels have been created",
    niveauMSA: "The level has been updated",
    niveauSupp: "The level has been deleted",
    appreciationOptionAjout: "Appreciation has been added",
    appreciationOptionMSA: "Appreciation has been updated",
    appreciationOptionSupp: "Appreciation has been deleted",
    certificationAjout: "Certification has been added",
    certificationMSA: "Certification has been updated",
    certificationSupp: "Certification has been deleted",
    modification: " modifiée avec succès",
    suppression: " supprimée avec succès",
    ajout: "ajoutée avec succès",
    decisionConseilAjout: "The decision has been added",
    decisionConseilMSA: "The decision has been updated",
    decisionConseilSupp: "The decision has been deleted",
    decisionConseilApplied: "Council decision applied successfully",
    noteEnregistre: "The grade saved successfully",
    noteToutesEnregistre: "All grades saved successfully",
    noteRemoved: "The grade has been removed successfully",
    notesRemoved: "Grades had been removed successfully",
    smsEnvoye: "SMS sent successfully",
    modificationsEnseignantsEffectue:
      "Teachers' changes are done successfully!!",
    modificationsMatieresEffectue: "Subjects' changes are done successfully!!",
    operationEffectue: "Operation completed successfully",
    cacheAjout: "Stamp has been uploaded",
    cacheSupp: "Stamp has been deleted",
    inscriAjout: "Registration has been added",
    eleveInscrit: "students successfully registered",
    inscriSupp: "Registration has been deleted",
    inscriAnnule: "Registration has been canceled",
    eleveRective: "Student has been reactivated",
    pubAjout: "The post has been added",
    pubModif: "The post has been updated",
    pubSupp: "The post has been archived",
    photoAjout: "The photo has been added",
    compte: "The account type has been added",
    autorisationMSA: "Authorization has been updated",
    autorisationSupp: "Authorization has been deleted",
    utilisateurAjout: " User has been added",
    utilisateurMSA: " User has been changed",
    utilisateurSupp: " User has been archived",
    utilisateurDesac: "User has been deactivated",
    utilisateurActiv: " User has been activated",
    repasAjout: "Meal has been added",
    repasMSA: "The meal has been changed",
    repasSupp: "The meal has been deleted",
    depenseMSA: "The expense has been updated",
    depenseSupp: "The expense has been archived",
    reglementSupp: "Payment have been removed",
    paiementAjout: "Payment have been added",
    paiementModifie: "Payment has been successfully modified",
    paiementSupprime: "Payment has been successfully deleted",
    dossierMSA: "The file has been updated",
    dossierSupp: "The file has been removed",
    buildingMSA: "The building {name} has been successfully updated",
    bulletinMSA: " School report has been updated ",
    typeDepenseAjout: "Expense type has been added",
    typeDepenseModif: "Expense type has been updated",
    typeDepenseArchiv: "Expense type has been archived",
    fournisseurAjout: "Le fournisseur a été ajouté",
    fournisseurMSA: "Le fournisseur a été modifié",
    fournisseurArchiv: "Le fournisseur a été archivé",
    typeRecetteMSA: "Le type de recette a été modifié",
    typeRecetteAjout: "Le type de recette a été ajouté",
    typeRecetteArchiv: "Le type de recette a été archivé",
    activiteAjout: " Activity has been added",
    activiteSupp: "Activity has been archived",
    activiteMSA: "Activity has been updated",
    emploiMSA: "Schedule has been updated",
    accessRevoked: "Access revoked successfully",
    logoMSA: "The logo has been changed ",
    fileUploadedPleaseSave: "{name} file uploaded successfully, please save!",
    seanceAjout: " The session has been added",
    seanceMSA: "The session has been updated",
    seanceSupp: " The session has been archived",
    punitionValid: " The punishment is reviewed",
    disciplineValid: " The student discipline is reviewed",
    personnelAjout: " Staff has been added",
    personnelMSA: "Staff has been updated",
    personnelSupp: "Staff has been archived ",
    personnelNonSupp: "Staff has not been deleted",
    enseignantAjout: "The teacher has been added",
    enseignantMSA: "The teacher has been updated",
    enseignantSupp: "The teacher has been deleted",
    enseignantNonSupp: "The teacher was not deleted",
    classeAjout: "The class has been added",
    classeMSA: "The class has been updated",
    classeSupp: "The class has been archived",
    moduleSupp: "The module has been removed",
    typePunitionAjout: "The type of punishment has been added",
    typePunitionMSA: "The type of punishment has been updated",
    typePunitionArchiv: "The type of punishment has been archived",
    typeStudentDisciplineAjout: "The type of student discipline has been added",
    typeStudentDisciplineMSA: "The type of student discipline has been updated",
    typeStudentDisciplineArchiv:
      "The type of student discipline has been archived",
    typeQualificationAjout: "The qualification type has been added",
    typeQualificationMSA: "The qualification type has been updated",
    typeQualificationArchiv: "The qualification type has been archived",
    matiereAjout: "The subject has been added",
    submoduleAdded: "The sub-module has been added",
    subsubjectAdded: "The sub-subject has been added",
    matiereMSA: "The subject has been updated",
    matiereSupp: "The subject has been archived",
    anneeAjout: "The school year has been added",
    anneeMSA: "The school year has been updated",
    anneeSupp: "The school year has been archived",
    serviceAjout: "The service has been added ",
    serviceMSA: "The service has been updated",
    serviceSupp: "The service has been deleted ",
    salleAjout: "The room has been added",
    salleMSA: "The room has been updated",
    salleSupp: "The room has been  archived",
    eleveAjout: "The student has been added",
    eleveMSA: "The student has been updated",
    eleveSupp: "The student has been archived",
    eleveSupp2: "The student has been deleted",
    parentAjout: "The parent has been added",
    parentMSA: "The parent has been updated",
    parentSupp: "The parent has been  archived",
    eleveAjoutAuClasse: "Student successfully added to class!",
    eleveDemeangeAuClasse: "Student successfully moved to {name}",
    InscriptionAnnulee: "Registration canceled successfully.",
    imageTelecharge: "{name} file uploaded successfully.",
    videoAdded: "Video {name} added successfully",
    conseillerPedagogiqueAjout: "The advisor has been added",
    conseillerPedagogiqueMSA: "The advisor has been updated",
    newsValidationSettingUpdated:
      "Automatic validation for news posts has been updated successfully",
    conseillerPedagogiqueSupp: "The advisor has been archived",
    productUpdate: "Product updated successfully.",
    fetchCommands: "Fetching commands...",
    commandSupp: "Command deleted successfully.",
    commandUpdate: "Command updated successfully.",
    prodSupp: "You have deactivated the product successfully",
    prodReactivate: "Product reactivated successfully",
    libraryAddDoc: "Document has been added",
    libraryUpdateDoc: "Document has been updated",
    libraryArchiveDoc: "Document has been archived",
    libraryReactiveDoc: "Document has been reactivated",
    moduleOrderUpdated: "Module order updated successfully",
    studentPhotoUploaded: "Student photo uploaded successfully",
    studentPhotoDeleted: "Student photo deleted successfully",
    studentExemptionRemoved: "Student exemption successfully removed",
    studentExempted: "Student has been successfully exempted",
    sessionsUpdated: "{count} sessions have been updated successfully",
    sessionsCanceled: "{count} sessions have been canceled successfully",
    sessionsRestored: "{count} sessions have been restored successfully",
    recurringSessionsDeleted:
      "{count} recurring sessions have been deleted successfully",
    changementEffectue: "Changes applied successfully",
    parentMisAJour: "Parent information has been updated",
    groupUpdated: "Group updated",
    studentRemovedFromGroup: "Student removed from group",
    excelGenerated: "Excel file has been successfully generated.",
  },
  error: {
    dateFinPlusGrande: "The end date must be greater than the start date",
    oops: "Oops! An error occurred",
    impoAjoutAppreciationOption: "Unable to add appreciation",
    aucCert: "No certifications is found",
    impoAjoutCertification: "Unable to add the certification",
    impoEnregistrerVide: "Cannot save empty value",
    fetchError: "Error loading data",
    fetchingStudents: "Error fetching students list",
    invalidNote: "Invalid rating!. Must be between 0 and 20",
    smsFormat: "Invalid format, phone numbers must be separated by commas!",
    noPhoneNumber: "No phone number",
    invalid: "invalid",
    notEnrolled: "Not enrolled",
    noStudentFound: "No student found",
    noClassFound: "No class found for the selected grade",
    phoneNumberExists: "Phone number already exists in the system",
    eleveDejaInscritPourMois:
      "Student already registered for the selected months",
    impoModifiEleve: "Unable to update student",
    impoModifi: "Unable to update",
    eleveNonAjoutAuClasse:
      "Registration not added, please cancel the registration then assign the student to a new class!",
    InscriptionNonModifi:
      "Registration not modified, please cancel the registration and then assign the student to a new class!",
    matiereNonAffecte: "All subjects and its coefficient must be filled!",
    subsubjectNonAffecte: "{subject}: All sub-subjects must be filled!",
    capacite: "The capacity of the room is lower than the number of students",
    fichiers: "You can only upload JPG ,JPEG or PNG files!",
    fichiersPNG: "You can only upload PNG files!",
    fichiersPDFWord:
      "You can only upload JPG, JPEG, PNG, PDF, Word (.doc, .docx) files!",
    fileTypeNotAllowed:
      "Only images, PDF, Office files (Word, Excel, PowerPoint), and videos (MP4, WebM) are allowed",
    onlyPDFAllowed: "You can only upload PDF files!",
    onlyImagesAndPDFAllowed:
      "You can only upload images (JPEG, PNG, WebP) or PDF files!",
    onlyImagesPDFWordExcel:
      "You can only upload images (JPEG, PNG, WebP), PDF, Word, or Excel files!",
    onlyAudioFilesAllowed: "Only audio files are allowed (e.g. MP3, WAV, M4A).",
    allowedFileTypes: "Only the following file types are allowed: {types}",
    allowedImageTypes: "Only the following image types are allowed: {types}",
    classe: "class not found",
    activite: "Activity not found",
    service: "Service not added",
    inscription: "Registration ",
    aucScol: "No tuition registration found",
    aucClasse: "No class is found",
    aucEleve: "No student is found",
    aucInscri: "No registration for the activity is found",
    aucPersonnel: "No staff is found",
    aucService: "No serrvice is found",
    aucActivite: "No activity is found",
    aucActualite: "No news is found",
    aucRole: "No role is found",
    aucEtablissement: "No establishment is found",
    aucRecette: "No type of revenue is found",
    allSubModuleNeedToBeSelected: "Select all sub-modules",
    noSubMoudoleIsfound: "No sub-module found",
    moduleNonSupp: "This module cannot be deleted",
    deleteSession: "Error deleting session",
    aucMatiere: "No subject is found",
    aucSubsubject: "No sub-subject is found",
    aucUser: "No user is found",
    aucFournisseur: "No provider is found",
    aucDepense: "No expenses are found",
    aucQualification: "No qualification type found",
    aucEnseignant: "No teacher is found",
    aucAnnee: "No school year is found",
    aucSalle: "No room is found",
    aucModule: "No module is found",
    verifier: "Check passwords",
    modif: "An error in editing",
    ajout: "An error in adding",
    supp: "An error in the deletion",
    impoInscriSupp: "Unable to delete this registration",
    impoPubAjout: "Unable to add post",
    impoPubModif: "Unable to update post",
    impoPubSupp: "Unable to delete post",
    impoAjoutType: "Unable to add this type",
    impoAjoutActivite: "Unable to add activity",
    impoAjoutAnnee: "Unable to add schooler year",
    impoAjoutClasse: "Unable to add schooler class",
    impoAjoutSalle: "Unable to add the room",
    impoAjoutService: "Unable to add the service",
    impoAjoutFournisseur: "Unable to add the provider",
    impoAjoutCeType: "Unable to add this type",
    impoModifiMatieres: "Unable to edit the subjects",
    impoModifiEnseignants: "Unable to edit the teachers",
    image: "The image must be less than 5 MB",
    fileTooLarge: "File size must be less than 5MB",
    image50: "The images must be less than 50 MB",
    maxImage: "The maximum number of images is 15",
    maxFiles: "The maximum number of files is 15",
    videoFormat: "Only MP4, MOV, AVI, MKV, and WebM video formats are allowed",
    maxVideos: "Maximum 5 videos allowed",
    videoSize: "Video size must be less than 500MB",
    nonAjoute: "Not added",
    autorisationNonMSA: "Authorization has not been updated",
    autorisationNonSupp: "Permission not removed",
    eleveNonMSA: " Student has not been updated",
    impoTelecharger: " Unable to download image",
    dossier: "Unable to find student record ",
    dossierNonMSA: "The file has not been updated",
    nonValid: "you cannot validate a payment of an amount equal to zero",
    recetteNonAjoute: "Revenue  not added",
    recetteNonMSA: "Revenue not updated ",
    recetteNonSupp: "Revenue not  deleted",
    qualificationNonAjoute: " Qualification not added",
    qualificationNonMSA: "Qualification not updated",
    qualificationNonSupp: "Qualification not deleted",
    serviceNonSupp: "The service not deleted",
    erreur: "An error has occurred",
    selectionnerDates: "Please select a class and a period",
    dateDebutApresFin: "The start date must be before the end date",
    erreurRecuperationSeances: "Error retrieving sessions",
    erreurRecuperationAssiduite: "Error retrieving attendance data",
    erreurGenerationPdf: "Error generating PDF",
    depenseNonSupp: "Expense not deleted",
    buildingEchoue: "Failed to update building {name}",
    inscriEchoue: "Registration is failed",
    personnelNonAjoute: "Staff has not been added",
    enseignantNonAjoute: "Teacher has not been added",
    enseignantNonMSA: "Teacher has not been updated",
    anneeNonAjoute: "Year has not been added",
    anneeNonMSA: "Year has not been updated",
    punitionNonAjoute: "Punishment has not been added",
    punitionNonMSA: "Punishment has not been updated",
    serviceNonAjoute: "Service has not been added",
    serviceNonMSA: "Service has not been updated",
    depenseNonAjoute: "Expense has not been added",
    depenseNonMSA: "Expense has not been updated",
    fournisseurNonAjoute: "Provider has not been added",
    fournisseurNonMSA: "Provider has not been updated",
    fournisseurNonSupp: "Provider has not been deleted",
    activiteNonMSA: "L'activité ne peut être modifé, veuillez réessayer!",
    moduleNonAjoute: "Module has not been added",
    moduleNonMSA: "Module has not been updated",
    personnelNonMSA: "Staff has not been updated!",
    matiereNonAjoute: "Subject has not been added",
    subModuleNonAjoute: "Sub-module has not been added",
    subsubjectNonAjoute: "Sub-subject has not been added",
    matiereNonMSA: "Subject has not been updated",
    listeNonTrouve: "List of students not found!",
    inscrEchoue: "Registration is failed",
    activiteNonSupp: "Activity cannot be deleted",
    classeNonSupp: "Class cannot be deleted",
    classeIndis: "The class is unavailable ",
    salleIndis: "The room is unavailable ",
    enseignantIndis: "The teacher is unavailable",
    selectEnseignant: "Select a teacher",
    selectSeance: "Select a session",
    teacherConflictFuture:
      "Teacher {teacherName} is already scheduled for the same time and day of week in the future",
    classConflictFuture:
      "Class {className} is already scheduled for the same time and day of week in the future",
    teacherConflictUpdate:
      "Teacher {teacherName} is already taken at this time",
    classConflictUpdate: "Class {className} is already taken at this time",
    conflictDetails: "Conflict Details",
    conflictingTeacher: "Conflicting Teacher",
    conflictingClass: "Conflicting Class",
    conflictTime: "Time",
    conflictDate: "Date",
    conflictGroup: "Group",
    conflictWeek: "Week",
    conflictEndTime: "End Time",
    selectClasse: "Select a class ",
    sallePriseEntre:
      "The room {room} is taken by the class {name} between {start} and {end}",
    classPriseEntre: "The class {name} is taken between {start} and {end}",
    enseignantEnseigneClasse:
      "Teacher {fullname} teaches class {name} subject {subject} between {start} and {end}",
    conflictingSessionInfo:
      "Conflicts with: {subject} — {teacher} — {className} — {date} {start}-{end}{extra}",
    teacherGroupConflict:
      "Teacher conflict: Cannot schedule different groups at the same time",
    teacherWeekConflict:
      "Teacher conflict: Cannot schedule different weeks at the same time",
    teacherMixedConflict:
      "Teacher conflict: Cannot mix group and regular sessions at the same time",
    classroomGroupConflict:
      "Class conflict: Cannot schedule different groups at the same time",
    classroomWeekConflict:
      "Class conflict: Cannot schedule different weeks at the same time",
    classroomMixedConflict:
      "Class conflict: Cannot mix group and regular sessions at the same time",
    teacherGroupConflictDesc:
      "The teacher is already scheduled for a different group at this time. Teachers cannot be assigned to multiple groups simultaneously.",
    teacherWeekConflictDesc:
      "The teacher is already scheduled for a different week (A/B) at this time. Teachers cannot be assigned to multiple weeks simultaneously.",
    teacherMixedConflictDesc:
      "The teacher is already scheduled for a regular session at this time. Cannot mix group sessions with regular sessions.",
    classroomGroupConflictDesc:
      "The classroom is already scheduled for a different group at this time. Different groups can use the same classroom.",
    classroomWeekConflictDesc:
      "The classroom is already scheduled for a different week (A/B) at this time. Different weeks can use the same classroom.",
    classroomMixedConflictDesc:
      "The classroom is already scheduled for a regular session at this time. Cannot mix group sessions with regular sessions.",
    anneeNonSupp: "Year cannot be deleted",
    utilisateurNonAjoutDiff:
      "Cannot add user, please try with a different username!",
    conseillerPedagogiqueNonAjoute: "Pedagogical advisor not added",
    conseillerPedagogiqueNonMSA: "Pedagogical advisor has not been updated",
    conseillerPedagogiqueNonSupp: "Pedagogical advisor has not been removed",
    invalidFormat: "Invalid File Format",
    maxStudentsReached:
      "Maximum number of students reached. Please upgrade your subscription to add more students.",
    maxUsersReached:
      "Maximum number of users reached. Please upgrade your subscription to add more users.",
    productUpdate: "Failed to update the product. Please try again.",
    autorisationSupp: "You are not authorized to delete this command.",
    prodReactivate: "Failed to reactivate product",
    libraryAddDoc: "Document has not been added",
    libraryUpdateDoc: "Document has not been updated",
    libraryArchiveDoc: "Document has not been archived",
    libraryReactiveDoc: "Document has not been reactivated",
    failedToUpdateModuleOrder:
      "Failed to update module order. Please try again",
    alreadyAssigned: "Already assigned to",
    studentPhotoUploadError: "Failed to upload student photo",
    studentPhotoDeleteError: "Failed to delete student photo",
    fileUploadError: "Error uploading file. Please try again.",
    noDataToUpdate: "No data to update",
    updateSessions: "Error updating sessions",
    deleteRecurringSessions: "Error deleting recurring sessions",
    classNotFound: "Class not found!",
    studentListNotFound: "Student list not found",
    unexpectedError: "An unexpected error occurred.",
    groupUpdateFailed: "Error updating group",
    fetchingData: "Failed to fetch data. Please try again.",
    usernameExists: "Username is not available",
    activiteHasPayments:
      "It is not possible to change the school year, as the activity involves registrations within the current school year.",
    failedToLoadFinancialStats: "Failed to load financial statistics",
    failedToLoadAnalytics: "Failed to load {tab} analytics",
    errorLoadingSchoolYears: "Error loading school years",
  },
  warning: {
    verifieDonnees: "Check your data",
    connectionProblem: "A connection problem, please refresh the page!",
    selectModePaiement: "Select payment method",
    paiementNonEffectuer: "Payment not made",
    invalidMarks: "Please ensure your marks fall within the range of 0 to 20",
    notCorrectMarks:
      "Please ensure that your marks have been entered correctly",
    missedSubsubjects:
      "It appears that not all of ({name})'s marks have been completed. Please fill in any missing marks.",
  },
  stats: {
    userStats: "Users Stats",
    connectedStats: "Connected Users",
    connects: "Connections",
    connect: "Connection",
    disconnect: "Disconnection",
    seen: " seen",
    published: " published",
    mainStats: "Number of users connected by date",
    nb_connections: "Number of connections",
    connection_duration: "Connection duration",
    mainStatSelected: "Connection duration (hours) for {name} by date",
    secondaryStatsteacher: "Publication of courses/homeworks per day",
    secondaryStatsparent: "Consultation of courses/homeworks per day",
    secondaryStatSelectedteacher:
      "Course/homework publication by {name} per day",
    secondaryStatSelectedparent:
      "Consultation of courses/homeworks by {name} per day",
    detailedStats: "Connection details",
    detailedStatSelected: "Connection details for {name}",
    lastConnection: "Last connection",
    duration: "Connection duration",
    neverLoggedIn: "Never logged in",
    hasLoggedIn: "Has logged in",
    noConnectionHistory: "No connection history",
    fullName: "Full name",
    childName: "Child name",
  },
  bulletinBuilder: {
    contradictoryWith: "This option is contradictory with {option}",
    subjectsOptions: "Subjects/Sub-subjects Options",
    modulesOptions: "Modules/Sub-modules Options",
    otherOptions: "Other Options",
    hideSubjectMark: "Hide subject/sub-subject marks",
    hideModuleMark: "Hide module/sub-module marks",
    additionalImages: "Additional Images",
    customGovLogo: "Customize Ministry logo",
    showSubmodule: "Show submodule name",
    showSubmoduleMoy: "Show submodule Average",
    noStampFound: "No stamp found",
    errorPrintingBulletin: "An error occurred while printing the bulletin",
    errorGettingBulletinData:
      "An error occurred while getting the bulletin data",
    selectStudentFirst: "Please select a student first",
    scaleImagesTooltip:
      "This option allows you to scale images in the bulletin, use it with caution.",
    scaleImages: "Scale Images",
    hideSubModuleMark: "Hide the average of the submodules",
    certifUsePersonalizedMoy: "Certif with personalized Average",
    certif: "certificate",
    adminAppreciation: "Admin Appreciation",
    pedaLike: "Rounding rectangles",
    onlyForForceOnePage: "Useful for force one page or stretch to full page",
    textuelle: "Text Elements",
    images: "Images",
    couleurs: "Colors",
    taillesPolice: "Font Sizes",
    optionsAvancees: "Advanced Options",
    enTete: "Header",
    corps: "Body",
    cote: "Side",
    espacement: "Spacing",
    arrierePlanQR: "Background and QR",
    schoolName: "School Name",
    schoolarYear: "School Year",
    className: "Class Name",
    studentName: "Student Name",
    birthDate: "Birth Date",
    nbInscription: "Registration Number",
    uniqueIden: "Unique ID",
    schoolLogo: "School Logo",
    studentImage: "Student Photo",
    govLogo: "Ministry Logo",
    subsubjectMark: "Sub-subject Mark",
    subjectMark: "Subject Mark",
    moduleMark: "Module Mark",
    appreciation: "Appreciation",
    minPerClass: "Minimum per Class",
    maxPerClass: "Maximum per Class",
    normal: "General Average",
    peda: "Pedagogical Average",
    personalized: "Personalized Average",
    afficherNomEcole: "Show School Name",
    afficherAnneeScolaire: "Show School Year",
    afficherNomClasse: "Show Class Name",
    afficherTextMinistere: "Show Ministry Text",
    afficherNomEleve: "Show Student Name",
    afficherDateNaissance: "Show Birth Date",
    afficherNbInscription: "Show Registration Number",
    afficherIdentifiantUnique: "Show Unique ID",
    enteteTrimestre: "Term Header",
    afficherLogoEcole: "Show School Logo",
    afficherImageEleve: "Show Student Photo",
    afficherLogoMinistere: "Show Ministry Logo",
    personnaliserCouleurs: "Customize Colors",
    paletteCouleurs: "Color Palette",
    noteSousMatiere: "Sub-subject Mark",
    noteMatiere: "Subject Mark",
    noteModule: "Module Mark",
    minParClasse: "Minimum per Class",
    maxParClasse: "Maximum per Class",
    fusionnerSousMatieres: "Merge Sub-subjects",
    masquerMatieres: "Hide Subjects",
    masquerMinParMatiere: "Hide Minimum per Subject",
    masquerMaxParMatiere: "Hide Maximum per Subject",
    pasEncoreDisponible: "This feature is not yet available",
    forcerUnePage: "Force One Page",
    etirerPageEntiere: "Stretch Full Page",
    slowingFactor: "This option may slowdown PDF generation",
    margeGauche: "Left Margin",
    trimersterLineMargin: "Header margin",
    margeInferieure: "Bottom Margin",
    ajouterQRCode: "Add QR Code",
    ajouterArrierePlan: "Add Background",
    cliquezGlisser: "Click or drag and drop a file",
    supportImageUnique: "Supports images only",
    apercuBulletin: "Report Card Preview",
    selectionnerEleve: "Select Student",
    selectionnerTemplate: "Select Template",
    actualiser: "Refresh",
    selectionnerEleveDabord: "Please select a student first",
    visualiserBulletin: "View Report Card",
    configurer: "Configure",
    titre: "Title",
    valeur: "Value",
    position: "Position",
    centre: "Center",
    gauche: "Left",
    droit: "Right",
    bas: "Bottom",
    ordre: "Order",
    changerPositions: "Change Positions",
    optionsAffichage: "Display Options",
    afficherMinimum: "Show Minimum",
    afficherMaximum: "Show Maximum",
    afficherRang: "Show Rank",
    recommandeActiver:
      "It is recommended to activate only 2 out of 3 averages at the maximum.",
    couleurMoyenne: "Average Color",
    couleurRang: "Rank Color",
    couleurMin: "Minimum Color",
    couleurMax: "Maximum Color",
    legende: "Legend",
    libelle: "Label",
    coefficientMoyenne: "Average Coefficient",
    coefficientMoyennePedagogique: "Pedagogical Average Coefficient",
    sensitiveOption: "These options are sensitive, use with caution",
    modifierCouleurs: "Modify Colors",
    couleurPrincipale: "Main Color",
    enteteTrimestreTitres: "Term Header and Titles",
    bordureCouleurPrincipale: "Main Color Border",
    couleurSecondaire: "Secondary Color",
    titresMoyennes: "Average Titles",
    bordureCouleurSecondaire: "Secondary Color Border",
    couleurTertiaire: "Tertiary Color",
    arrierePlanMinMaxRang: "Min/Max/Rank Background",
    bordureCouleurTertiaire: "Tertiary Color Border",
    configurerPolice: "Configure Font",
    taille: "Size",
    couleur: "Color",
    font: "Font",
    lineReturn: "Line Return after the title",
    nonDisponiblePourEnTeteBas: "Not available for bottom headers",
    veuillezVerifierChamps: "Please check the fields",
    afficherMoyenne: "Show average",
    afficherMoyennePedagogique: "Show Pedagogical Average",
    afficherMoyennePersonnalise: "Show Personalized Average",
    afficherCertif: "Show certificate",
    afficherCache: "Show stamp",
    afficherDate: "Show date",
    selectFont: "Select a font",
    positionX: "Position X",
    parametresEnregistres: "Settings saved",
    parametresNonEnregistres: "Settings not saved",
    checkInputs: "Please check your inputs",
    positionUsedBy: "This position is used by",
    restaureParametres: "Restored to default settings",
    modeleSelectionne: "Template selected",
    arabicAndFrench: "Arabic and French",
    arabicOnly: "Arabic only",
    selectionnerElevePourVisualiser: "Select a student to view the bulletin",
    parametresEnregistresAvecSucces: "Settings saved successfully",
  },
  teacherGradePermissions: {
    title: "Teacher Grade Permissions",
    subTitle: "control if teachers can edit student grades after submission",
    gradeEditingEnabled: "Grade editing is enabled",
    gradeEditingDisabled: "Grade editing is disabled",
    selectTeachers: "Select teachers",
    allTeachers: "All teachers",
    specificTeachers: "Specific teachers",
    permissionSaved: "Grade permissions saved successfully",
    chooseTrimester: "Choose Term",
    gradeEditing: "Grade Editing",
    teacherAccessMode: "Give access to",
    canEdit: "Can Edit Grades",
    searchTeachers: "Search by teacher's name",
    filterAccess: "Filter by teacher access",
    withAccess: "Teachers with Access",
    withoutAccess: "Teachers without Access",
    selectTeachersError:
      "Please select at least one teacher when 'Specific Teachers' mode is enabled.",
  },
  aiFeedback: {
    title: "Smart Report",
    lastUpdated: "Last updated",
    initiatedMessage: "AI Analysis in Progress",
    initiatedDescription:
      "We are analyzing the student's performance. This may take a few moments.",
    summary: "Performance Summary",
    strengths: "Key Strengths",
    weaknesses: "Areas for Improvement",
    recommendations: "Recommendations",
    generalAppreciation: "General Appreciation",
    noFeedback: "No report available",
    generateReport: "Generate a report with AI",
    information: "Report details",
    generatedByAI: "Generated by AI",
    generatedAt: "Generated at",
    pdfGenerationError: "Error generating the report",
    pdfGeneratedSuccessfully: "Report generated successfully",
  },
  invoice: {
    addressedTo: " addressed to",
    editAddressedTo: "Edit addressed to",
    type: "Type",
    selectType: "Select type",
    particular: "Individual",
    entreprise: "Company",
    MF: "MF",
    representative: "Representative",
    enterMF: "Enter MF",
    selectRepresentative: "Select representative",
    father: "Father",
    mother: "Mother",
    other: "Other",
    addressedToName: "Name",
    enterName: "Enter name",
    typeRequired: "Type is required",
    nameRequired: "Name is required",
    representativeRequired: "Representative is required",
    MFRequired: "MF is required",
    selectAddressedTo: "Select addressed to",
    loadingParentsInfo: "Loading parent information...",
    selectParent: "Select a parent",
    multipleParentsFound: "Multiple parents found",
    parentFound: "Parent found",
    selectParentForDocument: "Please select the parent for document addressing",
    documentAddressedTo: "Document addressed to",
    noParentFound: "No parent found",
    fatherLabel: "Father",
    motherLabel: "Mother",
    parentMissingInfo: "Parent (missing information)",
    errorLoadingParents: "Error loading parents",
    facture: "Invoice",
    factureAvoir: "Invoice - Credit Note",
    recu: "Receipt",
    recuAvoir: "Receipt - Credit Note",
    nomPrenomEleve: "Name and Surname (student)",
    designation: "Designation",
    frais: "Fees",
    quantite: "Quantity",
    prixUnitaireHT: "Unit Price HT",
    montantHT: "Amount HT",
    montantTTC: "Amount TTC",
    qte: "Qty",
    prixUnitaire: "Unit price",
    total: "Total",
    totalHTBrut: "Total HT Gross",
    remise: "Discount",
    totalHT: "Total HT",
    totalTVA: "Total VAT",
    timbre: "Stamp",
    retenueALaSource: "Withholding tax",
    netAPayer: "NET TO PAY",
    reste: "Remaining",
    adresseeA: "Addressed to:",
    cachetSignature: "Stamp and signature",
    arreteePresenteFacture: "This invoice is stopped at the sum of:",
    dinarsEt: "dinars and",
    millimes: "millimes",
    ecolePrimairePrivee: "Private primary school",
    page: "Page",
    mf: "MF",
    tel: "Tel",
    mail: "Mail",
    numeroLabel: "Number:",
    dateLabel: "Date:",
    avanceLabel: " ( advance )",
    signature: "Signature",
    paymentMethods: "Payment methods",
    tuitionSummary: "Tuition payment summary",
    activitySummary: "Activity payment summary",
    summaryTotalToPay: "Total to pay",
    summaryDebitPaid: "Debit – Paid",
    summaryCreditUnpaid: "Credit – Unpaid",
    summaryTotalPaid: "Total paid",
    summaryTotalUnpaid: "Total unpaid",
    summaryPartial: "partial",
    chequeDetail: "Cheque",
    transactionCode: "Transaction code",
    pmNumber: "No.",
    pmReference: "Ref.",
    pmHolder: "Holder",
    pmBank: "Bank",
    pmRib: "RIB",
    pmDueDate: "Due date",
    pmDate: "Date",
    baseReduction: "Base discount",
    baseReductionShort: "Disc.",
    baseReductionTotal: "Total base discounts",
    schoolCopy: "School copy",
  },
  promotion: {
    button: "Automatic promotion",
    title: "Automatic student promotion",
    subtitle: "Move students to the next school year according to their level.",
    back: "Back",
    fromYear: "Source year",
    toYear: "Target year",
    noNextYearShort: "No next year",
    noNextYearTitle: "No next school year",
    noNextYearDesc: "Create the next school year first to run the promotion.",
    missingTitle: "Missing virtual classrooms",
    missingDesc:
      "Create the following levels (affectation classrooms) for the target year before running the promotion:",
    doneTitle: "Promotion completed",
    promoted: "promoted",
    kept: "kept (repeaters)",
    archived: "archived",
    skipped: "skipped (already placed)",
    noStudents: "No students to promote.",
    toPromote: "To promote",
    toKeep: "To keep",
    toArchive: "To archive",
    students: "students",
    endOfCycle: "End of cycle",
    keptShort: "kept",
    archivedShort: "archived",
    terminalHint:
      "These students will be archived. Check the repeaters to keep in the new school year.",
    terminalHintNoKeep:
      "These students will be archived (no same-level affectation classroom to keep them).",
    alreadyPlaced: "already placed",
    confirmText: "Confirm moving students to the next year?",
    confirmOk: "Confirm",
    execute: "Run promotion",
    notReady: "Fix the prerequisites before running the promotion.",
  },
  inscriptionStats: {
    tabNormal: "Classes",
    tabAffectation: "Affectations",
    tabIndicators: "Indicators",
    total: "Total students",
    enrolled: "Enrolled students",
    affected: "Affected students",
    unplaced: "Unplaced students",
    repartition: "Student distribution",
    effectifParClasse: "Students per class",
    parNiveau: "Students per level",
    bandAffectation: "Affectation (level)",
    bandNormal: "Classes",
    eleves: "students",
    moyenne: "Average",
    imbalance: "Class size imbalance",
    imbalanceTag: "Imbalanced",
    imbalanceHint:
      "A level is flagged when the gap between the fullest and emptiest class is large. Red = fullest class, orange = emptiest.",
    aucuneDonnee: "No data available",
    loadError: "Could not load indicators",
  },
  errorCode: {
    LEVEL_REQUIRED_FIRST:
      "This level must be created in the Levels tab before adding a classroom.",
    LEVEL_ALREADY_EXISTS: "This level already exists for this school year.",
    LEVEL_HAS_PAYMENTS:
      "This level cannot be deleted because payments are linked to it.",
    LEVEL_HAS_STUDENTS:
      "This level cannot be deleted because students are still assigned to it.",
    EXACTLY_ONE_OWNER_REQUIRED:
      "There must be exactly one owner for the cash register.",
    AT_LEAST_ONE_OWNER_REQUIRED:
      "The cash register must have at least one owner.",
    DUPLICATE_CAISSE_USER:
      "A user can only be listed once on a cash register.",
    CAISSE_REFERENCE_ALREADY_EXISTS:
      "A cash register already uses this reference.",
    PRINCIPAL_CAISSE_ALREADY_EXISTS:
      "A principal cash register already exists. Only one is allowed.",
    CAISSE_SELECTION_REQUIRED:
      "You have access to several cash registers, pick the one to use.",
    NOT_OWNER_OF_CAISSE:
      "You cannot perform this payment because you are not the owner of any cash register.",
    CAISSE_NOT_PERMITTED:
      "Cash register or bank account not found, or you are not allowed to pay from it.",
    INSUFFICIENT_BALANCE: "Insufficient balance",
    //config bulletin collége errors
    SUBJECT_REQUIRED: "Subject is required",
    SUBJECT_ALREADY_EXISTS: "This subject already exists in the config",
    CONFIG_NOT_FOUND: "Config not found",
    SUBJECT_NOT_FOUND: "Subject not found",
    MISSING_REQUIRED_FIELDS: "Missing required fields",
    NO_GRADES_FOR_TRIMESTER:
      "No grades are recorded for this student in the selected trimester. The report cannot be generated.",
    CONFIG_DELETE_FAILED: "Failed to delete config",
    CONFIG_CLONE_FAILED: "Failed to clone config",
    CONFIG_UPDATE_ORDERS_FAILED: "Failed to update config orders",
    SUBJECT_ORDER_UPDATE_FAILED: "Failed to update subject order",
    DUPLICATE_CONFIG:
      "A config already exists for this grade, term, and school year combination",
    SUBJECT_ADD_FAILED: "Failed to add subject",
    SUBJECT_UPDATE_FAILED: "Failed to update subject",
    SUBJECT_DELETE_FAILED: "Failed to delete subject",
    SUBJECTS_QUERY_FAILED: "Failed to get subjects",
    CONFIG_QUERY_FAILED: "Failed to get config",
    CONFIG_SAVE_FAILED: "Failed to save config",
    INVALID_CONFIG_OPTIONS: "Invalid config options",
    PACK_PERMISSION_ERROR: "You don't have permission to perform this action",
    NO_AUTO_APPRECIATION:
      "No automatic appreciation rules to clone for this subject and school year.",
    AUTO_APPRECIATION_MISSING_TEACHER_ACCESS:
      "Cannot apply automatic appreciation for module {moduleName}. Missing teacher access for classrooms: {classrooms}.",
    AUTO_APPRECIATION_NO_TEACHER_SUBJECT_ACCESS:
      "Automatic appreciation could not be applied because no teacher is assigned to this subject in some classrooms. Please update teacher subject access and try again.",
    CLUB_ACTIVITY_REQUIRED:
      "Please select an activity or enter a custom club name",
    CLUB_POST_NOT_FOUND: "Activity club post not found",
    CLUB_JOIN_NOT_FOUND: "Join request not found",
    CLUB_STUDENT_NOT_FOUND: "Student not found",
    CLUB_CLASSROOM_NOT_FOUND: "Classroom not found",
    CLUB_REGISTRATION_NOT_STARTED: "Registration has not started yet",
    CLUB_REGISTRATION_CLOSED: "Registration is closed",
    CLUB_NO_PLACES_LEFT: "No places left",
    CLUB_INVALID_STUDENT: "Invalid student",
    CLUB_ALREADY_REGISTERED: "Already registered",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "School year header is missing",
    ACTIVITY_GROUP_ACTIVITY_ID_REQUIRED: "Activity is required",
    ACTIVITY_GROUP_ID_REQUIRED: "Group is required",
    ACTIVITY_GROUP_INVALID_ID: "Invalid group",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "Activity not found",
    ACTIVITY_GROUP_NOT_FOUND: "Activity group not found",
    ACTIVITY_GROUP_NAME_EXISTS: "A group with this name already exists",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "Activity enrollment not found",
    ACTIVITY_GROUP_LIST_FAILED: "Could not load activity groups",
    ACTIVITY_GROUP_CREATE_FAILED: "Could not create the group",
    ACTIVITY_GROUP_RENAME_FAILED: "Could not rename the group",
    ACTIVITY_GROUP_DELETE_FAILED: "Could not delete the group",
    ACTIVITY_GROUP_ASSIGN_FAILED: "Could not assign the student to the group",
    ACTIVITY_GROUP_UNASSIGN_FAILED: "Could not remove the student from the group",
    CAISSE_INSUFFICIENT_BALANCE:
      "The selected cash register does not have enough total balance for this payment.",
    CAISSE_INSUFFICIENT_MODE_BALANCE:
      "The selected cash register does not have enough funds allocated to this payment method (cash, cheques, transfers, etc.).",
    CAISSE_NOT_FOUND: "Caisse not found",
    INVOICE_NOT_FOUND: "Invoice not found, please check your value",
    AMOUNT_EXCEEDS_INVOICE_TOTAL: "The amount exceeds the invoice total",
    AVOIR_DUPLICATE_DEPENSE:
      "A credit note already exists for this invoice. Only one credit note per invoice is allowed.",
    AVOIR_INVOICE_NOT_FULLY_PAID:
      "A credit note can only be created for an invoice that is fully paid.",
    PAYMENT_NOT_FOUND: "Payment not found, please check your value",
    PAYMENT_ID_REQUIRED: "Payment ID is required",
    DUPLICATE_PAYMENT_MONTH:
      "This employee has already been paid for this month. Please select another month or another employee.",
    ALREADY_TRANSFERRED:
      "This invoice is already transferred, it cannot be cancelled",
    NOT_AUTHORIZED_TO_CANCEL:
      "You are not authorized to cancel this invoice, only the owner of the principal cash register can cancel transferred payments",
    ALREADY_CANCELLED: "This invoice is already cancelled",
    VALIDATED_CHEQUES_EXIST:
      "Cannot cancel invoice: validated cheques/traites/virements exist",
    BORDEREAU_VALIDATED_CHEQUES_EXIST:
      "Cannot delete a bordereau containing validated cheques",
    FACTURE_ONLY_AVOIR:
      "Invoices can only be cancelled with type 'Credit note'",
    CHEQUE_TRAITE_ALREADY_REPLACED_OR_CANCELLED:
      "The cheque/traite is already replaced or cancelled",
    CHEQUE_TRAITE_ALREADY_VALIDATED: "The cheque/traite is already validated",
    DUPLICATE_CHEQUES: "Some cheques already exist !",
    DUPLICATE_CHEQUE_OR_TRAITE_NUMBER:
      "This cheque or draft number has already been used, or it appears more than once in this payment.",
    DUPLICATE_PROVIDER_INVOICE_NUMBER:
      "This invoice already exists; please edit the existing invoice",
    DUPLICATE_INPUT_CHEQUES: "Some cheques are duplicated in the input data",
    TRANCHES_ALREADY_PAID: "The student has already paid the specified terms",
    MONTHS_ALREADY_PAID: "The student has already paid the specified months",
    INSCRIPTION_ALREADY_PAID:
      "The student has already paid the specified admission",
    DUP_CIN: "Teacher with this CIN already exists !",
    DUP_EMAIL: "Teacher with this email already exists !",
    DB_NOT_FOUND: "School not found.",
    CREATE_TEACHER_FAILED: "impossible to add the teacher, please try again !",
    UPDATE_EMPLOYEE_FAILED:
      "impossible to update the employee, please try again !",
    VALIDATION_ERROR: "Some information is incorrect, please check your input.",
    TEACHER_INVALID_PHONE: "Phone number is invalid. Use the international format, e.g. +21620123456.",
    TEACHER_INVALID_BIRTH_DATE: "Birth date is invalid. Pick a valid date (DD/MM/YYYY) or leave it empty.",
    TEACHER_INVALID_CIN_CREATED_AT: "CIN issue date is invalid. Pick a valid date (DD/MM/YYYY) or leave it empty.",
    TEACHER_INVALID_INTERVIEW_DATE: "Interview date is invalid. Pick a valid date (DD/MM/YYYY) or leave it empty.",
    TEACHER_INVALID_START_DATE: "Start date is invalid. Pick a valid date (DD/MM/YYYY) or leave it empty.",
    TEACHER_INVALID_END_DATE: "End date is invalid. Pick a valid date (DD/MM/YYYY) or leave it empty.",
    TEACHER_INVALID_BANK_BRANCH: "Bank branch is invalid. Use letters, spaces, hyphens and parentheses only.",
    TEACHER_INVALID_EXPECTED_HOURS: "Expected hours per day is invalid. Enter a number between 0 and 24.",
    TEACHER_CIN_DUPLICATE: "CIN already belongs to another employee. Enter a different CIN or leave it empty.",
    AUTHENTICATION_ERROR: "Login failed, please check your credentials.",
    AUTHORIZATION_ERROR: "Unauthorized access.",
    NOT_FOUND_ERROR: "The requested resource could not be found.",
    CONFLICT_ERROR: "This action conflicts with existing data.",
    DATABASE_ERROR: "A problem occurred, please try again.",
    EXTERNAL_SERVICE_ERROR:
      "An external service is temporarily unavailable, please try again later.",
    CREATE_EMPLOYEE_FAILED:
      "impossible to add the employee, please try again !",
    EMPLOYEE_DUP_CIN: "Employee with this CIN already exists !",
    ENCAISSEMENT_BANK_INCOMPATIBLE_METHOD:
      "A bank account cannot receive cash. Use cheque, traite, bank transfer, or TPE.",
    ENCAISSEMENT_NON_CASH_REQUIRES_BANK:
      "Cheque, traite, bank transfer, and TPE must be credited to a bank account.",
    OUTBOUND_PAYMENT_NOT_READY:
      "The disbursement must be validated in reconciliation before confirming receipt.",
    STORAGE_QUOTA_EXCEEDED:
      "Your school's storage quota does not allow this upload. Contact the sales team to obtain more quota, or free space by removing files.",
    UPLOAD_PRESIGN_FAILED: "Could not prepare upload. Please try again.",
    ACTIVITY_SCHEDULE_MISSING_SCHOOLARYEAR: "Select a school year.",
    ACTIVITY_SCHEDULE_INVALID_DATA: "Check the session information.",
    ACTIVITY_SCHEDULE_INVALID_ID: "The selected session is invalid.",
    ACTIVITY_SCHEDULE_INVALID_RECURRENCE:
      "The repetition period must create between 1 and 500 sessions.",
    ACTIVITY_SCHEDULE_ACTIVITY_NOT_FOUND: "The activity was not found.",
    ACTIVITY_SCHEDULE_TEACHER_NOT_FOUND: "The teacher was not found.",
    ACTIVITY_SCHEDULE_ROOM_NOT_FOUND: "The room was not found.",
    ACTIVITY_SCHEDULE_GROUP_NOT_FOUND:
      "The group does not belong to this activity.",
    ACTIVITY_SCHEDULE_NOT_FOUND: "The session was not found.",
    ACTIVITY_SCHEDULE_CONFLICT:
      "The teacher or room is already scheduled at this time.",
    ACTIVITY_SCHEDULE_CANCELED: "Restore the session before editing it.",
    ACTIVITY_SCHEDULE_LIST_FAILED: "Could not load activity sessions.",
    ACTIVITY_SCHEDULE_CREATE_FAILED: "Could not create the session.",
    ACTIVITY_SCHEDULE_UPDATE_FAILED: "Could not update the session.",
    ACTIVITY_SCHEDULE_CANCEL_FAILED: "Could not cancel the session.",
    ACTIVITY_SCHEDULE_RESTORE_FAILED: "Could not restore the session.",
    ACTIVITY_SCHEDULE_DELETE_FAILED: "Could not delete the session.",
    ACTIVITY_SCHEDULE_HAS_ATTENDANCE:
      "This session has attendance marks. Cancel it instead of deleting.",
    ACTIVITY_ATTENDANCE_MISSING_SCHOOLARYEAR:
      "A valid school year is required.",
    ACTIVITY_ATTENDANCE_INVALID_ID: "Invalid attendance id.",
    ACTIVITY_ATTENDANCE_INVALID_DATA: "Invalid attendance data.",
    ACTIVITY_ATTENDANCE_SESSION_NOT_FOUND: "Activity session not found.",
    ACTIVITY_ATTENDANCE_SESSION_CANCELED:
      "Cannot mark attendance on a canceled session.",
    ACTIVITY_ATTENDANCE_SESSION_FUTURE:
      "Cannot mark attendance on a future session.",
    ACTIVITY_ATTENDANCE_FORBIDDEN: "Not allowed to mark this session.",
    ACTIVITY_ATTENDANCE_YEAR_LOCKED:
      "Activity attendance is locked for this school year.",
    ACTIVITY_ATTENDANCE_VALIDATED_LOCKED:
      "This attendance was validated by the administration and is locked.",
    ACTIVITY_ATTENDANCE_NOT_VALIDATED:
      "This session's attendance is not validated by the administration yet.",
    ACTIVITY_ATTENDANCE_REOPEN_FAILED: "Could not reopen the session.",
    ACTIVITY_ATTENDANCE_YEAR_NOT_FOUND: "School year not found.",
    ACTIVITY_ATTENDANCE_YEAR_LOCK_FAILED:
      "Could not update teacher access for this school year.",
    ACTIVITY_ATTENDANCE_STUDENT_NOT_ON_ROSTER:
      "Student is not on this session roster.",
    ACTIVITY_ATTENDANCE_ALREADY_EXISTS:
      "Attendance already exists for this student.",
    ACTIVITY_ATTENDANCE_NOT_FOUND: "Attendance mark not found.",
    ACTIVITY_ATTENDANCE_ROSTER_FAILED: "Could not load the session roster.",
    ACTIVITY_ATTENDANCE_CREATE_FAILED: "Could not create attendance.",
    ACTIVITY_ATTENDANCE_UPDATE_FAILED: "Could not update attendance.",
    ACTIVITY_ATTENDANCE_DELETE_FAILED: "Could not delete attendance.",
    ACTIVITY_ATTENDANCE_SUMMARY_FAILED: "Could not build attendance summary.",
    ACTIVITY_ATTENDANCE_ACTIVITY_NOT_FOUND: "Activity not found.",
    ACTIVITY_ATTENDANCE_NOT_DAILY:
      "Attendance indication is only available for daily activities.",
    ACTIVITY_ATTENDANCE_PAYMENT_NOT_FOUND: "Activity enrollment not found.",
    ACTIVITY_ATTENDANCE_INDICATION_FAILED:
      "Could not load attendance indication.",
    ACTIVITY_ATTENDANCE_VALIDATE_FAILED:
      "Could not validate activity attendance.",
    ACTIVITY_ATTENDANCE_EMPTY_ROSTER:
      "No students on this session roster.",
    ACTIVITY_ATTENDANCE_ROSTER_INCOMPLETE:
      "Marks must cover the full session roster.",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "Select a school year.",
    ACTIVITY_GROUP_INVALID_ID: "The selected activity group is invalid.",
    ACTIVITY_GROUP_PAYMENT_INVALID_ID: "The selected enrollment is invalid.",
    ACTIVITY_GROUP_INVALID_DATA: "Check the activity group information.",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "The activity was not found.",
    ACTIVITY_GROUP_NOT_FOUND: "The activity group was not found.",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "The activity enrollment was not found.",
    ACTIVITY_GROUP_NAME_EXISTS:
      "An active group with this name already exists.",
    ACTIVITY_GROUP_LIST_FAILED: "Could not load activity groups.",
    ACTIVITY_GROUP_CREATE_FAILED: "Could not create the activity group.",
    ACTIVITY_GROUP_RENAME_FAILED: "Could not update the activity group.",
    ACTIVITY_GROUP_DELETE_FAILED: "Could not delete the activity group.",
    ACTIVITY_GROUP_ASSIGN_FAILED: "Could not assign the student to the group.",
    ACTIVITY_GROUP_UNASSIGN_FAILED:
      "Could not remove the student from the group.",
  },
  upload: {
    failedTitle: "Upload failed",
  },
  status: {
    VALIDATED: "Validated",
    REJECTED: "Rejected",
    PENDING: "Pending",
    NON_DEPOSE: "Not deposited",
    DEPOSE: "Deposited",
    TRAITE: "Treated",
    REPLACED: "Replaced by cash",
    CANCELLED: "Cancelled",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    active: "Active",
    cancelled: "Cancelled",
  },
  schedule: {
    weekA: "A",
    weekB: "B",
    unknownClass: "Unknown Class",
    unknown: "Unknown",
    teacher: "Teacher",
    classroom: "Class",
    session: "Session",
    scheduleNotFound: "Schedule not found",
    errorCreatingSession: "An error occurred while creating the session",
    addSessionFailed: "Failed to add session",
    timetableExceeded:
      "Session end time ({endTime}) exceeds timetable end time ({timetableEnd}) for {day}",
    time: "Time",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    group: "Group",
    week: "Week",
    sunday: "Sunday",
  },
  financialStats: {
    title: "Financial Statistics",
    subtitle: "Comprehensive financial insights and analytics for your school",
    refresh: "Refresh",
    startDate: "Start Date",
    endDate: "End Date",
    total: "Total",
    totalRevenue: "Total Revenue",
    revenueSubtitle: "Total income from all sources",
    totalExpenses: "Total Expenses",
    expensesSubtitle: "Total costs and expenditures",
    netProfit: "Net Profit",
    profitSubtitle: "Revenue minus expenses",
    profitMargin: "Profit Margin",
    marginSubtitle: "Profitability percentage",
    financialHealth: "Financial Health",
    health: {
      excellent: "Excellent",
      good: "Good",
      fair: "Fair",
      poor: "Poor",
      unknown: "Unknown",
    },
    healthDescription: {
      excellent: "Outstanding financial performance with strong profitability",
      good: "Good financial health with positive growth trends",
      fair: "Adequate financial performance with room for improvement",
      poor: "Financial performance needs immediate attention",
      unknown: "Unable to assess financial health",
    },
    totalInvoices: "Total Invoices",
    cancellationRate: "Cancellation Rate",
    monthlyTrend: "Monthly Trend",
    paymentMethods: "Payment Methods",
    revenueExpenseComparison: "Revenue vs Expenses",
    topPerformingMonths: "Top Performing Months",
    revenueAnalytics: "Revenue Analytics",
    expenseAnalytics: "Expense Analytics",
    studentAnalytics: "Student Analytics",
    caisseAnalytics: "Caisse Analytics",
    averageInvoiceValue: "Average Invoice Value",
    growthRate: "Growth Rate",
    dailyRevenue: "Daily Revenue",
    dailyRevenueTrend: "Daily Revenue Trend",
    revenueByType: "Revenue by Type",
    factures: "Invoices",
    receipts: "Receipts",
    paymentMethodsBreakdown: "Payment Methods Breakdown",
    paymentMethod: "Payment Method",
    amount: "Amount",
    percentage: "Percentage",
    cash: "Cash",
    check: "Check",
    card: "Card",
    transfer: "Transfer",
    wire: "Wire Transfer",
    employeeExpenses: "Employee Expenses",
    generalExpenses: "General Expenses",
    cancellations: "Cancellations",
    monthlyExpenseBreakdown: "Monthly Expense Breakdown",
    expenseDistribution: "Expense Distribution",
    expenseCategories: "Expense Categories",
    category: "Category",
    trend: "Trend",
    employees: "Employees",
    general: "General",
    totalStudents: "Total Students",
    averagePaymentPerStudent: "Average Payment per Student",
    topPayingStudents: "Top Paying Students",
    showAll: "Show All",
    showLess: "Show Less",
    rank: "Rank",
    student: "Student",
    totalPaid: "Total Paid",
    invoices: "Invoices",
    lastPayment: "Last Payment",
    actions: "Actions",
    viewDetails: "View Details",
    paymentMethodsDistribution: "Payment Methods Distribution",
    paymentFrequency: "Payment Frequency",
    singlePayment: "Single Payment",
    multiplePayments: "Multiple Payments",
    frequentPayers: "Frequent Payers",
    noData: "No data available",
    totalCaisses: "Total Caisses",
    averageRevenuePerCaisse: "Average Revenue per Caisse",
    caissePerformance: "Caisse Performance",
    caisse: "Caisse",
    performance: "Performance",
    revenueComparison: "Revenue Comparison",
    caisseDistribution: "Caisse Distribution",
    principal: "Principal",
    subcaisse: "Sub-caisse",
    bank: "Bank",
    excellent: "Excellent",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
    positivePerformance: "Positive",
    negativePerformance: "Negative",
    monthlyTrends: "Monthly Trends",
    revenueExpenseProfit: "Revenue, Expenses & Profit",
    financialOverview: "Financial Overview",
    revenueVsExpenses: "Revenue vs Expenses",
    revenue: "Revenue",
    expenses: "Expenses",
    profit: "Profit",
    tnd: "TND",
    inscrit: "Inscrit",
    nonInscrit: "Non inscrit",
    categories: "categories",
    revenueSourcesTitle: "Revenue sources",
    revenueSourcesSubtitle: "Tuition vs comp V3 depense inflows",
    revenueSource: {
      tuition: "Tuition / invoices",
      inverseEncaissement: "Inverse depense (cash-in)",
      avoirFournisseur: "Supplier credit note received",
    },
    depenseOutflowTitle: "Paid-out by payment mode",
    depenseOutflowSubtitle: "Cash actually disbursed (depense payments)",
    depenseByTypeTitle: "Paid depenses by expense type",
    depenseByTypeSubtitle: "Split by depense type (paid amounts)",
    moneyFlowTitle: "Cash movement (period)",
    moneyIn: "Inflows",
    moneyOut: "Outflows",
    netCashPosition: "Net (in − out)",
    tuitionShort: "Tuition",
    inverseShort: "Inverse",
    avoirShort: "Credit n.",
    depensePaidOut: "Paid depenses (module)",
    otherCategory: "Other",
  },
  error404: {
    pageInaccessible: "Page Inaccessible",
    subscriptionMessage:
      "Your current subscription does not support this feature.",
    upgradeMessage: "Upgrade now to enrich your experience!",
    returnButton: "Return",
  },
  reduction: {
    designation: "Designation",
    reduction: "Reduction",
    reductionTND: "Reduction (TND)",
    reductionKES: "Reduction (KES)",
    reductionPercent: "Reduction (%)",
    amountBeforeReduction: "Amount before reduction",
    amountAfterReduction: "Amount after reduction",
    actions: "Actions",
    amountInTND: "Amount in TND",
    amountInKES: "Amount in KES",
    percentage: "Percentage",
    selected: "selected",
  },
  payment: {
    selectFeesToPay: "Select fees to pay",
    showAll: "Show all",
    hideAll: "Hide all",
    payWithAdvance: "Pay with advance",
    withoutAdvance: "Without advance",
    enableAdvancePayment: "Enable advance payment",
    advanceAmountTND: "Advance amount (TND)",
    enterAmount: "Enter amount",
    advanceAmountExceedsTotal:
      "The advance amount entered is greater than the total amount of fees to pay. advance amount must be less than or equal to {maxAmount}",
    advanceAmountInsufficient:
      "The advance amount entered does not allow covering all fees. Please enter a higher advance amount.",
    tuition: "Tuition",
    activity: "Activity",
    feesToPay: "Fees to pay",
    remaining: "Remaining",
    advanceApplied: "Advance applied",
    remainingToPay: "Remaining to pay",
    partialPaymentRemaining: "Partial payment - remaining amount to pay",
    advanceInsufficientForFee:
      "The advance amount entered does not allow covering this fee. Please enter a higher advance amount.",
    paid: "Paid",
    deselectAll: "Deselect all",
    selectAll: "Select all",
    registration: "Registration",
    installment: "Installment",
    fees: "Fees",
    amount: "Amount",
  },
  activityPayment: {
    service: "Service",
    numberOfStudents: "Number of students",
    order: "Order",
    no: "No",
    allMonths: "All months",
    allClasses: "All classes",
    monthlyPayment: "Monthly payment",
    installmentPayment: "Installment payment",
    studentName: "Student name",
    classroom: "Class",
    parents: "Parents",
    parentPhones: "Parent phones",
    paymentMode: "Payment mode",
    monthly: "Monthly",
    byInstallment: "By installment",
    globalStatus: "Global status",
    paid: "Paid",
    unpaid: "Unpaid",
    noClassFound: "No class found",
    activityNotFound: "Activity not found!",
    noActivityRegistrationFound: "No activity registration found",
  },
  inscriptionActivites: {
    monthlyPayment: "Monthly payment",
    installmentPayment: "Installment payment",
    paymentMode: "Payment mode",
    monthly: "Monthly",
    byInstallment: "By installment",
    globalStatus: "Global status",
    paid: "Paid",
    unpaid: "Unpaid",
    noClassFound: "No class found",
    manageGroups: "Manage groups",
    manageGroupsTitle: "Groups — {activity}",
    addGroup: "Add",
    groupName: "Group name",
    renameGroup: "Rename",
    deleteGroup: "Delete",
    noGroupsYet: "No groups for this activity yet",
    confirmDeleteGroup: "Delete this group?",
    selectActivityFirst: "Select an activity first",
    selectActivityToManageGroups: "Select an activity to manage its groups",
    filterByGroup: "Filter by group",
    groupCreated: "Group created successfully",
    groupRenamed: "Group renamed successfully",
    groupDeleted: "Group deleted successfully",
    groupAssigned: "Student assigned to group successfully",
    groupUnassigned: "Student removed from group successfully",
    multipleRegistration: "Multiple registration",
    multipleRegistrationTitle: "Registration across multiple activities",
    multipleRegistrationStep1Title: "1. Activities and students",
    multipleRegistrationStep1Subtitle:
      "Select several activities of the same type (all Daily or all Monthly/Term) then the students to register",
    multipleRegistrationStep2Title: "2. Per-activity configuration",
    multipleRegistrationStep2Subtitle:
      "Configure the dates and payment mode of each activity separately",
    multipleRegistrationNoActivitiesSelected: "No activity selected",
  },
  emploiActivites: {
    title: "Activity schedule",
    addSession: "Add session",
    editSession: "Edit session",
    selectActivityHint: "Select an activity to manage its timetable",
    selectActivityEmpty: "Choose an activity to see sessions",
    filterByGroup: "Filter by group",
    wholeActivity: "Whole activity",
    day: "Day",
    time: "Time",
    duration: "Duration (min)",
    selectTeacher: "Select a teacher",
    selectRoom: "Select a room",
    dayRequired: "Day is required",
    timeRequired: "Time is required",
    durationRequired: "Duration is required",
    cancelSession: "Cancel session",
    confirmCancelSession: "Cancel this session?",
    restoreSession: "Restore session",
    confirmRestoreSession: "Restore this canceled session?",
    confirmDeleteSession: "Delete this session?",
    canceled: "Canceled",
    active: "Active",
    sessionCreated: "Session created",
    sessionUpdated: "Session updated",
    sessionCanceled: "Session canceled",
    sessionRestored: "Session restored",
    sessionDeleted: "Session deleted",
    repeat: "Repeat session",
    repeatHint: "Create multiple sessions between two dates",
    repeatFrequency: "Frequency",
    repeatDaily: "Daily",
    repeatWeekly: "Weekly",
    repeatMonthly: "Monthly",
    startDate: "Start date",
    endDate: "End date",
    dateRangeRequired: "Start and end dates are required",
    endBeforeStart: "End date must be after start date",
    frequencyRequired: "Choose a frequency",
    noOccurrences: "No sessions to create for this period",
    sessionsWillBeCreated: "{count} session(s) will be created",
    sessionsCreated: "{count} session(s) created",
  },
  activityAttendance: {
    title: "Activity attendance",
    sessionsTab: "Sessions",
    summaryTab: "Summary",
    period: "Period",
    quickPeriod: "Quick period",
    weekly: "This week",
    monthly: "This month",
    student: "Student",
    studentCount: "{nb} students",
    expected: "Expected",
    attended: "Attended",
    needDates: "Select a date range",
    pickActivity: "Select an activity to list sessions",
    sessionsHint:
      "Open a session to mark attendance. Nothing is saved until you click Validate. Skip Validate for holidays / days off.",
    noSessions: "No sessions for these filters",
    group: "Group",
    teacher: "Teacher",
    room: "Room",
    day: "Day",
    time: "Time",
    status: "Status",
    canceled: "Canceled",
    canceledHint: "This session is canceled",
    future: "Upcoming",
    futureHint: "You can only mark attendance on today or past sessions",
    adminValidated: "Validated by administration",
    pendingAdmin: "Validated by teacher",
    pendingAdminHint:
      "The teacher validated this attendance and can still edit it. Review it, then click Validate to lock it for the teacher.",
    teacherValidatedAt: "Teacher validation",
    teacherNotValidated: "Not validated by the teacher yet",
    notRecorded: "Not recorded",
    nothingRecordedYet:
      "Nothing recorded yet for this session. Set statuses (default Present), then click Validate. Skip Validate for holidays / days off.",
    validatedHint:
      "Validated by administration: locked for the teacher. You can still change marks and Validate again, or reopen it for the teacher.",
    reopen: "Reopen for teacher",
    reopenConfirm:
      "Allow the teacher to edit this session's attendance again? It locks again when the administration validates it.",
    reopenSuccess: "Session reopened for the teacher",
    reopened: "Reopened",
    reopenedHint:
      "Reopened: the teacher can edit this session until the administration validates it again.",
    yearLockedForTeachers:
      "This is not the current school year. Teachers cannot edit activity attendance for it.",
    yearUnlockedForTeachers:
      "This is not the current school year, but teachers are currently allowed to edit its activity attendance.",
    allowTeacherEdit: "Allow teachers to edit",
    yearLockUpdated: "Teacher access updated",
    validate: "Validate attendance",
    validateConfirm: "Save attendance for all students on this session?",
    validateSuccess: "Attendance validated successfully",
    openSheet: "Mark sheet",
    markTitle: "Mark attendance",
    emptyRoster: "No students enrolled for this session",
    groupRosterHint:
      "Only students assigned to group “{group}” are listed.",
    hint:
      "Only validated sessions count. Select an activity to see all enrolled students. Without it, only students who have a matching session in the period are listed (group sessions only count their group). Clear the class filter if it is set.",
    empty:
      "No students for these filters. Pick an activity, widen the dates, or clear the class filter.",
  },
  activityPaymentAttendance: {
    title: "Attendance for this period",
    subtitle:
      "Indication only — select payment days manually below. Counts validated sessions only (Present and Late = attended).",
    refresh: "Refresh",
    needDates: "Select a date range",
    missingIds: "Student or activity is missing",
    noSessions: "No scheduled sessions in this period",
    noSessionsHint:
      "The activity timetable has no sessions for this student in the selected dates.",
    present: "Present",
    retard: "Late",
    absence: "Absent",
    exclus: "Excluded",
    none: "None",
    totals:
      "{sessions} session(s) · Present {present} · Late {retard} · Absent {absence} · Excluded {exclus}",
  },
  emploiActivites: {
    title: "Activity schedule",
    addSession: "Add session",
    editSession: "Edit session",
    selectActivityHint: "Select an activity to manage its timetable",
    selectActivityEmpty: "Choose an activity to see sessions",
    filterByGroup: "Filter by group",
    wholeActivity: "Whole activity",
    day: "Day",
    time: "Time",
    duration: "Duration (min)",
    selectTeacher: "Select a teacher",
    selectRoom: "Select a room",
    dayRequired: "Day is required",
    timeRequired: "Time is required",
    durationRequired: "Duration is required",
    cancelSession: "Cancel session",
    confirmCancelSession: "Cancel this session?",
    restoreSession: "Restore session",
    confirmRestoreSession: "Restore this canceled session?",
    confirmDeleteSession: "Delete this session?",
    canceled: "Canceled",
    active: "Active",
    sessionCreated: "Session created",
    sessionUpdated: "Session updated",
    sessionCanceled: "Session canceled",
    sessionRestored: "Session restored",
    sessionDeleted: "Session deleted",
    repeat: "Repeat session",
    repeatHint: "Create multiple sessions between two dates",
    repeatFrequency: "Frequency",
    repeatDaily: "Daily",
    repeatWeekly: "Weekly",
    repeatMonthly: "Monthly",
    startDate: "Start date",
    endDate: "End date",
    dateRangeRequired: "Start and end dates are required",
    endBeforeStart: "End date must be after start date",
    frequencyRequired: "Choose a frequency",
    noOccurrences: "No sessions to create for this period",
    sessionsWillBeCreated: "{count} session(s) will be created",
    sessionsCreated: "{count} session(s) created",
  },
  activityMultiForm: {
    installmentFees: "Installment fees",
    installment: "Installment",
    selectedPaymentMode: "The selected payment mode is ",
    byInstallments: "by installments",
    monthly: "monthly",
    feesToPay: "Fees to pay",
    fees: "Fees",
    included: "Included",
  },
  studentCredentials: {
    deactivateOrActivateAccount: "Deactivate or activate student account",
    accountActivated: "Account activated, user can access the application.",
    accountDeactivated:
      "Account deactivated, user cannot access the application.",
    deactivate: "Deactivate",
    activate: "Activate",
    studentQrCode: "Student QR code",
    usernameNoWhitespace: "Username cannot contain whitespace",
    passwordConfirmationRequired: "Please input the password again",
    passwordMismatch: "Two inputs don't match!",
    statusChangeSuccess: "Change completed successfully",
  },

  college: {
    bulletin: {
      config: {
        title: "College Bulletin Configuration",
        description: "Configure subjects and mark types for college bulletins!",
        subjectOrderUpdated: "Subject order updated successfully",
        subjectAlreadyExists: "This subject already exists in the config",
        failedToUpdateSubjectOrder:
          "Failed to update subject order. Please try again",
        configClone: "Configuration cloned successfully",
        ajouterConfigCollege: "Add College Configuration",
        modifierConfigCollege: "Edit College Configuration",
        modifierConfigSubject: "Edit Subject Configuration",
        niveau: "Grade",
        order: "Order",
        markTypes: "Mark Types",
        configurerMarkType: "Configure Mark",
        aucuneMatiere: "No subjects",
        confirmDeleteWithMarks:
          "This subject contains mark(s) for {count} student(s). Are you sure you want to delete it?",
        from: "From",
        to: "To",
        niveaux: "Grades",
        trimestres: "Terms",
        anneeScolaire: "School Year",
        count: "Count",
        markType: {
          oral: "Oral",
          cont1: "Control 1",
          cont2: "Control 2",
          synth: "Synthesis",
          written: "Written",
          tp: "Practical Work",
        },
      },
    },
  },

  college: {
    bulletin: {
      config: {
        title: "College Bulletin Configuration",
        description: "Configure subjects and mark types for college bulletins!",
        subjectOrderUpdated: "Subject order updated successfully",
        subjectAlreadyExists: "This subject already exists in the config",
        failedToUpdateSubjectOrder:
          "Failed to update subject order. Please try again",
        configClone: "Configuration cloned successfully",
        ajouterConfigCollege: "Add College Configuration",
        modifierConfigCollege: "Edit College Configuration",
        modifierConfigSubject: "Edit Subject Configuration",
        niveau: "Grade",
        order: "Order",
        markTypes: "Mark Types",
        configurerMarkType: "Configure Mark",
        aucuneMatiere: "No subjects",
        confirmDeleteWithMarks:
          "This subject contains mark(s) for {count} student(s). Are you sure you want to delete it?",
        from: "From",
        to: "To",
        niveaux: "Grades",
        trimestres: "Terms",
        anneeScolaire: "School Year",
        count: "Count",
        markType: {
          oral: "Oral",
          cont1: "Control 1",
          cont2: "Control 2",
          synth: "Synthesis",
          written: "Written",
          tp: "Practical Work",
        },
      },
    },
  },
  footer: {
    copyright: "Copyright ©",
    allRightsReserved: "All Rights Reserved.",
    version: "Version:",
  },
  attestationInscription: {
    title: "Enrollment Certificate",
    iUndersigned: "I, the undersigned",
    directorMale: "the director",
    directorFemale: "the director",
    ofThe: "of the",
    certifiesThatStudent: "certifies that the student",
    bornOn: "born on",
    isEnrolledIn: "is enrolled in our institution for the school year",
    inClass: "in class",
    doneAt: "Done at",
    on: "on",
    signatureAndStamp: "Signature and Stamp",
  },
  ficheClasse: {
    nonDisponible: "Not available",
    anneeScolaireLabel: "School year",
    delegeRegionalEducation: "Regional Education Authority",
    date: "Date",
    listeEleves: "Students List",
    classe: "Class",
    garcon: "Boy",
    fille: "Girl",
    total: "Total",
    garcons: "Boys",
    filles: "Girls",
    numero: "Number",
    identifiantUnique: "Unique identifier",
    nomComplet: "Full name",
    dateNaissance: "Date of birth",
    group: "Group",
    sexe: "Sex",
    listeElevesPDF: "Student_list",
    formulaireParent: "Parent form",
    nomPrenom: "Full name",
    nomPrenomFr: "Full name in French",
    nomParent: "Parent's name",
    telephone: "Phone",
    pere: "Father",
    mere: "Mother",
    ficheParentPDF: "Parent_Form",
    parentSheetSelectAtLeastOneColumn:
      "Please select at least one column to print.",
    parentSheetSelectColumnsHint:
      "Choose the columns to include in the parent sheet. You can generate a full list or only the fields you need (e.g. email list, address list).",
    parentSheetSelectColumnsTitle: "Select columns to print",
  },
  attendanceHistoryPdf: {
    classe: "Class",
    period: "Period",
    num: "Num",
    studentName: "Student Name",
    page: "Page",
    legend: "Legend",
    present: "Present",
    absence: "Absence",
    retard: "Late",
    exclus: "Exclusion",
    history: "History",
  },
  conseilClass: {
    managerAndTeacher: "Director and teachers",
    options: "Options",
    allow: "Show",
    auto: "Automatic",
    useSchoolCode: "Use school code",
    repeatEachPage: "Repeat on each page",
    rect: "Border",
    orientation: "Orientation",
    landscape: "Landscape",
    portrait: "Portrait",
    govText: "Government text",
    schoolLogo: "School logo",
    schoolYear: "School year",
    govLog: "Government logo",
    stats: "Statistics",
    mainTitle: "Main title",
    secondaryText: "Secondary text",
    preParagraph: "Intro paragraph",
    table: "Admitted students table",
    tablePostParagraph: "Paragraph after admitted students table",
    postParagraph: "Post-table paragraph",
    number: "Number",
    fullName: "Full name",
    firstName: "First name",
    lastName: "Last name",
    birthDate: "Birth date",
    birthPlace: "Birth place",
    uniqueIden: "Unique ID",
    prevYears: "Previous years",
    trim1: "Term 1",
    trim2: "Term 2",
    trim3: "Term 3",
    moy: "Average",
    decision: "Decision",
    handicape: "Disability",
    exceptionalStats: "Exceptional pass table",
    filled: "Fill with students",
    specCount: "Number of empty rows",
    agePass: "Age pass table",
    fail: "Failed students table",
    govSpecific: "Regional block (last page)",
    manager: "Principal",
    teacher: "Teachers",
    templateName: "Template name",
    templateNamePlaceholder: "e.g. Class council PV grade 6",
    selectTemplate: "Saved template",
    builtinDefault: "default",
    pvMissingKeyBanner:
      "{count} student(s) without a corresponding decision (A/C/R)",
    pvMissingKeyHint:
      "These students will not appear in the PV tables. Fix board decision parametrage or assign a decision per student.",
    pvMissingKeyMore: "... and {count} more",
    settingsSaved: "Settings saved successfully",
    templateAssigned: "Template assigned to this level",
    checkInputs: "Please check your inputs",
    selectClassFirst: "Please select a class first",
    couldNotGetClassPv: "Could not load class PV data",
    cloneAlert:
      "Settings were duplicated. Refresh the page to see the full effect.",
    templateNameRequired: "Please enter a template name",
    templateNameAlreadyExists:
      "This template name already exists. Choose another name.",
    nameTemplateTitle: "Name the template",
    nameTemplatePrompt:
      "You are saving from the default template. Give it a unique name before saving for this level.",
    selectSourceTemplate: "Source template to duplicate",
    cloneSourceHint:
      "To duplicate another template, select it in settings, save, then open duplication.",
    cloneSaveTemplateFirst:
      "Save the selected template in settings before duplicating it.",
    unnamedTemplate: "Unnamed",
    selectCloneTargets: "Please select at least one target",
  },
  pickup: {
    title: "Pickup",
    enabled: "Enable parent pickup",
    radius: "Allowed radius (meters)",
    location: "Pickup location",
    locationHint:
      "Leave empty to use the school location defined in the school settings.",
    noBuildingLocation:
      "No school location is defined in the school settings. Enter the pickup location.",
    noLocation:
      "A location is required to enable pickup. Enter the pickup location or define the school location.",
    latLngTogether: "Latitude and longitude must be filled in together.",
    saved: "Pickup settings saved",
    waiting: "Waiting",
    history: "History",
    noWaiting: "No student is waiting",
    student: "Student",
    classe: "Class",
    parent: "Parent",
    requestedAt: "Requested at",
    expiresIn: "Expires in",
    status: "Status",
    statusPickedUp: "Picked up",
    statusExpired: "Expired (not validated)",
    validatedBy: "Validated by",
    validate: "Mark as picked up",
    confirmValidate: "Confirm that the student has left with the parent?",
    validated: "Student marked as picked up",
    level: "Level",
    sortOldest: "Arrival: oldest first",
    sortNewest: "Arrival: newest first",
    distance: "Distance from school",
    relation: {
      father: "Father",
      mother: "Mother",
      guardian: "Guardian",
    },
  },
};

export default {
  locale: "en-US",
  localeAntd,
  messages,
};
